import React, { Component, Fragment } from "react";
import {
  Card,
  CardBody,
  Col,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Button,
  Row,
} from "reactstrap";
import { change, reduxForm } from "redux-form";
import classnames from "classnames";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import BasicDataPatient from "./BasicDataPatient/BasicDataPatient";
import DefaultTabsBorderedTopBackground from "./Background/components/DefaultTabsBorderedTopBackground";
import SystemReview from "./SystemReview/SystemReview";
import PhysicalExam from "./PhysicalExam/PhysicalExam";
import AnalysisAndMedicalPlan from "./AnalysisAndMedicalPlan/AnalysisAndMedicalPlan";
import Diagnostic from "./Diagnostic/Diagnostic";
import MedicalOrders from "./MedicalOrders/MedicalOrders";
import MedicalProcedures from "./MedicalProcedures/MedicalProcedures";
import SourceDocuments from "./SourceDocuments/SourceDocuments";
import Notes from "./Notes/Notes";
import Ananmesis from "./Ananmesis/Anamesis";
import Modal from "@material-ui/core/Modal";
import { withStyles } from "@material-ui/core/styles";
import MuiAccordion from "@material-ui/core/Accordion";
import MuiAccordionSummary from "@material-ui/core/AccordionSummary";
import MuiAccordionDetails from "@material-ui/core/AccordionDetails";
import moment from "moment";
import history from "../../../../history";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import PatientInformation from "../../PatientInformation/PatientInformation";
import PatientBackground from "./PatientBackground/PatientBackground";
import SpeechTerapy from "./SpeechTerapy/SpeechTerapyForm";
import { getBase64FromFile } from "../../../Utils/FilesProcess";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import ModalMessage from "../../../../shared/components/Modal";
import { calculateAgeParse } from "../../../Utils/Patient";
import pdfFormula from "./../../ClinicEvent/components/PdfReports/PdfFormula";
import pdfProceduresAndFormula from "./../../ClinicEvent/components/PdfReports/PdfProceduresAndFormula";
import pdfProceduresFormat from "./../../ClinicEvent/components/PdfReports/PdfProceduresFormat";
import CriterialExclutionAndInclution from "./ClinicalStudio/CriterialExclutionAndInclution";
import InformedConsent from "./ClinicalStudio/InformedConsent";
import EventAdverse from "../../ClinicHistoryView/components/EventAdverse/EventAdverse";
import ProtocolDeviations from "./ClinicalStudio/ProtocolDeviations";
import { data } from "jquery";
import ActivityVisitsPatient from "./ClinicalStudio/ActivityVisitsPatient";
import "moment-timezone";
import MedicalOrdersFunctionalCom from "./MedicalOrders/MedicalOrdersFunctionalCom";
import MedicalIncapacity from "./MedicalIncapacity/MedicalIncapacity";
import Results from "./MedicalProcedures/Results/Results";
import { faArrowRotateLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const sections = [
  "patologicos",
  "quirurgicos",
  "farmacologicos",
  "ginecoobstétricos",
  "inmunización",
  "otros",
  "familiares",
];
const sectionMap = [
  "patologicos",
  "quirurgicos",
  "farmacologicos",
  "ginecoobstetricos",
  "inmunizaciones",
  "otros",
  "familiares",
];
const ailments = [
  [
    "Hipertensión",
    "Metabólicos",
    "Cardiacos",
    "Infecciosos",
    "Vasculares",
    "Alérgicos",
    "Cancer",
    "Transfusiones",
    "Autoinmunes",
    "Traumático",
    "Diabetes",
    "Hiperlipidemia",
    "Enf. Coronaria",
    "Enf. Vascular Periferica",
    "Hepatitis",
  ],
  //["Hipertensión", "Diabetes", "Hiperlipidemia", "Enf. Coronaria", "Enf. Vascular Periferica", "Hepatitis", "Cancer", "Transfusiones"],
  ["Quirurgico"],
  ["Farmacologico"],
  ["Ginecoobstétricos"],
  ["Inmunizaciones"],
  [
    "Alergías",
    "Hospitalario",
    "Traumatico",
    "Enfermedades de transmisión sexual",
    "Psiquiatricos",
  ],
  [
    "Enfermedad Coronaria",
    "Diabetes",
    "Cancer",
    "Muerte Subita(H<55/M<60)",
    "Hipertensión",
  ],
];

const ailmentsSystemReview = [
  "Síntomas Generales",
  "Respiratorios",
  "Cardiovascular",
  "Gastrointestinal",
  "Genitourinario",
  "Osteomuscular",
  "Dermatologico",
  "Endocrino",
  "Neurologico",
];

const Accordion = withStyles({
  root: {
    border: "1px solid rgba(0, 0, 0, .125)",
    boxShadow: "none",
    "&:not(:last-child)": {
      borderBottom: 0,
    },
    "&:before": {
      display: "none",
    },
    "&$expanded": {
      margin: "auto",
    },
  },
  expanded: {},
})(MuiAccordion);

const AccordionSummary = withStyles({
  root: {
    backgroundColor: "rgba(0, 0, 0, .03)",
    borderBottom: "1px solid rgba(0, 0, 0, .125)",
    marginBottom: -1,
    minHeight: 56,
    "&$expanded": {
      minHeight: 56,
    },
  },
  content: {
    "&$expanded": {
      margin: "12px 0",
    },
  },
  expanded: {},
})(MuiAccordionSummary);

const AccordionDetails = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiAccordionDetails);

class DefaultTabsBorderedTop extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
  };

  constructor() {
    super();
    this.existMedicalProcedures = false;
    this.state = {
      btnActive: true,
      activeTab: "1",
      loadTab: false,
      profile: sessionStorage.getItem("perfil"),
      anamesis: {
        cause: "Enfermedad general",
        reasonForConsultation: "",
        currentIllness: "",
        candidate: false,
        study: null,
        acronym: null,
        participate: false,
      },
      sectionAilment: {
        ailments: (() => {
          return sections.map((section, index) => {
            var sectionNew = { [section]: [] };
            ailments[index].map((ailment, i) => {
              sectionNew[section].push({
                ailment: ailment,
                value: "No",
                commentary: "",
              });
            });
            return sectionNew;
          });
        })(),
        observations: "",
        commentary: (() => {
          return new Array(sections.length).fill(null);
        })(),
        pathologicals: {
          hipertension: {
            value: "No",
            comentario: "",
          },
          metabolicos: {
            value: "No",
            comentario: "",
          },
          cardiacos: {
            value: "No",
            comentario: "",
          },
          infecciosos: {
            value: "No",
            comentario: "",
          },
          vasculares: {
            value: "No",
            comentario: "",
          },
          alergicos: {
            value: "No",
            comentario: "",
          },
          cancer: {
            value: "No",
            comentario: "",
          },
          transfusiones: {
            value: "No",
            comentario: "",
          },
          autoinmunes: {
            value: "No",
            comentario: "",
          },
          traumatico: {
            value: "No",
            comentario: "",
          },
          diabetes: {
            value: "No",
            comentario: "",
          },
          hiperlipidemia: {
            value: "No",
            comentario: "",
          },
          enfermedad_coronaria: {
            value: "No",
            comentario: "",
          },
          enf_vascular_per: {
            value: "No",
            comentario: "",
          },
          hepatitis: {
            value: "No",
            comentario: "",
          },
          observacion: "",
        },
        surgicals: {
          quirurjico: {
            value: "No",
            comentario: "",
          },
          observacion: "",
        },
        pharmacological: {
          farmacologico: {
            value: "No",
            comentario: "",
            table: [],
          },
          observacion: "",
        },
        gynecologists: {
          ginecoobstetrico: {
            value: "No",
            comentario: "",
          },
          observacion: "",
        },
        habits: {
          packegesPerYear: "",
          cigarretsPerDay: "",
          yearStart: "",
          yearEnd: "",
          years: "",
          firewood: "",
          smoke: "",
          comsuption: "",
          substaces: [],
          substace: "",
          frecuency: "",
          alcohol: "No",
          alcoholLastYear: "",
          frecuencyAlcohol: "",
          physicalActivity: "No",
          frecuencyPhysicalActivity: "",
          activities: [],
          comsuption: "No",
          nutricional: "",
          timePhysicalActivity: "",
        },
        family: {
          cancer: {
            value: "No",
            comentario: "",
          },
          diabetes: {
            value: "No",
            comentario: "",
          },
          hipertension: {
            value: "No",
            comentario: "",
          },
          muerte_subita: {
            value: "No",
            comentario: "",
          },
          enfermedad_coronaria: {
            value: "No",
            comentario: "",
          },
          observacion: "",
        },
        others: {
          alergias: {
            value: "No",
            comentario: "",
          },
          traumatico: {
            value: "No",
            comentario: "",
          },
          hospitalario: {
            value: "No",
            comentario: "",
          },
          psiquiatricos: {
            value: "No",
            comentario: "",
          },
          enfermades_t_sexual: {
            value: "No",
            comentario: "",
          },
          otros: {
            value: "No",
            comentario: "",
          },
          observacion: "",
        },
        inmunizations: {
          inmunizaciones: {
            value: "No",
            comentario: "",
            table: [],
          },
          observacion: "",
        },
      },
      SystemReview: {
        ailments: (() => {
          return ailmentsSystemReview.map((ailment) => {
            return { ailment: ailment, commentary: "" };
          });
        })(),
      },
      PhysicalExam: {
        gender: "",
        weight: "",
        abdominalPerimeter: "",
        size: "",
        heartRate: "",
        breathingFrequency: "",
        temperature: "",
        bloodPressureMM: "",
        bloodPressureHg: "",
        BMI: "",
        bodySurface: "",
        dominance: "",
        generalFeatures: "",
        headAndFace: "",
        ori: "",
        eyes: "",
        neck: "",
        chest: "",
        cardioVascular: "",
        pulmonary: "",
        abdomen: "",
        limbs: "",
        neurological: "",
        genitourinary: "",
        skin_appendages: "",
        otorhino: "",
        load: false,
      },
      Diagnostic: {
        cups: "",
        name: "",
        diagnostic: {},
        addedDiagnostics: [],
        dataOldDiagnostic: [],
        observations: [],
        dataDiagnostic: [],
        typesDiag: [],
        generalObservation: "",
        load: false,
      },
      MedicalOrders: {
        cups: "",
        name: "",
        diagnostic: {},
        addedDiagnostics: [],
        observation: "",
        observations: [],
        amount: [],
        dataDiagnostic: [],
        time: "",
        formulas: [],
        load: false,
        observationAndProcedure: "",
        medicalObservation: "",
      },
      AnalysisAndMedicalPlan: {
        analysis: "",
        plan: "",
        recommendations: "",
      },
      MedicalProcedures: {
        ECO: {
          vid: "",
          rao: "",
          e: "",
          pp: "",
          ao: "",
          a: "",
          ps: "",
          vd: "",
          tapse: "",
          vis: "",
          ai: "",
          ad: "",
          fe: "",
          adult: "",
          description: "",
          conclusions: "",
          professional: "",
          medicalOrders: [],
          medicament: {},
          addedMedicaments: [],
          observations: [],
          nameTemplete: "",
          id_servicio: "",
          ecoFiles: [],
          cie: {
            code: "",
            name: "",
          },
        },
        Stress: {
          vid: "",
          rao: "",
          e: "",
          pp: "",
          ao: "",
          a: "",
          ps: "",
          vd: "",
          tapse: "",
          vis: "",
          ai: "",
          ad: "",
          fe: "",
          adult: "",
          description: "",
          conclusions: "",
          professional: "",
          medicalOrders: [],
          medicament: {},
          addedMedicaments: [],
          observations: [],
          nameTemplete: "",
          id_servicio: "",
          stressFiles: [],
          cie: {
            code: "",
            name: "",
          },
        },
        Test: {
          professional: "",
          conclusion: "",
          conclusions: "",
          medicament: {},
          addedMedicaments: [],
          nameTemplete: "",
          id_servicio: "",
          testFiles: [],
          cie: {
            code: "",
            name: "",
          },
        },
        Holter: {
          professional: "",
          conclusion: "",
          medicament: {},
          addedMedicaments: [],
          nameTemplete: "",
          id_servicio: "",
          holterFiles: [],
          cie: {
            code: "",
            name: "",
          },
        },
        Map: {
          professional: "",
          conclusion: "",
          medicament: {},
          addedMedicaments: [],
          nameTemplete: "",
          id_servicio: "",
          mapFiles: [],
          cie: {
            code: "",
            name: "",
          },
        },
        EKG: {
          ritmo: "",
          fc: "",
          ondaP: "",
          pr: "",
          qrs: "",
          ejeQRS: "",
          styt: "",
          qtc: "",
          professional: "",
          conclusions: "",
          medicament: {},
          addedMedicaments: [],
          file: null,
          nameTemplete: "",
          id_servicio: "",
          ekgFiles: [],
          cie: {
            code: "",
            name: "",
          },
        },
      },
      FileProcedure: [],
      MedicalProceduresExist: false,
      examResults: {
        results: "",
        notes: "",
      },
      templates: {
        PhysicalExam: {},
        MedicalProcedures: {},
        examResults: {},
        SystemReview: {},
      },
      sourceDocuments: [],
      loading: false,
      errors: {},
      stateClinicistory: false, // Estado de la Historia clinica Cerrada/true Abierta/false
      openErrors: false,
      enabledTabsProcedures: {
        ECO: false,
        Stress: false,
        Test: false,
        Holter: false,
        Map: false,
        EKG: false,
        LAB: false,
        ninguno: false,
      },
      userPermits: [],
      profileName: "",
      SpeechTerapyText: null,
      refreshInfoPatient: {
        secondLastName: "",
        firstLastName: "",
        names: "",
        birthday: new Date(),
        documentNumber: "",
        typeOfDocument: "",
        age: "",
      },
      informacion_femenina: {
        menopausia: null,
        embarazo: null,
        menstruacion: null,
        planificacion: null,
      },
      expanded: "panel1",
      openAlert: false,
      modalAlert: { title: "", color: "", message: "" },
      urlLogo: sessionStorage.getItem("logoURL"),
      professional: null,
      id_profesional: 0,
      clinic_profile: null,
      creationProcess: null,
      showPDf: false,
      infoAdmissionPatient: null,
      third: null,
      dataClinicalStudio: null,
      detailsClinicalStudio: {
        criterialExcIncData: {
          enrolado: "No",
          inclusion: [],
          exclusion: [],
        },
        dataInformedConsent: [],
      },
      textPatientStudioContain: "El paciente es Enrolado en el Estudio Clínico",
      hiddenQuerysTabs: false,
      hiddenAnamnesis: false,
      sharedFormulas: {},
      colorAlergiesIcon: "#55e5bb",
      shouldEnabledProcedureTab: "1",
      infoPlanCurrentHistory: null,
      shouldResultsBeUpdated: false,
      uploadFileProcedure: false,
      dateFirstClosureClinicHistory: null, //Fecha de  cuando se cerró por primera la historiaClinica
      dateAtReopenClinicHistory: null, //Fecha de hasta cuando va a estar disponible reabrir la historia clinica
      contractInfo: null, // info del contrato
      listTipos: JSON.parse(sessionStorage.getItem("centroTipos")),
    };
  }

  componentDidMount() {
    this.verifyShowTabs();
    this.validateHiddenAnamnesis();

    //Esteban Londoño Ospina 22/07/2022
    //Validacion del Estudio Clinico
    if (
      this.props.data.studio == true &&
      this.props.data.id_estudio != null &&
      this.props.data.id_estudio != undefined
    ) {
      this.loadClinicalStudio(this.props.data.id_estudio);
    }

    if (this.props.data !== undefined && this.props.data !== null) {
      this.loadDataCita();
    }
    this.validateUserPermits();
    let tabsProcedures = this.validateTabsProcedures();

    this.setState(
      { stateClinicistory: this.props.data.historia_cerrada },
      async () => {
        let dataTemplates = null;
        if (this.state.stateClinicistory) {
          this.checkClosureEventHistory();
        } else {
          dataTemplates = await this.loadDataTempletes();
          //this.chargeDataTemplates(dataTemplates, tabsProcedures);
        }

        //Se carga el analisis y plan medico de la admision anterior sino tenia info trae la plantilla
        this.loadAnalysisAndMedicalPlanPorAdmision()
          .then((load) => {
            console.log("cargar Analisis y plan medico!!");
          })
          .catch((error) => {
            console.log(error);
          });

        //Trae la plantilla de Análisis y plan medico
        /* this.loadAnalysisAndMedicalPlanTemplate().then((dataAnalysisAndMedicalPlanTemplate) => {
        this.setState({
          AnalysisAndMedicalPlan: {
            analysis: dataAnalysisAndMedicalPlanTemplate !== undefined ? dataAnalysisAndMedicalPlanTemplate.analisis : '',
            plan: dataAnalysisAndMedicalPlanTemplate !== undefined ? dataAnalysisAndMedicalPlanTemplate.plan_medico : '',
            recommendations: dataAnalysisAndMedicalPlanTemplate !== undefined ? dataAnalysisAndMedicalPlanTemplate.recomendaciones : ''
          }
        }, () => {
          var { dispatch } = this.props;
          dispatch(change("analysis-and-medical-plan-form", "textarea-analysis", dataAnalysisAndMedicalPlanTemplate !== undefined ? dataAnalysisAndMedicalPlanTemplate.analisis : ''));
          dispatch(change("analysis-and-medical-plan-form", "textarea-medical-plan", dataAnalysisAndMedicalPlanTemplate !== undefined ? dataAnalysisAndMedicalPlanTemplate.plan_medico : ''));
          dispatch(change("analysis-and-medical-plan-form", "textarea-recommendations", dataAnalysisAndMedicalPlanTemplate !== undefined ? dataAnalysisAndMedicalPlanTemplate.recomendaciones : ''));
        });
      }).catch((error) => {
        console.log(error);
      }) */

        this.loadAnamesis()
          .then((load) => {
            console.log("cargar anamesis !!");
          })
          .catch((error) => {
            console.log(error);
          });

        /*  this.setState({ Diagnostic: { ...this.state.Diagnostic, load: true } }, () => {
         this.loadDiagnostic().then((load) => {
           console.log("cargar diagnostico !!");
           this.setState({ Diagnostic: { ...this.state.Diagnostic, load: false } })
         }).catch((error) => {
           console.log(error)
         });
       }) */

        this.setState(
          { Diagnostic: { ...this.state.Diagnostic, load: true } },
          () => {
            this.loadPatientDiagnosis()
              .then((load) => {
                console.log("cargar diagnostico !!");
                this.setState({
                  Diagnostic: { ...this.state.Diagnostic, load: false },
                });
              })
              .catch((error) => {
                console.log(error);
              });
          }
        );

        this.setState(
          { MedicalOrders: { ...this.state.MedicalOrders, load: true } },
          () => {
            this.loadMedicalOrders()
              .then((load) => {
                console.log("cargar ordenes medicas !!");
                this.setState(
                  {
                    MedicalOrders: { ...this.state.MedicalOrders, load: false },
                  },
                  () => {
                    this.loadMedicalOrdersByIdAdmssion();
                  }
                );
              })
              .catch((error) => {
                console.log(error);
              });
          }
        );

        /*  this.setState({ MedicalOrders: { ...this.state.MedicalOrders, load: true } }, () => {
         this.loadMedicalOrdersByIdAdmssion().then((load) => {
           console.log("cargar ordenes medicas !!");
           this.setState({ MedicalOrders: { ...this.state.MedicalOrders, load: false } }, () => {
             console.log(this.state.MedicalOrders);
           });
         }).catch((error) => {
           console.log(error)
         });
       }) */

        this.loadBackgroud()
          .then((load) => {
            console.log("cargar Background !!");
          })
          .catch((error) => {
            console.log(error);
          });

        this.loadMedicalProcedures()
          .then(async (dataProcedure) => {
            if (dataProcedure != null && dataProcedure != undefined) {
              var { dispatch } = this.props;

              //Forzar a Cargar los Holter
              if (tabsProcedures.Holter) {
                this.setState(
                  {
                    MedicalProcedures: {
                      ...this.state.MedicalProcedures,
                      ["Holter"]: {
                        ...this.state.MedicalProcedures["Holter"],
                        ["conclusion"]:
                          dataProcedure.holter.holter[0].conclusion,
                        ["id_servicio"]: tabsProcedures.id_servicio_holter,
                        ["nameTemplete"]:
                          dataProcedure.holter.holter[0].nameTemplete,
                      },
                    },
                  },
                  () => {
                    dispatch(
                      change(
                        "medical-procedures-form",
                        "textarea-conclusion-HOLTER",
                        this.state.MedicalProcedures.Holter.conclusion
                      )
                    );
                  }
                );
              }

              if (tabsProcedures.ECO) {
                //Forzar a cargar los ECO
                this.setState(
                  {
                    MedicalProcedures: {
                      ...this.state.MedicalProcedures,
                      ["ECO"]: {
                        ...this.state.MedicalProcedures["ECO"],
                        ["id_servicio"]: tabsProcedures.id_servicio_eco,
                        ["conclusions"]: dataProcedure.eco.eco[0].conclusiones,
                        ["nameTemplete"]: dataProcedure.eco.eco[0].nameTemplete,
                      },
                    },
                  },
                  () => {
                    dispatch(
                      change(
                        "medical-procedures-form",
                        "textarea-conclusions-ECO",
                        this.state.MedicalProcedures.ECO.conclusions
                      )
                    );
                  }
                );
              }

              if (tabsProcedures.Stress) {
                //Forzar a cargar los Stress
                this.setState(
                  {
                    MedicalProcedures: {
                      ...this.state.MedicalProcedures,
                      ["Stress"]: {
                        ...this.state.MedicalProcedures["Stress"],
                        ["conclusions"]:
                          dataProcedure.estres.estres[0].conclusiones,
                        ["nameTemplete"]:
                          dataProcedure.estres.estres[0].nameTemplete,
                        ["id_servicio"]: tabsProcedures.id_servicio_stress,
                      },
                    },
                  },
                  () => {
                    dispatch(
                      change(
                        "medical-procedures-form",
                        "textarea-conclusions-STRESS",
                        this.state.MedicalProcedures.Stress.conclusions
                      )
                    );
                  }
                );
              }

              if (tabsProcedures.EKG) {
                console.log("dataEKG", dataProcedure.ekg.ekg[0]);
                //Forzar a Cargar el EKG
                this.setState(
                  {
                    MedicalProcedures: {
                      ...this.state.MedicalProcedures,
                      ["EKG"]: {
                        ...this.state.MedicalProcedures["EKG"],
                        ["conclusions"]:
                          dataProcedure.ekg.ekg[0].conclusions ||
                          dataProcedure.ekg.ekg[0].conclusion,

                        ["nameTemplete"]: dataProcedure.ekg.ekg[0].nameTemplete,
                        ["id_servicio"]: tabsProcedures.id_servicio_ekg,
                      },
                    },
                  },
                  () => {
                    console.log("dataEKG", this.state.MedicalProcedures.EKG);
                    dispatch(
                      change(
                        "medical-procedures-form",
                        "textarea-conclusions-EKG",
                        this.state.MedicalProcedures.EKG.conclusions
                      )
                    );
                  }
                );
              }

              if (tabsProcedures.Map) {
                //Forzar a Cargar el Mapa
                this.setState(
                  {
                    MedicalProcedures: {
                      ...this.state.MedicalProcedures,
                      ["Map"]: {
                        ...this.state.MedicalProcedures["Map"],
                        ["conclusion"]: dataProcedure.mapa.mapa[0].conclusion,
                        ["nameTemplete"]:
                          dataProcedure.mapa.mapa[0].nameTemplete,
                        ["id_servicio"]: tabsProcedures.id_servicio_map,
                      },
                    },
                  },
                  () => {
                    dispatch(
                      change(
                        "medical-procedures-form",
                        "textarea-conclusion-MAP",
                        this.state.MedicalProcedures.Map.conclusion
                      )
                    );
                  }
                );
              }

              if (tabsProcedures.Test) {
                //Forzar a Cargar el Test
                this.setState(
                  {
                    MedicalProcedures: {
                      ...this.state.MedicalProcedures,
                      ["Test"]: {
                        ...this.state.MedicalProcedures["Test"],
                        ["conclusions"]:
                          dataProcedure.prueba.prueba[0].conclusiones,
                        ["nameTemplete"]:
                          dataProcedure.prueba.prueba[0].nameTemplete,
                        ["id_servicio"]: tabsProcedures.id_servicio_test,
                      },
                    },
                  },
                  () => {
                    dispatch(
                      change(
                        "medical-procedures-form",
                        "textarea-conclusions-TEST",
                        this.state.MedicalProcedures.Test.conclusions
                      )
                    );
                  }
                );
              }
            } else {
              if (tabsProcedures.Holter) {
                this.setState({
                  MedicalProcedures: {
                    ...this.state.MedicalProcedures,
                    ["Holter"]: {
                      ...this.state.MedicalProcedures["Holter"],
                      ["id_servicio"]: tabsProcedures.id_servicio_holter,
                    },
                  },
                });
              }

              if (tabsProcedures.ECO) {
                this.setState({
                  MedicalProcedures: {
                    ...this.state.MedicalProcedures,
                    ["ECO"]: {
                      ...this.state.MedicalProcedures["ECO"],
                      ["id_servicio"]: tabsProcedures.id_servicio_eco,
                    },
                  },
                });
              }

              if (tabsProcedures.Stress) {
                this.setState({
                  MedicalProcedures: {
                    ...this.state.MedicalProcedures,
                    ["Stress"]: {
                      ...this.state.MedicalProcedures["Stress"],
                      ["id_servicio"]: tabsProcedures.id_servicio_stress,
                    },
                  },
                });
              }

              if (tabsProcedures.EKG) {
                this.setState({
                  MedicalProcedures: {
                    ...this.state.MedicalProcedures,
                    ["EKG"]: {
                      ...this.state.MedicalProcedures["EKG"],
                      ["id_servicio"]: tabsProcedures.id_servicio_ekg,
                    },
                  },
                });
              }

              if (tabsProcedures.Map) {
                this.setState({
                  MedicalProcedures: {
                    ...this.state.MedicalProcedures,
                    ["Map"]: {
                      ...this.state.MedicalProcedures["Map"],
                      ["id_servicio"]: tabsProcedures.id_servicio_map,
                    },
                  },
                });
              }

              if (tabsProcedures.Test) {
                this.setState({
                  MedicalProcedures: {
                    ...this.state.MedicalProcedures,
                    ["Test"]: {
                      ...this.state.MedicalProcedures["Test"],
                      ["id_servicio"]: tabsProcedures.id_servicio_test,
                    },
                  },
                });
              }
            }
          })
          .catch((error) => {
            console.log(error);
          });

        this.loadFileProcedure();

        this.setState(
          { PhysicalExam: { ...this.state.PhysicalExam, load: true } },
          () => {
            this.loadPhysicalExam(dataTemplates)
              .then((load) => {
                console.log("cargar examenes fisicos !!");
                this.setState({
                  PhysicalExam: { ...this.state.PhysicalExam, load: false },
                });
              })
              .catch((error) => {
                console.log(error);
              });
          }
        );

        this.setState(
          { SystemReview: { ...this.state.SystemReview, load: true } },
          () => {
            this.loadSystemReview()
              .then((load) => {
                console.log("cargar revisión del sistema !!");
                this.setState({
                  SystemReview: { ...this.state.SystemReview, load: false },
                });
              })
              .catch((error) => {
                console.log(error);
              });
          }
        );

        //Se sugiere al Doctor llenar los Diagnosticos que se habian llenado en la Entrevista
        if (this.state.stateClinicistory != true) {
          this.loadInterviewDiagnostic();
        }

        console.log(this.state.profile);
      }
    );

    this.fetchDataProfessionals();
    this.loadDataProfile();
  }

  validateHiddenAnamnesis = () => {
    let clinica = JSON.parse(sessionStorage.getItem("clinica"));
    if (clinica.anamnesis_historia == true) {
      this.setState({ hiddenAnamnesis: false });
    } else {
      this.setState({ hiddenAnamnesis: true });
    }
  };

  //Esteban Londoño Ospina 16/09/2022
  //Verifica si se ocultan los Tabs de Consulta en la Historia Clinica
  verifyShowTabs = () => {
    try {
      let serviciosAdmision = this.props.data.servicios;
      const hasTherapy = serviciosAdmision.some((servicio) => {
        return servicio.codigo.includes("922");
      });
      if (serviciosAdmision[0].id_rips_concepto == 1 || hasTherapy) {
        this.setState({ hiddenQuerysTabs: false });
      } else {
        this.setState({ hiddenQuerysTabs: true });
      }
    } catch (e) {
      console.log(e);
    }
  };

  chargeDataTemplates = (dataTempletes, tabsProcedures) => {
    //Si hay plantillas las muestra
    if (dataTempletes != null && dataTempletes != undefined) {
      var { dispatch } = this.props;
      //Plantilla de Holter
      if (tabsProcedures.Holter) {
        this.setState(
          {
            MedicalProcedures: {
              ...this.state.MedicalProcedures,
              ["Holter"]: {
                ...this.state.MedicalProcedures["Holter"],
                ["conclusion"]: dataTempletes.procedimientos.Holter.conclusion,
              },
            },
          },
          () => {
            dispatch(
              change(
                "medical-procedures-form",
                "textarea-conclusion-HOLTER",
                dataTempletes.procedimientos.Holter.conclusion
              )
            );
          }
        );
      }

      if (tabsProcedures.ECO) {
        this.setState(
          {
            MedicalProcedures: {
              ...this.state.MedicalProcedures,
              ["ECO"]: {
                ...this.state.MedicalProcedures["ECO"],
                ["conclusions"]: dataTempletes.procedimientos.ECO.conclusions,
              },
            },
          },
          () => {
            dispatch(
              change(
                "medical-procedures-form",
                "textarea-conclusions-ECO",
                this.state.MedicalProcedures.ECO.conclusions
              )
            );
          }
        );
      }

      if (tabsProcedures.Stress) {
        this.setState(
          {
            MedicalProcedures: {
              ...this.state.MedicalProcedures,
              ["Stress"]: {
                ...this.state.MedicalProcedures["Stress"],
                ["conclusions"]:
                  dataTempletes.procedimientos.Stress.conclusions,
              },
            },
          },
          () => {
            dispatch(
              change(
                "medical-procedures-form",
                "textarea-conclusions-STRESS",
                this.state.MedicalProcedures.Stress.conclusions
              )
            );
          }
        );
      }

      if (tabsProcedures.EKG) {
        this.setState(
          {
            MedicalProcedures: {
              ...this.state.MedicalProcedures,
              ["EKG"]: {
                ...this.state.MedicalProcedures["EKG"],
                ["conclusions"]: dataTempletes.procedimientos.EKG.conclusions,
              },
            },
          },
          () => {
            dispatch(
              change(
                "medical-procedures-form",
                "textarea-conclusions-EKG",
                this.state.MedicalProcedures.EKG.conclusions
              )
            );
          }
        );
      }

      if (tabsProcedures.Test) {
        this.setState(
          {
            MedicalProcedures: {
              ...this.state.MedicalProcedures,
              ["Test"]: {
                ...this.state.MedicalProcedures["Test"],
                ["conclusions"]: dataTempletes.procedimientos.Test.conclusions,
              },
            },
          },
          () => {
            dispatch(
              change(
                "medical-procedures-form",
                "textarea-conclusions-TEST",
                this.state.MedicalProcedures.Test.conclusions
              )
            );
          }
        );
      }

      if (tabsProcedures.Map) {
        //Forzar a Cargar el Mapa
        this.setState(
          {
            MedicalProcedures: {
              ...this.state.MedicalProcedures,
              ["Map"]: {
                ...this.state.MedicalProcedures["Map"],
                /*['professional']: dataProcedure.mapa.mapa[0].profesional,
              ['addedMedicaments']: dataProcedure.mapa.mapa[0].diagnostico,*/
                ["conclusion"]: dataTempletes.procedimientos.Map.conclusion,
              },
            },
          },
          () => {
            dispatch(
              change(
                "medical-procedures-form",
                "textarea-conclusion-MAP",
                this.state.MedicalProcedures.Map.conclusion
              )
            );
          }
        );
      }
    }
  };

  replaceConcurrenceInString = (string, search, replace) => {
    return string.split(search).join(replace);
  };

  loadClinicalStudio = async (id_estudio) => {
    await fetch(
      `${process.env.REACT_APP_PUBLIC_URL}estudiosc/show/` + id_estudio,
      {
        method: "GET",
        headers: {
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
        "Content-Type": "application/json",
      }
    )
      .then((response) => {
        if (response.status != 500 && response.status != 403) {
          return response.json();
        } else {
          throw new Error("Ha ocurrido un error en el Servidor");
        }
      })
      .then((data) => {
        if (data.existe == true) {
          //Si existe el Estudio Clinico realiza las siguientes Gestiones
          this.setState({ dataClinicalStudio: data.contenido }, () => {
            this.handlerAcronym(this.state.dataClinicalStudio.estudio.acronimo);
            this.loadCandidatureAndInterestingPatientWithStudio(
              this.props.data.id_historia,
              id_estudio
            );
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  loadCandidatureAndInterestingPatientWithStudio = async (
    id_historia,
    id_estudio
  ) => {
    await fetch(
      `${process.env.REACT_APP_PUBLIC_URL}estudiosc/consultar-candidatura?id_historia=${id_historia}&id_estudio=${id_estudio}`,
      {
        method: "GET",
        headers: {
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
        "Content-Type": "application/json",
      }
    )
      .then((response) => {
        if (response.status != 500 && response.status != 403) {
          return response.json();
        } else {
          throw new Error("Ha ocurrido un error en el Servidor");
        }
      })
      .then((data) => {
        if (data.candidatura != null) {
          this.setState(
            {
              anamesis: {
                ...this.state.anamesis,
                candidate: data.candidatura.candidato_estudio,
                participate: data.candidatura.participa_estudio,
              },
            },
            () => {
              if (this.state.anamesis.participate == true) {
                //Criterios de Inclusion y Exclusion
                this.getCriterialDataClinicalStudio();
              }
            }
          );
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  getCriterialDataClinicalStudio = () => {
    //Criterios de Inclusion y Exclusion
    this.getCriteria()
      .then(() => {
        this.loadCriterialStudyAdmission();
      })
      .catch((err) => {
        console.log(err);
      });
  };

  getCriterialClinicalStudioDataPatient = async () => {
    await fetch(
      `${process.env.REACT_APP_PUBLIC_URL}estudiosc/consultar-candidatura?id_historia=${id_historia}&id_estudio=${id_estudio}`,
      {
        method: "GET",
        headers: {
          authorization: "Bearer " + sessionStorage.getItem("token"),
          "Content-Type": "application/json",
        },
      }
    )
      .then((response) => {
        if (response.status != 500 && response.status != 403) {
          return response.json();
        } else {
          throw new Error("Ha ocurrido un error en el Servidor");
        }
      })
      .then((data) => {})
      .catch((error) => {
        console.log(error);
      });
  };

  loadCriterialStudyAdmission = async () => {
    await fetch(
      `${process.env.REACT_APP_PUBLIC_URL}historia-estudio/consultar-criterios`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
        body: JSON.stringify({
          id_admision: this.props.data.id_admision,
          id_historia: this.props.data.id_historia,
        }),
      }
    )
      .then((response) => {
        if (response.status != 500 && response.status != 403) {
          return response.json();
        } else {
          throw new Error("Ha ocurrido un error en el Servidor");
        }
      })
      .then((data) => {
        if (data.existe == true) {
          this.setState(
            {
              detailsClinicalStudio: {
                ...this.state.detailsClinicalStudio,
                criterialExcIncData: {
                  ...this.state.detailsClinicalStudio.criterialExcIncData,
                  inclusion: data.contenido.inclusion.criterios,
                  exclusion: data.contenido.exclusion.criterios,
                  enrolado:
                    data.contenido.paciente_enrolado == true ? "Sí" : "No",
                },
              },
            },
            () => {
              data.contenido.paciente_enrolado == true;
              this.setState({
                textPatientStudioContain:
                  "El Paciente Continua en el Estudio Clinico",
              });
            }
          );
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  loadFileProcedure = () => {
    return new Promise((resolve, reject) => {
      fetch(
        process.env.REACT_APP_PUBLIC_URL +
          "procedimientos-adjunto/consultar?id_admision=" +
          this.props.data.id_admision,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            authorization: "Bearer " + sessionStorage.getItem("token"),
          },
        }
      )
        .then((response) => {
          if (response.status != 500 && response.status != 403) {
            return response.json();
          } else {
            throw new Error("Error Data");
          }
        })
        .then((dataAdjunto) => {
          if (dataAdjunto.adjunto != null) {
            console.log("carga6toArchivoProcedimiento", dataAdjunto.adjunto);
            this.setState(
              {
                FileProcedure: dataAdjunto.adjunto,
              },
              () => this.defineFilesForProcedures()
            );
          }
        })
        .catch((error) => {
          console.log(error);
        });
    });
  };

  defineFilesForProcedures = () => {
    this.setState({ uploadFileProcedure: true }, () => {
      if (!!this.state.FileProcedure) {
        if (!!this.state.FileProcedure.length) {
          let filesWithoutIdService = [];
          let filesWithServices = [];
          this.state.FileProcedure.forEach((file) => {
            if (!!file.id_servicio) {
              const idServicio = file.id_servicio.toString();
              for (const procedure in this.state.MedicalProcedures) {
                if (
                  this.state.MedicalProcedures[procedure].id_servicio ===
                  idServicio
                ) {
                  file.procedure = procedure;
                  file.wholeUrl =
                    process.env.REACT_APP_PUBLIC_URL +
                    file.url_adjunto +
                    sessionStorage.getItem("token");
                  filesWithServices.push(file);
                }
              }
            } else {
              file.wholeUrl =
                process.env.REACT_APP_PUBLIC_URL +
                file.url_adjunto +
                sessionStorage.getItem("token");
              filesWithoutIdService.push(file);
            }
          });
          this.filterFileProcedures(filesWithServices);
        }
      }
    });
  };

  filterFileProcedures = (filesAllProcedures) => {
    let labFiles = [];
    if (!!filesAllProcedures) {
      if (!!filesAllProcedures.length) {
        filesAllProcedures.forEach((file) => {
          switch (file.procedure) {
            case "ECO":
              let ecoFilesCurr = this.state.MedicalProcedures.ECO.ecoFiles;
              let findEcoFile = ecoFilesCurr.find(
                (ecFile) =>
                  ecFile.id_procedimiento_adjunto ===
                  file.id_procedimiento_adjunto
              );
              !findEcoFile && ecoFilesCurr.push(file);
              this.setState({
                MedicalProcedures: {
                  ...this.state.MedicalProcedures,
                  ["ECO"]: {
                    ...this.state.MedicalProcedures["ECO"],
                    ["ecoFiles"]: ecoFilesCurr,
                  },
                },
                uploadFileProcedure: false,
              });
              break;
            case "EKG":
              let ekgFilesCurr = this.state.MedicalProcedures.EKG.ekgFiles;
              let findEkgFile = ekgFilesCurr.find(
                (ekFile) =>
                  ekFile.id_procedimiento_adjunto ===
                  file.id_procedimiento_adjunto
              );
              !findEkgFile && ekgFilesCurr.push(file);
              this.setState({
                MedicalProcedures: {
                  ...this.state.MedicalProcedures,
                  ["EKG"]: {
                    ...this.state.MedicalProcedures["EKG"],
                    ["ekgFiles"]: ekgFilesCurr,
                  },
                },
                uploadFileProcedure: false,
              });
              break;
            case "Holter":
              let holterFilesCurr =
                this.state.MedicalProcedures.Holter.holterFiles;
              let findHolterFile = holterFilesCurr.find(
                (holFile) =>
                  holFile.id_procedimiento_adjunto ===
                  file.id_procedimiento_adjunto
              );
              !findHolterFile && holterFilesCurr.push(file);
              this.setState({
                MedicalProcedures: {
                  ...this.state.MedicalProcedures,
                  ["Holter"]: {
                    ...this.state.MedicalProcedures["Holter"],
                    ["holterFiles"]: holterFilesCurr,
                  },
                },
                uploadFileProcedure: false,
              });
              break;
            case "LAB":
              labFiles.push(file);
              break;
            case "Map":
              let mapFilesCurr = this.state.MedicalProcedures.Map.mapFiles;
              let findMapFile = mapFilesCurr.find(
                (mapFile) =>
                  mapFile.id_procedimiento_adjunto ===
                  file.id_procedimiento_adjunto
              );
              !findMapFile && mapFilesCurr.push(file);
              this.setState({
                MedicalProcedures: {
                  ...this.state.MedicalProcedures,
                  ["Map"]: {
                    ...this.state.MedicalProcedures["Map"],
                    ["mapFiles"]: mapFilesCurr,
                  },
                },
                uploadFileProcedure: false,
              });
              break;
            case "Stress":
              let stressFilesCurr =
                this.state.MedicalProcedures.Stress.stressFiles;
              let findStressFile = stressFilesCurr.find(
                (stressFile) =>
                  stressFile.id_procedimiento_adjunto ===
                  file.id_procedimiento_adjunto
              );
              !findStressFile && stressFilesCurr.push(file);
              this.setState({
                MedicalProcedures: {
                  ...this.state.MedicalProcedures,
                  ["Stress"]: {
                    ...this.state.MedicalProcedures["Stress"],
                    ["stressFiles"]: stressFilesCurr,
                  },
                },
                uploadFileProcedure: false,
              });
              break;
            case "Test":
              let testFilesCurr = this.state.MedicalProcedures.Test.testFiles;
              let findTestFile = testFilesCurr.find(
                (testFile) =>
                  testFile.id_procedimiento_adjunto ===
                  file.id_procedimiento_adjunto
              );
              !findTestFile && testFilesCurr.push(file);
              this.setState({
                MedicalProcedures: {
                  ...this.state.MedicalProcedures,
                  ["Test"]: {
                    ...this.state.MedicalProcedures["Test"],
                    ["testFiles"]: testFilesCurr,
                  },
                },
                uploadFileProcedure: false,
              });
              break;
          }
        });
      }
    }
  };

  loadInterviewDiagnostic = () => {
    return new Promise((resolve, reject) => {
      fetch(
        process.env.REACT_APP_PUBLIC_URL +
          "admision-entrevista/consultar-diagnosticos?id_admision=" +
          this.props.data.id_admision,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            authorization: "Bearer " + sessionStorage.getItem("token"),
          },
        }
      )
        .then((response) => {
          if (response.status != 500 && response.status != 403) {
            return response.json();
          } else {
            throw new Error("Error Data");
          }
        })
        .then((res) => {
          this.setState({
            Diagnostic: {
              ...this.state.Diagnostic,
              addedDiagnostics: res,
            },
          });
          //resolve(res);
        })
        .catch((error) => {
          //reject(error);
          console.log("ERROR TEST");
          console.log(error);
        });
    });
  };

  handlerSecondLastNameDataInfo = (SecondLastName) => {
    this.setState({
      refreshInfoPatient: {
        ...this.state.refreshInfoPatient,
        secondLastName: SecondLastName,
      },
    });
  };
  handlerFirstLastNameDataInfo = (FirstLastName) => {
    this.setState({
      refreshInfoPatient: {
        ...this.state.refreshInfoPatient,
        firstLastName: FirstLastName,
      },
    });
  };
  handlerNamesDataInfo = (names) => {
    this.setState({
      refreshInfoPatient: { ...this.state.refreshInfoPatient, names: names },
    });
  };
  handlerBirthDateDataInfo = (birthday) => {
    this.setState(
      {
        refreshInfoPatient: {
          ...this.state.refreshInfoPatient,
          ["birthday"]: birthday,
        },
      },
      () =>
        this.setState({
          refreshInfoPatient: {
            ...this.state.refreshInfoPatient,
            ["birthday"]: birthday,
          },
        })
    );
  };
  handlerDocumentNumberDataInfo = (documentNumber) => {
    this.setState({
      refreshInfoPatient: {
        ...this.state.refreshInfoPatient,
        documentNumber: documentNumber,
      },
    });
  };
  handlerTypeOfDocumentDataInfo = (typeOfDocument) => {
    this.setState({
      refreshInfoPatient: {
        ...this.state.refreshInfoPatient,
        typeOfDocument: typeOfDocument,
      },
    });
  };

  validateUserPermits() {
    var user = JSON.parse(sessionStorage.getItem("usuario"));
    const nombrePerfil = sessionStorage.getItem("nombreperfil");
    if (user != null) {
      if (user.perfil != undefined) {
        var perfil = user.perfil.modulos;
        this.setState({ userPermits: perfil });
        this.setState({ profileName: nombrePerfil });
      } else {
        var perfil = [];
        this.setState({ userPermits: [] });
      }
    } else {
      this.setState({ userPermits: [] });
    }
  }

  validateTabsProcedures = () => {
    let enabledTabsProcedures = {
      ECO: false,
      id_servicio_eco: "",
      Stress: false,
      id_servicio_stress: "",
      Test: false,
      id_servicio_test: "",
      Holter: false,
      id_servicio_holter: "",
      Map: false,
      id_servicio_map: "",
      EKG: false,
      id_servicio_ekg: "",
      LAB: false,
      id_servicio_lab: "",
      ninguno: false,
    };
    try {
      for (let i = 0; i < this.props.data.servicios.length; i++) {
        switch (this.props.data.servicios[i].formato.toString()) {
          case "1": //ECO
            enabledTabsProcedures.ECO = true;
            enabledTabsProcedures.id_servicio_eco =
              this.props.data.servicios[i].id_servicio.toString();
            break;
          case "2": //EKG
            enabledTabsProcedures.EKG = true;
            enabledTabsProcedures.id_servicio_ekg =
              this.props.data.servicios[i].id_servicio.toString();
            break;
          case "3": //STREES
            enabledTabsProcedures.Stress = true;
            enabledTabsProcedures.id_servicio_stress =
              this.props.data.servicios[i].id_servicio.toString();
            break;
          case "4": //TEST
            enabledTabsProcedures.Test = true;
            enabledTabsProcedures.id_servicio_test =
              this.props.data.servicios[i].id_servicio.toString();
            break;
          case "5": //LABORATORIO
            enabledTabsProcedures.LAB = true;
            enabledTabsProcedures.id_servicio_lab =
              this.props.data.servicios[i].id_servicio.toString();
            break;
          case "6": //HOLTER
            enabledTabsProcedures.Holter = true;
            enabledTabsProcedures.id_servicio_holter =
              this.props.data.servicios[i].id_servicio.toString();
            break;
          case "7": //MAPA
            enabledTabsProcedures.Map = true;
            enabledTabsProcedures.id_servicio_map =
              this.props.data.servicios[i].id_servicio.toString();
            break;
          case "8": //REPORTES
            break;
          case "9": //NINGUNO
            enabledTabsProcedures.ninguno = true;
            break;
        }
      }
      console.log("enabledTabsProcedures", enabledTabsProcedures);
      let shouldActiveIndex = Object.keys(enabledTabsProcedures).find(
        (key) => enabledTabsProcedures[key] === true
      );
      this.setState({ enabledTabsProcedures: enabledTabsProcedures }, () =>
        this.shouldActiveTabFirstProcedure(shouldActiveIndex)
      );
      return enabledTabsProcedures;
    } catch (e) {
      console.log(e);
      return enabledTabsProcedures;
    }
  };

  shouldActiveTabFirstProcedure = (firstTabActive) => {
    console.log("firstTabActive", firstTabActive, typeof firstTabActive);
    let optionToSearh = !!firstTabActive
      ? firstTabActive.toString()
      : "Ninguno";
    switch (optionToSearh) {
      case "ECO":
        this.setState({ shouldEnabledProcedureTab: "2" });
        break;
      case "EKG":
        this.setState({ shouldEnabledProcedureTab: "5" });
        break;
      case "Holter":
        this.setState({ shouldEnabledProcedureTab: "6" });
        break;
      case "LAB":
        this.setState({ shouldEnabledProcedureTab: "8" });
        break;
      case "Map":
        this.setState({ shouldEnabledProcedureTab: "7" });
        break;
      case "Stress":
        this.setState({ shouldEnabledProcedureTab: "3" });
        break;
      case "Test":
        this.setState({ shouldEnabledProcedureTab: "4" });
        break;

      default:
        this.setState({ shouldEnabledProcedureTab: "1" });
        break;
    }
  };

  toggle = (tab) => {
    const { activeTab } = this.state;
    if (activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  };

  loadDataProfile = async () => {
    await fetch(process.env.REACT_APP_PUBLIC_URL + "clinica/listar", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + sessionStorage.getItem("token"),
      },
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log("data per", data);
        if (data.length > 0) {
          this.setState({
            clinic_profile: data[0],
          });
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  reopenEventHistory = async () => {
    let dataSend = { id_admision: this.props.data.id_admision };
    await fetch(process.env.REACT_APP_PUBLIC_URL + "evento/reabrir_historia", {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + sessionStorage.getItem("token"),
      },
      body: JSON.stringify(dataSend),
    })
      .then((response) => {
        if (response.status != 500 && response.status != 403) {
          return response.json();
        } else {
          throw new Error("Ha ocurrido un error en el Servidor");
        }
      })
      .then((data) => {
        console.log(data);
        if (!!data) {
          this.setState({ stateClinicistory: false });
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  checkClosureEventHistory = async () => {
    await fetch(
      process.env.REACT_APP_PUBLIC_URL +
        "evento/consultar/cierre_historia_clinica/" +
        this.props.data.id_admision,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      }
    )
      .then((response) => {
        if (response.status != 500 && response.status != 403) {
          return response.json();
        } else {
          throw new Error("Ha ocurrido un error en el Servidor");
        }
      })
      .then((data) => {
        if (!!data) {
          let firstClosureClinicHistory = data.fecha_cierre_1er_registro;
          let avaliableToReopenUntil = moment(firstClosureClinicHistory).add(
            12,
            "hours"
          );
          this.setState({
            dateAtReopenClinicHistory: avaliableToReopenUntil,
            dateFirstClosureClinicHistory: firstClosureClinicHistory,
          });
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  loadDataTempletes = () => {
    const id = sessionStorage.getItem("id_clinica");
    return new Promise((resolve, reject) => {
      fetch(
        process.env.REACT_APP_PUBLIC_URL +
          "historia-plantillas/consultar?id_clinica=" +
          id,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            authorization: "Bearer " + sessionStorage.getItem("token"),
          },
        }
      )
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          if (data.plantilla !== null) {
            this.setState({
              SystemReview: {
                ailments: [
                  {
                    ailment: ailmentsSystemReview[0],
                    commentary:
                      data.plantilla.revision_por_sistema.sintomas_generales,
                  },
                  {
                    ailment: ailmentsSystemReview[1],
                    commentary:
                      data.plantilla.revision_por_sistema.respiratorios,
                  },
                  {
                    ailment: ailmentsSystemReview[2],
                    commentary:
                      data.plantilla.revision_por_sistema.cardio_vascular,
                  },
                  {
                    ailment: ailmentsSystemReview[3],
                    commentary:
                      data.plantilla.revision_por_sistema.gastrointestintal,
                  },
                  {
                    ailment: ailmentsSystemReview[4],
                    commentary:
                      data.plantilla.revision_por_sistema.genitourinario,
                  },
                  {
                    ailment: ailmentsSystemReview[5],
                    commentary:
                      data.plantilla.revision_por_sistema.osteomuscular,
                  },
                  {
                    ailment: ailmentsSystemReview[6],
                    commentary:
                      data.plantilla.revision_por_sistema.dermatologico,
                  },
                  {
                    ailment: ailmentsSystemReview[7],
                    commentary: data.plantilla.revision_por_sistema.endocrino,
                  },
                  {
                    ailment: ailmentsSystemReview[8],
                    commentary: data.plantilla.revision_por_sistema.neurologico,
                  },
                ],
              },
              examResults: {
                results: data.plantilla.resultados_examenes.results,
                notes: data.plantilla.resultados_examenes.notes,
              },
            });
            if (!this.existMedicalProcedures) {
              resolve(data.plantilla);
            } else {
              resolve(null);
            }
          } else {
            resolve(null);
          }
        })
        .catch((error) => {
          console.error("Error:", error);
          reject(null);
        });
    });
  };

  handlerAgeDataInfo = (age) => {
    this.setState({
      refreshInfoPatient: {
        ...this.state.refreshInfoPatient,
        age: age,
      },
    });
  };

  handlerInfoFemMenopausia = (menopuasia) => {
    this.setState({
      informacion_femenina: {
        ...this.state.informacion_femenina,
        menopausia: menopuasia,
      },
    });
  };
  handlerInfoFemMenstruacion = (menstruacion) => {
    this.setState({
      informacion_femenina: {
        ...this.state.informacion_femenina,
        menstruacion: menstruacion,
      },
    });
  };
  handlerInfoFemPlanificacion = (planificacion) => {
    this.setState({
      informacion_femenina: {
        ...this.state.informacion_femenina,
        planificacion: planificacion,
      },
    });
  };
  handlerInfoFemEmbarazo = (embarazo) => {
    this.setState({
      informacion_femenina: {
        ...this.state.informacion_femenina,
        embarazo: embarazo,
      },
    });
  };

  handlerSelectCauseOfAdmission = (cause) => {
    this.setState({ anamesis: { ...this.state.anamesis, cause: cause } });
  };

  handlerReasonForConsultation = (reasonForConsultation) => {
    this.setState({
      anamesis: {
        ...this.state.anamesis,
        reasonForConsultation: reasonForConsultation,
      },
    });
  };

  handlerCurrentIllness = (currentIllness) => {
    this.setState({
      anamesis: { ...this.state.anamesis, currentIllness: currentIllness },
    });
  };

  loadAnamesis = () => {
    var data = {
      id_historia: this.props.data.id_historia,
      id_admision: this.props.data.id_admision,
    };
    return new Promise((resolve, reject) => {
      fetch(process.env.REACT_APP_PUBLIC_URL + "anamnesis/consultar", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
        body: JSON.stringify(data),
      })
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          console.log(data);
          if (data.existe) {
            var anamesis = data.contenido[data.contenido.length - 1];
            console.log("carga1eroAnamnesis", anamesis);
            this.setState(
              {
                anamesis: {
                  cause: anamesis.causa_ingreso,
                  reasonForConsultation: anamesis.motivo_consulta,
                  currentIllness: anamesis.enfermedad_actual,
                },
              },
              () => {
                var { dispatch } = this.props;
                dispatch(
                  change("ananmesis-form", "cause-of-admission", {
                    value: anamesis.causa_ingreso,
                    label: anamesis.causa_ingreso,
                  })
                );
                dispatch(
                  change(
                    "ananmesis-form",
                    "textarea-reason-for-consultation",
                    anamesis.motivo_consulta
                  )
                );
                dispatch(
                  change(
                    "ananmesis-form",
                    "textarea-current-illness",
                    anamesis.enfermedad_actual
                  )
                );
              }
            );
            resolve(false);
          } else {
            this.loadAnamnesisTemplate().then((dataAnamnesis) => {
              if (dataAnamnesis != null) {
                this.setState(
                  {
                    anamesis: {
                      cause: dataAnamnesis.causa_ingreso,
                      reasonForConsultation: dataAnamnesis.motivo_consulta,
                      currentIllness: dataAnamnesis.enfermedad_actual,
                    },
                  },
                  () => {
                    var { dispatch } = this.props;
                    dispatch(
                      change("ananmesis-form", "cause-of-admission", {
                        value: dataAnamnesis.causa_ingreso,
                        label: dataAnamnesis.causa_ingreso,
                      })
                    );
                    dispatch(
                      change(
                        "ananmesis-form",
                        "textarea-reason-for-consultation",
                        dataAnamnesis.motivo_consulta
                      )
                    );
                    dispatch(
                      change(
                        "ananmesis-form",
                        "textarea-current-illness",
                        dataAnamnesis.enfermedad_actual
                      )
                    );
                  }
                );
              }
            });
            resolve(false);
          }
        })
        .catch((error) => {
          console.error("Error:", error);
          reject(error);
        });
    });
  };

  loadAnamnesisTemplate = () => {
    return new Promise((resolve, reject) => {
      fetch(process.env.REACT_APP_PUBLIC_URL + "pantillas-anamnesis/listar", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.status != 500 && response.status != 403) {
            return response.json();
          } else {
            throw new Error("Ha ocurrido un error en el Servidor");
          }
        })
        .then((data) => {
          resolve(data[0]);
        })
        .catch((error) => {
          console.log("AnamnesisError:", error);
          resolve(null);
        });
    });
  };

  loadBackgroud = () => {
    let id_admision = 0;
    if (this.state.stateClinicistory == true) {
      id_admision = this.props.data.id_admision;
    }

    var data = {
      id_historia: this.props.data.id_historia,
      id_admision: id_admision,
    };
    return new Promise((resolve, reject) => {
      fetch(process.env.REACT_APP_PUBLIC_URL + "antecedente/consultar", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
        body: JSON.stringify(data),
      })
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          if (data.existe) {
            var backgroundData = data.contenido;

            //Antecedentes Patologicos
            let pathologicsBackgroud =
              backgroundData[0].patologicos != null
                ? backgroundData[0].patologicos.patologicos[0]
                : null;
            this.loadDataBackgroundPathologics(pathologicsBackgroud);

            //Antecedentes Quirurjicos
            let surgicalBackgroud =
              backgroundData[0].quirurgicos != null
                ? backgroundData[0].quirurgicos.quirurgicos[0]
                : null;
            this.loadSurgicalBackground(surgicalBackgroud);

            let pharmacologicBackgroud =
              backgroundData[0].farmacologicos != null
                ? backgroundData[0].farmacologicos.farmacologicos[0]
                : null;
            this.loadPharmacologicBackground(
              pharmacologicBackgroud,
              backgroundData[0].fecha_admision
            );
            this.loadMedicalOrdersFromPharmacological(pharmacologicBackgroud);

            let gynecologistsBackgroud =
              backgroundData[0].ginecoobstetricos != null
                ? backgroundData[0].ginecoobstetricos.ginecoobstetricos[0]
                : null;
            this.loadGynecologistBackgroud(gynecologistsBackgroud);

            let familyBackgroud =
              backgroundData[0].familiares != null
                ? backgroundData[0].familiares.familiares[0]
                : null;
            this.loadFamilyBackgroud(familyBackgroud);

            let otherBackgroud =
              backgroundData[0].otros != null
                ? backgroundData[0].otros.otros[0]
                : null;
            this.loadOtherBackgroud(otherBackgroud);

            let inmunizationsBackgroud =
              backgroundData[0].inmunizaciones != null
                ? backgroundData[0].inmunizaciones.inmunizaciones[0]
                : null;
            this.loadInmunizationsBackgroud(inmunizationsBackgroud);

            var habitsData =
              backgroundData[data.contenido.length - 1].habitos.habitos[0];
            this.loadHabits(habitsData);
            resolve(false);
          } else {
            console.log(data.contenido);
            resolve(false);
          }
        })
        .catch((error) => {
          console.error("Error:", error);
          reject(error);
        });
    });
  };

  loadDataBackgroundPathologics = (dataPathologics) => {
    console.log("dataPathologics", dataPathologics);
    if (dataPathologics != null) {
      this.setState({
        sectionAilment: {
          ...this.state.sectionAilment,
          pathologicals: {
            hipertension: {
              value: dataPathologics.hipertension.value,
              comentario: dataPathologics.hipertension.comentario,
            },
            metabolicos: {
              value: dataPathologics.metabolicos.value,
              comentario: dataPathologics.metabolicos.comentario,
            },
            cardiacos: {
              value: dataPathologics.cardiacos.value,
              comentario: dataPathologics.cardiacos.comentario,
            },
            infecciosos: {
              value: dataPathologics.infecciosos.value,
              comentario: dataPathologics.infecciosos.comentario,
            },
            vasculares: {
              value: dataPathologics.vasculares.value,
              comentario: dataPathologics.vasculares.comentario,
            },
            alergicos: {
              value: dataPathologics.alergicos.value,
              comentario: dataPathologics.alergicos.comentario,
            },
            cancer: {
              value: dataPathologics.cancer.value,
              comentario: dataPathologics.cancer.comentario,
            },
            transfusiones: {
              value: dataPathologics.transfusiones.value,
              comentario: dataPathologics.transfusiones.comentario,
            },
            autoinmunes: {
              value: dataPathologics.autoinmunes.value,
              comentario: dataPathologics.autoinmunes.comentario,
            },
            traumatico: {
              value: dataPathologics.traumatico.value,
              comentario: dataPathologics.traumatico.comentario,
            },
            diabetes: {
              value: dataPathologics.hasOwnProperty("diabetes")
                ? dataPathologics.diabetes.value
                : "No",
              comentario: dataPathologics.hasOwnProperty("diabetes")
                ? dataPathologics.diabetes.comentario
                : "",
            },
            hiperlipidemia: {
              value: dataPathologics.hasOwnProperty("hiperlipidemia")
                ? dataPathologics.hiperlipidemia.value
                : "No",
              comentario: dataPathologics.hasOwnProperty("hiperlipidemia")
                ? dataPathologics.hiperlipidemia.comentario
                : "",
            },
            enfermedad_coronaria: {
              value: dataPathologics.hasOwnProperty("enfermedad_coronaria")
                ? dataPathologics.enfermedad_coronaria.value
                : "No",
              comentario: dataPathologics.hasOwnProperty("enfermedad_coronaria")
                ? dataPathologics.enfermedad_coronaria.comentario
                : "",
            },
            enf_vascular_per: {
              value: dataPathologics.hasOwnProperty("enf_vascular_per")
                ? dataPathologics.enf_vascular_per.value
                : "No",
              comentario: dataPathologics.hasOwnProperty("enf_vascular_per")
                ? dataPathologics.enf_vascular_per.comentario
                : "",
            },
            hepatitis: {
              value: dataPathologics.hasOwnProperty("hepatitis")
                ? dataPathologics.hepatitis.value
                : "No",
              comentario: dataPathologics.hasOwnProperty("hepatitis")
                ? dataPathologics.hepatitis.comentario
                : "",
            },
            observacion: dataPathologics.observation,
          },
        },
      });
    }
  };

  loadSurgicalBackground = (dataSurgical) => {
    if (dataSurgical != null) {
      this.setState({
        sectionAilment: {
          ...this.state.sectionAilment,
          surgicals: {
            quirurjico: {
              value: dataSurgical.quirurgico.value,
              comentario: dataSurgical.quirurgico.comentario,
            },
            observacion: dataSurgical.observation,
          },
        },
      });
    }
  };

  loadMedicalOrdersFromPharmacological = (dataPharmacologica) => {
    let medSendToMedicalOrders =
      dataPharmacologica != null
        ? dataPharmacologica.farmacologico.table
        : null;
    console.log({ dataPharmacologica });

    medSendToMedicalOrders.forEach((med) => {
      let formula = {
        activePrinciple: med.principioactivo,
        concentration: med.concentracion,
        pharmaceuticalForm: med.formafarmaceutica,
        route: med.viaadministracion,
        dose: med.dosis,
        frequency: med.frecuencia,
        duration: "30",
        units: this.durationTable(
          30,
          parseInt(med.dosis),
          this.frecuencyLetters(med.frecuencia)
        ),
      };
      console.log("FormulaToSend", formula);
      this.handlerFormulasNewFunctional(formula);
    });
  };

  loadPharmacologicBackground(dataPharmacologica, admissionDate) {
    if (dataPharmacologica != null) {
      let currentMedicalOrders = this.state.MedicalOrders.formulas;
      let currentTableInmunizations = dataPharmacologica.farmacologico.table;
      let newCurrentMedicalOrders = currentMedicalOrders.map((form) => {
        let medicine = {};
        medicine.principioactivo = form.activePrinciple;
        medicine.concentracion = form.concentration;
        medicine.dosis = form.dose;
        medicine.frecuencia = form.frequency;
        medicine.viaadministracion = form.route;
        medicine.fecha_inico = moment(form.admissioDate).format("YYYY-MM-DD");
        medicine.fecha_fin = "";
        return medicine;
      });
      let wholeInmunizations = [
        ...currentTableInmunizations,
        ...newCurrentMedicalOrders,
      ];
      console.log({
        currentTableInmunizations,
        currentMedicalOrders,
        wholeInmunizations,
      });
      const uniquesFormulas = [];

      this.setState(
        {
          sectionAilment: {
            ...this.state.sectionAilment,
            pharmacological: {
              farmacologico: {
                value: dataPharmacologica.farmacologico.value,
                comentario: dataPharmacologica.farmacologico.comentario,
                table: wholeInmunizations,
              },
              observacion: dataPharmacologica.observation,
            },
          },
        } /* ()=> this.loadMedicalOrdersFromPharmacological(dataPharmacologica) */
      );
    }
  }

  frecuencyLetters = (freq) => {
    switch (freq) {
      case "Dos veces al día":
        return 2;
      case "Tres veces al día":
        return 3;
      case "Cuatro veces al día":
        return 4;
      default:
        return 1;
    }
  };

  durationTable = (dur, dos, freq) => {
    let valor = dos * freq * dur;
    return valor;
  };

  loadGynecologistBackgroud = (dataGynecologist) => {
    if (dataGynecologist != null) {
      this.setState({
        sectionAilment: {
          ...this.state.sectionAilment,
          gynecologists: {
            ginecoobstetrico: {
              value: dataGynecologist.ginecoobstetrico.value,
              comentario: dataGynecologist.ginecoobstetrico.comentario,
            },
            observacion: dataGynecologist.observation,
          },
        },
      });
    }
  };

  loadFamilyBackgroud = (dataFamily) => {
    if (dataFamily != null) {
      this.setState({
        sectionAilment: {
          ...this.state.sectionAilment,
          family: {
            cancer: {
              value: dataFamily.cancer.value,
              comentario: dataFamily.cancer.comentario,
            },
            diabetes: {
              value: dataFamily.diabetes.value,
              comentario: dataFamily.diabetes.comentario,
            },
            hipertension: {
              value: dataFamily.hipertension.value,
              comentario: dataFamily.hipertension.comentario,
            },
            muerte_subita: {
              value: dataFamily.muerte_subita.value,
              comentario: dataFamily.muerte_subita.comentario,
            },
            enfermedad_coronaria: {
              value: dataFamily.enf_coronaria.value,
              comentario: dataFamily.enf_coronaria.comentario,
            },
            observacion: dataFamily.observation,
          },
        },
      });
    }
  };

  loadOtherBackgroud = (dataOther) => {
    if (dataOther != null) {
      this.setState({
        sectionAilment: {
          ...this.state.sectionAilment,
          others: {
            alergias: {
              value: dataOther.alergias.value,
              comentario: dataOther.alergias.comentario,
            },
            traumatico: {
              value: dataOther.traumatico.value,
              comentario: dataOther.traumatico.comentario,
            },
            hospitalario: {
              value: dataOther.hospitalario.value,
              comentario: dataOther.hospitalario.comentario,
            },
            psiquiatricos: {
              value: dataOther.psiquiatricos.value,
              comentario: dataOther.psiquiatricos.comentario,
            },
            enfermades_t_sexual: {
              value: dataOther.enfermades_t_sexual.value,
              comentario: dataOther.enfermades_t_sexual.comentario,
            },
            otros: {
              value: "No",
              comentario: "",
            },
            observacion: dataOther.observation,
          },
        },
      });
    }
  };

  loadInmunizationsBackgroud = (dataInmunizations) => {
    console.log("DATAINMUNE", dataInmunizations);
    if (dataInmunizations != null) {
      this.setState({
        sectionAilment: {
          ...this.state.sectionAilment,
          inmunizations: {
            inmunizaciones: {
              value: dataInmunizations.inmunizaciones.value,
              comentario: dataInmunizations.inmunizaciones.comentario,
              table: dataInmunizations.inmunizaciones.table,
            },
            observacion: dataInmunizations.observation,
          },
        },
      });
    }
  };

  loadHabits = (dataHabits) => {
    //Si el paciente consume drogas debe verificar cuales son
    var substances = [];
    if (dataHabits.bazuco === "Si") {
      substances.push("Bazuco");
    }
    if (dataHabits.cocaina === "Si") {
      substances.push("Cocaina");
    }
    if (dataHabits.extasis === "Si") {
      substances.push("Extasis");
    }
    if (dataHabits.extasis === "Si") {
      substances.push("Heroina");
    }
    if (dataHabits.hongos === "Si") {
      substances.push("Hongos");
    }
    if (dataHabits.lsd === "Si") {
      substances.push("LSD");
    }
    if (dataHabits.marihuana === "Si") {
      substances.push("Marihuana");
    }
    if (dataHabits.ghb === "Si") {
      substances.push("GHB");
    }

    if (dataHabits != null) {
      this.setState({
        sectionAilment: {
          ...this.state.sectionAilment,
          habits: {
            packegesPerYear: dataHabits.paquetes_anio,
            cigarretsPerDay: dataHabits.cigarillos_dia,
            yearStart: dataHabits.ano_inicio,
            yearEnd: dataHabits.ano_fin,
            years: dataHabits.tiempo_anios,
            firewood: dataHabits.humo_lena,
            smoke: dataHabits.fumador,
            comsuption: dataHabits.sustancia_psico,
            substaces: substances,
            substace: dataHabits.sustancias_otras,
            frecuency: dataHabits.sustancia_frecuencia,
            alcohol: dataHabits.alcohol,
            alcoholLastYear: dataHabits.alcohol_ultimo_anio,
            frecuencyAlcohol: dataHabits.alcohol_frecuencia,
            physicalActivity: dataHabits.actividad_fisica,
            frecuencyPhysicalActivity: dataHabits.alcohol_frecuencia,
            activities: dataHabits.actividades_cuales,
            nutricional: dataHabits.nutricional,
            timePhysicalActivity: dataHabits.actividad_tiempo,
          },
        },
      });
    }
  };

  loadSystemReview = () => {
    let id_admision = 0;
    if (this.state.stateClinicistory == true) {
      id_admision = this.props.data.id_admision;
    }
    var data = {
      id_historia: this.props.data.id_historia,
      id_admision: id_admision,
    };
    return new Promise((resolve, reject) => {
      fetch(process.env.REACT_APP_PUBLIC_URL + "sistemas/consultar", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
        body: JSON.stringify(data),
      })
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          if (data.existe) {
            var systemReview = data.contenido[data.contenido.length - 1];
            console.log("carga8voRevisionSistema", systemReview);
            this.setState(
              {
                SystemReview: {
                  ailments: [
                    {
                      ailment: ailmentsSystemReview[0],
                      commentary: systemReview.sintomas_generales,
                    },
                    {
                      ailment: ailmentsSystemReview[1],
                      commentary: systemReview.respiratorio,
                    },
                    {
                      ailment: ailmentsSystemReview[2],
                      commentary: systemReview.cardiovascular,
                    },
                    {
                      ailment: ailmentsSystemReview[3],
                      commentary: systemReview.gastrointestinal,
                    },
                    {
                      ailment: ailmentsSystemReview[4],
                      commentary: systemReview.genitourinario,
                    },
                    {
                      ailment: ailmentsSystemReview[5],
                      commentary: systemReview.osteomuscular,
                    },
                    {
                      ailment: ailmentsSystemReview[6],
                      commentary: systemReview.dermatologico,
                    },
                    {
                      ailment: ailmentsSystemReview[7],
                      commentary: systemReview.endocrino,
                    },
                    {
                      ailment: ailmentsSystemReview[8],
                      commentary: systemReview.neurologico,
                    },
                  ],
                },
              },
              () => {
                var { dispatch } = this.props;
                dispatch(
                  change(
                    "system-review-form",
                    "comment-Síntomas Generales",
                    systemReview.sintomas_generales
                  )
                );
                dispatch(
                  change(
                    "system-review-form",
                    "comment-Respiratorios",
                    systemReview.respiratorio
                  )
                );
                dispatch(
                  change(
                    "system-review-form",
                    "comment-Cardiovascular",
                    systemReview.cardiovascular
                  )
                );
                dispatch(
                  change(
                    "system-review-form",
                    "comment-Gastrointestinal",
                    systemReview.gastrointestinal
                  )
                );
                dispatch(
                  change(
                    "system-review-form",
                    "comment-Genitourinario",
                    systemReview.genitourinario
                  )
                );
                dispatch(
                  change(
                    "system-review-form",
                    "comment-Osteomuscular",
                    systemReview.osteomuscular
                  )
                );
                dispatch(
                  change(
                    "system-review-form",
                    "comment-Dermatologico",
                    systemReview.dermatologico
                  )
                );
                dispatch(
                  change(
                    "system-review-form",
                    "comment-Endocrino",
                    systemReview.endocrino
                  )
                );
                dispatch(
                  change(
                    "system-review-form",
                    "comment-Neurologico",
                    systemReview.neurologico
                  )
                );
              }
            );
            resolve(false);
          } else {
            console.log(data.contenido);
            resolve(false);
          }
        })
        .catch((error) => {
          console.error("Error:", error);
          reject(error);
        });
    });
  };

  loadPhysicalExam = (dataTemplates) => {
    if (!!this.props.data.historia_cerrada) {
      var data = {
        id_admision: this.props.data.id_admision,
      };
      return new Promise((resolve, reject) => {
        fetch(process.env.REACT_APP_PUBLIC_URL + "fisico/consultar-admision", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            authorization: "Bearer " + sessionStorage.getItem("token"),
          },
          body: JSON.stringify(data),
        })
          .then((response) => {
            return response.json();
          })
          .then((data) => {
            console.log(data);
            let weightFromProps = null;
            let heightFromProps = null;
            let genderFromProps = null;
            if (this.props.data !== undefined && this.props.data !== null) {
              weightFromProps =
                this.props.data.peso !== undefined &&
                this.props.data.peso !== null
                  ? parseInt(this.props.data.peso)
                  : null;
              heightFromProps =
                this.props.data.talla !== undefined &&
                this.props.data.talla !== null
                  ? parseFloat(this.props.data.talla)
                  : null;
              genderFromProps =
                this.props.data.sexo !== undefined &&
                this.props.data.sexo !== null
                  ? this.props.data.sexo
                  : null;
              console.log(
                "ChangeFromProps",
                isNaN(weightFromProps),
                isNaN(heightFromProps),
                genderFromProps
              );
            }

            if (data.existe) {
              var physicalExam = data.contenido[data.contenido.length - 1];
              console.log("carga7moExamenFisico", physicalExam);
              this.setState(
                {
                  PhysicalExam: {
                    gender: !!genderFromProps
                      ? genderFromProps
                      : physicalExam.genero,
                    weight: !!weightFromProps
                      ? weightFromProps
                      : physicalExam.peso,
                    //weight: this.props.data.peso,
                    abdominalPerimeter: physicalExam.peri_abdominal,
                    size: !!heightFromProps
                      ? heightFromProps
                      : physicalExam.talla,
                    //size: this.props.data.talla,
                    heartRate: physicalExam.frecuencia_cardiaca,
                    breathingFrequency: physicalExam.frecuencia_respiratoria,
                    temperature: physicalExam.temperatura,
                    bloodPressureMM: physicalExam.presion_arterial,
                    bloodPressureHg: physicalExam.presion_arterial2,
                    BMI: physicalExam.masa_corporal,
                    //BMI: (this.props.data.peso / (Math.pow((this.props.data.talla / 100), 2))).toFixed(2),
                    bodySurface: physicalExam.superficie_corporal,
                    dominance: physicalExam.dominancia,
                    generalFeatures: physicalExam.aspecto_general,
                    headAndFace: physicalExam.cabeza_cara,
                    ori: physicalExam.ori,
                    eyes: physicalExam.ojos,
                    neck: physicalExam.cuello,
                    chest: physicalExam.torax,
                    cardioVascular: physicalExam.cardiovascular,
                    pulmonary: physicalExam.pulmonar,
                    abdomen: physicalExam.abdomen,
                    limbs: physicalExam.extremidades,
                    neurological: physicalExam.neurologico,
                    genitourinary: physicalExam.genitourinario,
                    skin_appendages: physicalExam.piel_faneras,
                    otorhino: physicalExam.otorrino,
                  },
                },
                () => {
                  var { dispatch } = this.props;
                  dispatch(
                    change("physical-exam-form", "select-gender", {
                      value: physicalExam.genero,
                      label: physicalExam.genero,
                    })
                  );
                  dispatch(
                    change(
                      "physical-exam-form",
                      "comment-weight",
                      physicalExam.peso
                    )
                  );
                  dispatch(
                    change(
                      "physical-exam-form",
                      "abdominal-perimeter",
                      physicalExam.peri_abdominal
                    )
                  );
                  dispatch(
                    change("physical-exam-form", "size", physicalExam.talla)
                  );
                  dispatch(
                    change(
                      "physical-exam-form",
                      "body-mass-index",
                      physicalExam.masa_corporal
                    )
                  );
                  dispatch(
                    change(
                      "physical-exam-form",
                      "select-dominance",
                      physicalExam.dominancia
                    )
                  );
                  dispatch(
                    change(
                      "physical-exam-form",
                      "heart-rate",
                      physicalExam.frecuencia_cardiaca
                    )
                  );
                  dispatch(
                    change(
                      "physical-exam-form",
                      "breathing-frequency",
                      physicalExam.frecuencia_respiratoria
                    )
                  );
                  dispatch(
                    change(
                      "physical-exam-form",
                      "temperature",
                      physicalExam.temperatura
                    )
                  );
                  dispatch(
                    change(
                      "physical-exam-form",
                      "blood-pressure",
                      physicalExam.presion_arterial
                    )
                  );
                  dispatch(
                    change(
                      "physical-exam-form",
                      "textarea-general-features",
                      physicalExam.aspecto_general
                    )
                  );
                  dispatch(
                    change(
                      "physical-exam-form",
                      "textarea-head-face",
                      physicalExam.cabeza_cara
                    )
                  );
                  dispatch(
                    change(
                      "physical-exam-form",
                      "textarea-ori",
                      physicalExam.ori
                    )
                  );
                  dispatch(
                    change(
                      "physical-exam-form",
                      "textarea-eyes",
                      physicalExam.ojos
                    )
                  );
                  dispatch(
                    change(
                      "physical-exam-form",
                      "textarea-neck",
                      physicalExam.cuello
                    )
                  );
                  dispatch(
                    change(
                      "physical-exam-form",
                      "textarea-chest",
                      physicalExam.torax
                    )
                  );
                  dispatch(
                    change(
                      "physical-exam-form",
                      "textarea-cardiovascular",
                      physicalExam.cardiovascular
                    )
                  );
                  dispatch(
                    change(
                      "physical-exam-form",
                      "textarea-pulmonary",
                      physicalExam.pulmonar
                    )
                  );
                  dispatch(
                    change(
                      "physical-exam-form",
                      "textarea-abdomen",
                      physicalExam.abdomen
                    )
                  );
                  dispatch(
                    change(
                      "physical-exam-form",
                      "textarea-limbs",
                      physicalExam.extremidades
                    )
                  );
                  dispatch(
                    change(
                      "physical-exam-form",
                      "textarea-neurological",
                      physicalExam.ojos
                    )
                  );
                  dispatch(
                    change(
                      "physical-exam-form",
                      "textarea-genitourinary",
                      physicalExam.neurologico
                    )
                  );
                  dispatch(
                    change(
                      "physical-exam-form",
                      "textarea-skin-appendages",
                      physicalExam.piel_faneras
                    )
                  );
                  dispatch(
                    change(
                      "physical-exam-form",
                      "textarea-otorhino",
                      physicalExam.otorrino
                    )
                  );
                  this.caculateBMIandSurfaceBody();
                }
              );
              resolve(false);
            } else {
              try {
                if (dataTemplates != null && dataTemplates != undefined) {
                  let physicalExamTemplate = dataTemplates.examen_fisico;
                  if (
                    physicalExamTemplate != null &&
                    physicalExamTemplate != undefined
                  ) {
                    console.log("physicalExamTemplate", physicalExamTemplate);

                    this.setState(
                      {
                        PhysicalExam: {
                          ...this.state.PhysicalExam,
                          gender: !!genderFromProps ? genderFromProps : "",
                          weight: !!weightFromProps ? weightFromProps : "",
                          size: !!heightFromProps ? heightFromProps : "",
                          generalFeatures: physicalExamTemplate.generalFeatures,
                          headAndFace: physicalExamTemplate.headAndFace,
                          ori: physicalExamTemplate.ori,
                          eyes: physicalExamTemplate.eyes,
                          neck: physicalExamTemplate.neck,
                          chest: physicalExamTemplate.chest,
                          cardioVascular: physicalExamTemplate.cardioVascular,
                          pulmonary: physicalExamTemplate.pulmonary,
                          abdomen: physicalExamTemplate.abdomen,
                          limbs: physicalExamTemplate.limbs,
                          neurological: physicalExamTemplate.neurological,
                          genitourinary: physicalExamTemplate.genitourinary,
                          skin_appendages: physicalExamTemplate.skin_appendages,
                          otorhino: physicalExamTemplate.otorrino,
                        },
                      },
                      () => {
                        var { dispatch } = this.props;
                        dispatch(
                          change(
                            "physical-exam-form",
                            "textarea-general-features",
                            physicalExamTemplate.generalFeatures
                          )
                        );
                        dispatch(
                          change(
                            "physical-exam-form",
                            "textarea-head-face",
                            physicalExamTemplate.headAndFace
                          )
                        );
                        dispatch(
                          change(
                            "physical-exam-form",
                            "textarea-ori",
                            physicalExamTemplate.ori
                          )
                        );
                        dispatch(
                          change(
                            "physical-exam-form",
                            "textarea-eyes",
                            physicalExamTemplate.eyes
                          )
                        );
                        dispatch(
                          change(
                            "physical-exam-form",
                            "textarea-neck",
                            physicalExamTemplate.neck
                          )
                        );
                        dispatch(
                          change(
                            "physical-exam-form",
                            "textarea-chest",
                            physicalExamTemplate.chest
                          )
                        );
                        dispatch(
                          change(
                            "physical-exam-form",
                            "textarea-cardiovascular",
                            physicalExamTemplate.cardioVascular
                          )
                        );
                        dispatch(
                          change(
                            "physical-exam-form",
                            "textarea-pulmonary",
                            physicalExamTemplate.pulmonary
                          )
                        );
                        dispatch(
                          change(
                            "physical-exam-form",
                            "textarea-abdomen",
                            physicalExamTemplate.abdomen
                          )
                        );
                        dispatch(
                          change(
                            "physical-exam-form",
                            "textarea-limbs",
                            physicalExamTemplate.limbs
                          )
                        );
                        dispatch(
                          change(
                            "physical-exam-form",
                            "textarea-neurological",
                            physicalExamTemplate.neurological
                          )
                        );
                        dispatch(
                          change(
                            "physical-exam-form",
                            "textarea-genitourinary",
                            physicalExamTemplate.genitourinary
                          )
                        );
                        dispatch(
                          change(
                            "physical-exam-form",
                            "textarea-skin-appendages",
                            physicalExamTemplate.skin_appendages
                          )
                        );
                        dispatch(
                          change(
                            "physical-exam-form",
                            "textarea-otorhino",
                            this.state.PhysicalExam.otorhino
                          )
                        );
                        this.caculateBMIandSurfaceBody();
                      }
                    );
                  }
                }
                resolve(false);
              } catch (e) {
                resolve(false);
              }
            }
          })
          .catch((error) => {
            console.error("Error:", error);
            reject(error);
          });
      });
    } else {
      var data = {
        id_historia: this.props.data.id_historia,
        id_admision: this.props.data.id_admision,
      };
      return new Promise((resolve, reject) => {
        fetch(process.env.REACT_APP_PUBLIC_URL + "fisico/consultar", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            authorization: "Bearer " + sessionStorage.getItem("token"),
          },
          body: JSON.stringify(data),
        })
          .then((response) => {
            return response.json();
          })
          .then((data) => {
            console.log(data);
            let weightFromProps = null;
            let heightFromProps = null;
            let genderFromProps = null;
            if (this.props.data !== undefined && this.props.data !== null) {
              weightFromProps =
                this.props.data.peso !== undefined &&
                this.props.data.peso !== null
                  ? parseInt(this.props.data.peso)
                  : null;
              heightFromProps =
                this.props.data.talla !== undefined &&
                this.props.data.talla !== null
                  ? parseFloat(this.props.data.talla)
                  : null;
              genderFromProps =
                this.props.data.sexo !== undefined &&
                this.props.data.sexo !== null
                  ? this.props.data.sexo
                  : null;
              console.log(
                "ChangeFromProps",
                isNaN(weightFromProps),
                isNaN(heightFromProps),
                genderFromProps
              );
            }

            if (data.existe) {
              var physicalExam = data.contenido[data.contenido.length - 1];
              console.log("carga7moExamenFisico", physicalExam);
              this.setState(
                {
                  PhysicalExam: {
                    gender: !!genderFromProps
                      ? genderFromProps
                      : physicalExam.genero,
                    weight: !!weightFromProps
                      ? weightFromProps
                      : physicalExam.peso,
                    //weight: this.props.data.peso,
                    abdominalPerimeter: physicalExam.peri_abdominal,
                    size: !!heightFromProps
                      ? heightFromProps
                      : physicalExam.talla,
                    //size: this.props.data.talla,
                    heartRate: physicalExam.frecuencia_cardiaca,
                    breathingFrequency: physicalExam.frecuencia_respiratoria,
                    temperature: physicalExam.temperatura,
                    bloodPressureMM: physicalExam.presion_arterial,
                    bloodPressureHg: physicalExam.presion_arterial2,
                    BMI: physicalExam.masa_corporal,
                    //BMI: (this.props.data.peso / (Math.pow((this.props.data.talla / 100), 2))).toFixed(2),
                    bodySurface: physicalExam.superficie_corporal,
                    dominance: physicalExam.dominancia,
                    generalFeatures: physicalExam.aspecto_general,
                    headAndFace: physicalExam.cabeza_cara,
                    ori: physicalExam.ori,
                    eyes: physicalExam.ojos,
                    neck: physicalExam.cuello,
                    chest: physicalExam.torax,
                    cardioVascular: physicalExam.cardiovascular,
                    pulmonary: physicalExam.pulmonar,
                    abdomen: physicalExam.abdomen,
                    limbs: physicalExam.extremidades,
                    neurological: physicalExam.neurologico,
                    genitourinary: physicalExam.genitourinario,
                    skin_appendages: physicalExam.piel_faneras,
                    otorhino: physicalExam.otorrino,
                  },
                },
                () => {
                  var { dispatch } = this.props;
                  dispatch(
                    change("physical-exam-form", "select-gender", {
                      value: physicalExam.genero,
                      label: physicalExam.genero,
                    })
                  );
                  dispatch(
                    change(
                      "physical-exam-form",
                      "comment-weight",
                      physicalExam.peso
                    )
                  );
                  dispatch(
                    change(
                      "physical-exam-form",
                      "abdominal-perimeter",
                      physicalExam.peri_abdominal
                    )
                  );
                  dispatch(
                    change("physical-exam-form", "size", physicalExam.talla)
                  );
                  dispatch(
                    change(
                      "physical-exam-form",
                      "body-mass-index",
                      physicalExam.masa_corporal
                    )
                  );
                  dispatch(
                    change(
                      "physical-exam-form",
                      "select-dominance",
                      physicalExam.dominancia
                    )
                  );
                  dispatch(
                    change(
                      "physical-exam-form",
                      "heart-rate",
                      physicalExam.frecuencia_cardiaca
                    )
                  );
                  dispatch(
                    change(
                      "physical-exam-form",
                      "breathing-frequency",
                      physicalExam.frecuencia_respiratoria
                    )
                  );
                  dispatch(
                    change(
                      "physical-exam-form",
                      "temperature",
                      physicalExam.temperatura
                    )
                  );
                  dispatch(
                    change(
                      "physical-exam-form",
                      "blood-pressure",
                      physicalExam.presion_arterial
                    )
                  );
                  dispatch(
                    change(
                      "physical-exam-form",
                      "textarea-general-features",
                      physicalExam.aspecto_general
                    )
                  );
                  dispatch(
                    change(
                      "physical-exam-form",
                      "textarea-head-face",
                      physicalExam.cabeza_cara
                    )
                  );
                  dispatch(
                    change(
                      "physical-exam-form",
                      "textarea-ori",
                      physicalExam.ori
                    )
                  );
                  dispatch(
                    change(
                      "physical-exam-form",
                      "textarea-eyes",
                      physicalExam.ojos
                    )
                  );
                  dispatch(
                    change(
                      "physical-exam-form",
                      "textarea-neck",
                      physicalExam.cuello
                    )
                  );
                  dispatch(
                    change(
                      "physical-exam-form",
                      "textarea-chest",
                      physicalExam.torax
                    )
                  );
                  dispatch(
                    change(
                      "physical-exam-form",
                      "textarea-cardiovascular",
                      physicalExam.cardiovascular
                    )
                  );
                  dispatch(
                    change(
                      "physical-exam-form",
                      "textarea-pulmonary",
                      physicalExam.pulmonar
                    )
                  );
                  dispatch(
                    change(
                      "physical-exam-form",
                      "textarea-abdomen",
                      physicalExam.abdomen
                    )
                  );
                  dispatch(
                    change(
                      "physical-exam-form",
                      "textarea-limbs",
                      physicalExam.extremidades
                    )
                  );
                  dispatch(
                    change(
                      "physical-exam-form",
                      "textarea-neurological",
                      physicalExam.ojos
                    )
                  );
                  dispatch(
                    change(
                      "physical-exam-form",
                      "textarea-genitourinary",
                      physicalExam.neurologico
                    )
                  );
                  dispatch(
                    change(
                      "physical-exam-form",
                      "textarea-skin-appendages",
                      physicalExam.piel_faneras
                    )
                  );
                  dispatch(
                    change(
                      "physical-exam-form",
                      "textarea-otorhino",
                      physicalExam.otorrino
                    )
                  );
                  this.caculateBMIandSurfaceBody();
                }
              );
              resolve(false);
            } else {
              try {
                if (dataTemplates != null && dataTemplates != undefined) {
                  let physicalExamTemplate = dataTemplates.examen_fisico;
                  if (
                    physicalExamTemplate != null &&
                    physicalExamTemplate != undefined
                  ) {
                    console.log("physicalExamTemplate", physicalExamTemplate);

                    this.setState(
                      {
                        PhysicalExam: {
                          ...this.state.PhysicalExam,
                          gender: !!genderFromProps ? genderFromProps : "",
                          weight: !!weightFromProps ? weightFromProps : "",
                          size: !!heightFromProps ? heightFromProps : "",
                          generalFeatures: physicalExamTemplate.generalFeatures,
                          headAndFace: physicalExamTemplate.headAndFace,
                          ori: physicalExamTemplate.ori,
                          eyes: physicalExamTemplate.eyes,
                          neck: physicalExamTemplate.neck,
                          chest: physicalExamTemplate.chest,
                          cardioVascular: physicalExamTemplate.cardioVascular,
                          pulmonary: physicalExamTemplate.pulmonary,
                          abdomen: physicalExamTemplate.abdomen,
                          limbs: physicalExamTemplate.limbs,
                          neurological: physicalExamTemplate.neurological,
                          genitourinary: physicalExamTemplate.genitourinary,
                          skin_appendages: physicalExamTemplate.skin_appendages,
                          otorhino: physicalExamTemplate.otorrino,
                        },
                      },
                      () => {
                        var { dispatch } = this.props;
                        dispatch(
                          change(
                            "physical-exam-form",
                            "textarea-general-features",
                            physicalExamTemplate.generalFeatures
                          )
                        );
                        dispatch(
                          change(
                            "physical-exam-form",
                            "textarea-head-face",
                            physicalExamTemplate.headAndFace
                          )
                        );
                        dispatch(
                          change(
                            "physical-exam-form",
                            "textarea-ori",
                            physicalExamTemplate.ori
                          )
                        );
                        dispatch(
                          change(
                            "physical-exam-form",
                            "textarea-eyes",
                            physicalExamTemplate.eyes
                          )
                        );
                        dispatch(
                          change(
                            "physical-exam-form",
                            "textarea-neck",
                            physicalExamTemplate.neck
                          )
                        );
                        dispatch(
                          change(
                            "physical-exam-form",
                            "textarea-chest",
                            physicalExamTemplate.chest
                          )
                        );
                        dispatch(
                          change(
                            "physical-exam-form",
                            "textarea-cardiovascular",
                            physicalExamTemplate.cardioVascular
                          )
                        );
                        dispatch(
                          change(
                            "physical-exam-form",
                            "textarea-pulmonary",
                            physicalExamTemplate.pulmonary
                          )
                        );
                        dispatch(
                          change(
                            "physical-exam-form",
                            "textarea-abdomen",
                            physicalExamTemplate.abdomen
                          )
                        );
                        dispatch(
                          change(
                            "physical-exam-form",
                            "textarea-limbs",
                            physicalExamTemplate.limbs
                          )
                        );
                        dispatch(
                          change(
                            "physical-exam-form",
                            "textarea-neurological",
                            physicalExamTemplate.neurological
                          )
                        );
                        dispatch(
                          change(
                            "physical-exam-form",
                            "textarea-genitourinary",
                            physicalExamTemplate.genitourinary
                          )
                        );
                        dispatch(
                          change(
                            "physical-exam-form",
                            "textarea-skin-appendages",
                            physicalExamTemplate.skin_appendages
                          )
                        );
                        dispatch(
                          change(
                            "physical-exam-form",
                            "textarea-otorhino",
                            this.state.PhysicalExam.otorhino
                          )
                        );
                        this.caculateBMIandSurfaceBody();
                      }
                    );
                  }
                }
                resolve(false);
              } catch (e) {
                resolve(false);
              }
            }
          })
          .catch((error) => {
            console.error("Error:", error);
            reject(error);
          });
      });
    }
  };

  loadDiagnostic = () => {
    var data = {
      id_historia: this.props.data.id_historia,
      id_admision: this.props.data.id_admision,
    };
    return new Promise((resolve, reject) => {
      fetch(process.env.REACT_APP_PUBLIC_URL + "diagadmision/consultar", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
        body: JSON.stringify(data),
      })
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          console.log("diagnostico:");
          console.log(data);
          if (data.existe) {
            var diagnostic =
              data.contenido[data.contenido.length - 1].diagnostico.diagnostico;
            console.log(diagnostic);
            this.setState(
              {
                Diagnostic: {
                  ...this.state.Diagnostic,
                  dataOldDiagnostic: diagnostic,
                },
              },
              () => {
                var { dispatch } = this.props;
                dispatch(
                  change(
                    "diagnostic-form",
                    "comment-Síntomas Generales",
                    diagnostic.sintomas_generales
                  )
                );
                dispatch(
                  change(
                    "diagnostic-form",
                    "comment-Respiratorios",
                    diagnostic.respiratorio
                  )
                );
              }
            );
            resolve(false);
          } else {
            console.log(data.contenido);
            resolve(false);
          }
        })
        .catch((error) => {
          console.error("Error:", error);
          reject(error);
        });
    });
  };

  loadPatientDiagnosis = () => {
    return new Promise((resolve, reject) => {
      fetch(
        process.env.REACT_APP_PUBLIC_URL +
          "diagnostico/consulta-por-paciente?id_historia=" +
          this.props.data.id_historia,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            authorization: "Bearer " + sessionStorage.getItem("token"),
          },
        }
      )
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          console.log(data);
          if (data.diagnostico.length > 0) {
            console.log("carga2doDiagnostico", data.diagnostico);
            try {
              let allDiagnostics = data.diagnostico;
              let oldDiagnostics = allDiagnostics.filter(
                (diag) =>
                  diag.id_admision !== parseInt(this.props.data.id_admision)
              );
              let onlyOldDiagnostic = [];
              let onlyCurrentAdmisionDiagnostics = [];
              let generalObservation = "";
              if (!!oldDiagnostics.length) {
                oldDiagnostics[0].diagnostico.diagnostico.forEach((oldDiag) => {
                  let diagnisticInfo = oldDiag;
                  if (!!diagnisticInfo) {
                    onlyOldDiagnostic.push(diagnisticInfo);
                  }
                });
              }

              let currentAdmisionDiagnostics = allDiagnostics.filter(
                (diag) =>
                  diag.id_admision === parseInt(this.props.data.id_admision)
              );
              if (!!currentAdmisionDiagnostics.length) {
                generalObservation =
                  currentAdmisionDiagnostics[0].observaciones;
                currentAdmisionDiagnostics[0].diagnostico.diagnostico.map(
                  (currDiag) => {
                    let diagnisticInfo = currDiag;
                    if (!!diagnisticInfo) {
                      onlyCurrentAdmisionDiagnostics.push(diagnisticInfo);
                    }
                  }
                );
              }

              let observationList = onlyCurrentAdmisionDiagnostics.map(
                (diag) => diag.observacion
              );
              let typeList = onlyCurrentAdmisionDiagnostics.map(
                (diag) => diag.tipo
              );
              console.log(
                "onlyOldDiagnostic",
                onlyOldDiagnostic,
                "onlyCurrentAdmisionDiagnostics",
                onlyCurrentAdmisionDiagnostics
              );
              this.setState({
                Diagnostic: {
                  ...this.state.Diagnostic,
                  dataOldDiagnostic: onlyOldDiagnostic,
                  addedDiagnostics: onlyCurrentAdmisionDiagnostics,
                  generalObservation: generalObservation,
                  observations: observationList,
                  typesDiag: typeList,
                },
              });
            } catch (error) {
              console.log(error);
            }
            resolve(false);
          } else {
            //setPatiensDiagnosis(null);
            resolve(false);
          }
        })
        .catch((error) => {
          console.error("Error:", error);
          reject(error);
        });
    });
  };

  loadAnalysisAndMedicalPlan = () => {
    var data = {
      id_historia: this.props.data.id_historia,
    };
    return new Promise((resolve, reject) => {
      fetch(process.env.REACT_APP_PUBLIC_URL + "planmedico/consultar", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
        body: JSON.stringify(data),
      })
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          if (data.existe) {
            console.log("cargar analisis y plan medico !!", data.contenido);
            var analysisAndMedicalPlan =
              data.contenido[data.contenido.length - 1];
            this.setState(
              {
                AnalysisAndMedicalPlan: {
                  analysis: analysisAndMedicalPlan.analisis,
                  plan: analysisAndMedicalPlan.plan_medico,
                  recommendations: analysisAndMedicalPlan.recomendaciones,
                },
              },
              () => {
                var { dispatch } = this.props;
                dispatch(
                  change(
                    "analysis-and-medical-plan-form",
                    "textarea-analysis",
                    analysisAndMedicalPlan.analisis
                  )
                );
                dispatch(
                  change(
                    "analysis-and-medical-plan-form",
                    "textarea-medical-plan",
                    analysisAndMedicalPlan.plan_medico
                  )
                );
                dispatch(
                  change(
                    "analysis-and-medical-plan-form",
                    "textarea-recommendations",
                    analysisAndMedicalPlan.recomendaciones
                  )
                );
              }
            );
            resolve(false);
          } else {
            this.loadAnalysisAndMedicalPlanTemplate().then(
              (dataAnalysisAndMedicalPlanTemplate) => {
                this.setState(
                  {
                    AnalysisAndMedicalPlan: {
                      analysis:
                        dataAnalysisAndMedicalPlanTemplate !== undefined
                          ? dataAnalysisAndMedicalPlanTemplate.analisis
                          : "",
                      plan:
                        dataAnalysisAndMedicalPlanTemplate !== undefined
                          ? dataAnalysisAndMedicalPlanTemplate.plan_medico
                          : "",
                      recommendations:
                        dataAnalysisAndMedicalPlanTemplate !== undefined
                          ? dataAnalysisAndMedicalPlanTemplate.recomendaciones
                          : "",
                    },
                  },
                  () => {
                    var { dispatch } = this.props;
                    dispatch(
                      change(
                        "analysis-and-medical-plan-form",
                        "textarea-analysis",
                        dataAnalysisAndMedicalPlanTemplate !== undefined
                          ? dataAnalysisAndMedicalPlanTemplate.analisis
                          : ""
                      )
                    );
                    dispatch(
                      change(
                        "analysis-and-medical-plan-form",
                        "textarea-medical-plan",
                        dataAnalysisAndMedicalPlanTemplate !== undefined
                          ? dataAnalysisAndMedicalPlanTemplate.plan_medico
                          : ""
                      )
                    );
                    dispatch(
                      change(
                        "analysis-and-medical-plan-form",
                        "textarea-recommendations",
                        dataAnalysisAndMedicalPlanTemplate !== undefined
                          ? dataAnalysisAndMedicalPlanTemplate.recomendaciones
                          : ""
                      )
                    );
                  }
                );
              }
            );
            console.log(data.contenido);
            resolve(false);
          }
        })
        .catch((error) => {
          console.error("Error:", error);
          reject(error);
        });
    });
  };

  loadAnalysisAndMedicalPlanPorAdmision = () => {
    var data = {
      id_admision: parseInt(this.props.data.id_admision),
    };
    return new Promise((resolve, reject) => {
      fetch(
        process.env.REACT_APP_PUBLIC_URL + "planmedico/consultar-admision",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            authorization: "Bearer " + sessionStorage.getItem("token"),
          },
          body: JSON.stringify(data),
        }
      )
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          if (data.existe) {
            console.log("cargar analisis y plan medico !!", data.contenido);
            var analysisAndMedicalPlan =
              data.contenido[data.contenido.length - 1];
            this.setState(
              {
                AnalysisAndMedicalPlan: {
                  analysis: analysisAndMedicalPlan.analisis,
                  plan: analysisAndMedicalPlan.plan_medico,
                  recommendations: analysisAndMedicalPlan.recomendaciones,
                },
              },
              () => {
                var { dispatch } = this.props;
                dispatch(
                  change(
                    "analysis-and-medical-plan-form",
                    "textarea-analysis",
                    analysisAndMedicalPlan.analisis
                  )
                );
                dispatch(
                  change(
                    "analysis-and-medical-plan-form",
                    "textarea-medical-plan",
                    analysisAndMedicalPlan.plan_medico
                  )
                );
                dispatch(
                  change(
                    "analysis-and-medical-plan-form",
                    "textarea-recommendations",
                    analysisAndMedicalPlan.recomendaciones
                  )
                );
              }
            );
            resolve(false);
          } else {
            this.loadAnalysisAndMedicalPlanTemplate().then(
              (dataAnalysisAndMedicalPlanTemplate) => {
                this.setState(
                  {
                    AnalysisAndMedicalPlan: {
                      analysis:
                        dataAnalysisAndMedicalPlanTemplate !== undefined
                          ? dataAnalysisAndMedicalPlanTemplate.analisis
                          : "",
                      plan:
                        dataAnalysisAndMedicalPlanTemplate !== undefined
                          ? dataAnalysisAndMedicalPlanTemplate.plan_medico
                          : "",
                      recommendations:
                        dataAnalysisAndMedicalPlanTemplate !== undefined
                          ? dataAnalysisAndMedicalPlanTemplate.recomendaciones
                          : "",
                    },
                  },
                  () => {
                    var { dispatch } = this.props;
                    dispatch(
                      change(
                        "analysis-and-medical-plan-form",
                        "textarea-analysis",
                        dataAnalysisAndMedicalPlanTemplate !== undefined
                          ? dataAnalysisAndMedicalPlanTemplate.analisis
                          : ""
                      )
                    );
                    dispatch(
                      change(
                        "analysis-and-medical-plan-form",
                        "textarea-medical-plan",
                        dataAnalysisAndMedicalPlanTemplate !== undefined
                          ? dataAnalysisAndMedicalPlanTemplate.plan_medico
                          : ""
                      )
                    );
                    dispatch(
                      change(
                        "analysis-and-medical-plan-form",
                        "textarea-recommendations",
                        dataAnalysisAndMedicalPlanTemplate !== undefined
                          ? dataAnalysisAndMedicalPlanTemplate.recomendaciones
                          : ""
                      )
                    );
                  }
                );
              }
            );
            console.log(data.contenido);
            resolve(false);
          }
        })
        .catch((error) => {
          console.error("Error:", error);
          reject(error);
        });
    });
  };

  loadAnalysisAndMedicalPlanTemplate = () => {
    return new Promise((resolve, reject) => {
      fetch(
        process.env.REACT_APP_PUBLIC_URL +
          "pantillas-analisis-plan-medico/listar",
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            authorization: "Bearer " + sessionStorage.getItem("token"),
          },
        }
      )
        .then((response) => {
          if (response.status != 500 && response.status != 403) {
            return response.json();
          } else {
            throw new Error("Ha ocurrido un error en el Servidor");
          }
        })
        .then((data) => {
          resolve(data[0]);
        })
        .catch((error) => {
          console.log("Plan Medico error:", error);
          resolve(null);
        });
    });
  };

  loadMedicalOrders = () => {
    //Formula
    var data = {
      id_historia: this.props.data.id_historia,
      id_admision: this.props.data.id_admision,
    };
    return new Promise((resolve, reject) => {
      fetch(process.env.REACT_APP_PUBLIC_URL + "tratadmision/consultar", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
        body: JSON.stringify(data),
      })
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          if (data.existe) {
            let tratamientos = data.contenido[0].tratamiento.tratamiento;
            const uniqueFormulas = [];
            const unique = tratamientos.filter((element) => {
              const isDuplicate = uniqueFormulas.find(
                (formu) => formu.principio_activo === element.principio_activo
              );
              if (!isDuplicate) {
                uniqueFormulas.push(element);
                return true;
              }
              return false;
            });

            //this.state.sectionAilment.inmunizations.inmunizaciones.table
            //this.state.MedicalOrders.formulas
            this.setState({
              MedicalOrders: {
                ...this.state.MedicalOrders,
                observations: [],
                /* medicalObservation: data.contenido[0].ordenes.ordenes.medicalObservation != undefined ? data.contenido[0].ordenes.ordenes.medicalObservation : "",
                observationAndProcedure: data.contenido[0].ordenes.ordenes.observationAndProcedure != undefined ? data.contenido[0].ordenes.ordenes.observationAndProcedure : "",
                addedDiagnostics: data.contenido[0].ordenes.ordenes.addedDiagnostics, */
                formulas: unique.map((tratamiento) => {
                  return {
                    activePrinciple: tratamiento.principio_activo,
                    concentration: tratamiento.concentracion,
                    dose: tratamiento.dosis,
                    route: tratamiento.via_administracion,
                    pharmaceuticalForm: tratamiento.forma_farmaceutica,
                    frequency: tratamiento.frecuencia,
                    duration: tratamiento.duracion,
                    units: tratamiento.unidades_requeridas,
                    admissioDate: data.contenido[0].fecha_admision,
                    otherFrequency: tratamiento.otra_frecuencia,
                  };
                }),
              },
            });
            resolve(false);
          } else {
            console.log(data.contenido);
            resolve(false);
          }
        })
        .catch((error) => {
          console.error("Error:", error);
          reject(error);
        });
    });
  };

  loadMedicalOrdersByIdAdmssion = () => {
    var data = {
      id_admision: this.props.data.id_admision,
    };
    return new Promise((resolve, reject) => {
      fetch(
        process.env.REACT_APP_PUBLIC_URL + "tratadmision/consultarPorAdmision",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            authorization: "Bearer " + sessionStorage.getItem("token"),
          },
          body: JSON.stringify(data),
        }
      )
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          if (data.existe) {
            // console.log("carga medicamento con admision", data.contenido[0]);
            /*let tratamientos = data.contenido[0];

             const uniqueFormulas = [];
            const unique = tratamientos.tratamiento.tratamiento.filter(element => {
              const isDuplicate = uniqueFormulas.find(formu => formu.principio_activo === element.principio_activo);
              if (!isDuplicate) {
                uniqueFormulas.push(element);
                return true;
              }
              return false;
            }); */

            //this.state.sectionAilment.pharmacological.farmacologico.table

            let observationsCharged = data.contenido[0].observaciones;
            let res = observationsCharged.replace(/[\\{}""]/g, "");
            let observationsMedicalOrCon = res.split(",");
            let amounts = data.contenido[0].cantidad;
            let resCant = !!amounts ? amounts.replace(/[\\{}""]/g, "") : "";
            let amountMedicalOrCon = resCant.split(",");
            this.setState({
              MedicalOrders: {
                ...this.state.MedicalOrders,
                observations: observationsMedicalOrCon,
                amount: amountMedicalOrCon,
                medicalObservation:
                  data.contenido[0].ordenes.ordenes.medicalObservation !=
                  undefined
                    ? data.contenido[0].ordenes.ordenes.medicalObservation
                    : "",
                observationAndProcedure:
                  data.contenido[0].ordenes.ordenes.observationAndProcedure !=
                  undefined
                    ? data.contenido[0].ordenes.ordenes.observationAndProcedure
                    : "",
                addedDiagnostics:
                  data.contenido[0].ordenes.ordenes.addedDiagnostics,
                /* formulas: unique.map((tratamiento) => {
                  var nuevoTratamiento = {};
                  nuevoTratamiento.activePrinciple = tratamiento.principio_activo;
                  nuevoTratamiento.concentration = tratamiento.concentracion;
                  nuevoTratamiento.dose = tratamiento.dosis;
                  nuevoTratamiento.route = tratamiento.via_administracion;
                  nuevoTratamiento.pharmaceuticalForm = tratamiento.forma_farmaceutica;
                  nuevoTratamiento.frequency = tratamiento.frecuencia;
                  nuevoTratamiento.duration = tratamiento.duracion;
                  nuevoTratamiento.units = tratamiento.unidades_requeridas;
                  return nuevoTratamiento;
                }) */
              },
            });
            resolve(false);
          } else {
            console.log(data.contenido);
            resolve(false);
          }
        })
        .catch((error) => {
          console.error("Error:", error);
          reject(error);
        });
    });
  };

  getDataFiles = () => {
    let dataSend = {
      id_historia: parseInt(this.props.data.id_historia),
      id_admision: parseInt(this.props.data.id_admision),
    };

    return new Promise((resolve, reject) => {
      fetch(process.env.REACT_APP_PUBLIC_URL + "archivos/consultar", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
        body: JSON.stringify(dataSend),
      })
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          console.log(data.contenido[0].archivos);
          if (data.existe) {
            this.setState({
              sourceDocuments: data.contenido[0].archivos,
            });
          }
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    });
  };

  loadMedicalProcedures = () => {
    var data = {
      id_historia: this.props.data.id_historia,
      id_admision: this.props.data.id_admision,
    };
    return new Promise((resolve, reject) => {
      fetch(process.env.REACT_APP_PUBLIC_URL + "procedimientos/consultar", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
        body: JSON.stringify(data),
      })
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          console.log("existenciaProc", data.existe);
          if (data.existe) {
            var procedures = data.contenido[data.contenido.length - 1];
            console.log("carga5toOtrosProcedimientos", procedures);
            this.setState(
              {
                MedicalProceduresExist: true,
              },
              () => {
                this.existMedicalProcedures = true;
              }
            );
            resolve(procedures);
          } else {
            console.log(data.contenido);
            resolve(null);
          }
        })
        .catch((error) => {
          console.error("Error:", error);
          reject(error);
        });
    });
  };

  dispatchFieldsMedicalProcedures = (procedures) => {
    var { dispatch } = this.props;
    dispatch(
      change(
        "medical-procedures-form",
        "textarea-conclusions-TEST",
        procedures.prueba.prueba[0].conclusiones
      )
    );
    dispatch(
      change(
        "medical-procedures-form",
        "textarea-conclusion-TEST",
        procedures.prueba.prueba[0].conclusion
      )
    );
  };

  handlerAilment = (ailment, section, sectionIndex, index) => {
    var ailments = this.state.sectionAilment.ailments;
    ailments[sectionIndex][section][index] = {
      ...ailments[sectionIndex][section][index],
      value: ailment,
    };
    this.setState({
      sectionAilment: { ...this.state.sectionAilment, ailments: ailments },
    });
  };

  handlerCommentary = (commentary, section, sectionIndex, index) => {
    var ailments = this.state.sectionAilment.ailments;
    ailments[sectionIndex][section][index] = {
      ...ailments[sectionIndex][section][index],
      commentary: commentary,
    };
    this.setState({
      sectionAilment: { ...this.state.sectionAilment, ailments: ailments },
    });
  };

  handlerComments = (commentary, sectionIndex) => {
    var commentary = this.state.sectionAilment.commentary;
    commentary[sectionIndex] = commentary;
    this.setState({
      sectionAilment: { ...this.state.sectionAilment, commentary: commentary },
    });
  };

  handlerCommentsSystemReview = (commentary, index) => {
    var ailments = this.state.SystemReview.ailments;
    ailments[index].commentary = commentary;
    this.setState({ SystemReview: { ailments: ailments } });
  };

  handlerAnalysis = (analysis) => {
    this.setState({
      AnalysisAndMedicalPlan: {
        ...this.state.AnalysisAndMedicalPlan,
        analysis: analysis,
      },
    });
  };

  handlerPlan = (plan) => {
    this.setState({
      AnalysisAndMedicalPlan: {
        ...this.state.AnalysisAndMedicalPlan,
        plan: plan,
      },
    });
  };

  handlerRecommendations = (recommendations) => {
    this.setState({
      AnalysisAndMedicalPlan: {
        ...this.state.AnalysisAndMedicalPlan,
        recommendations: recommendations,
      },
    });
  };

  handlerPhysicalExam = (physicalName, value) => {
    if (physicalName == "bloodPressureMM" || physicalName == "bloodPressureHg")
      this.setState({
        PhysicalExam: {
          ...this.state.PhysicalExam,
          [physicalName]: value.slice(0, 3),
        },
      });
    else
      this.setState({
        PhysicalExam: { ...this.state.PhysicalExam, [physicalName]: value },
      });
  };

  handlerWeight = (weight) => {
    this.setState(
      { PhysicalExam: { ...this.state.PhysicalExam, weight: weight } },
      () => {
        this.caculateBMIandSurfaceBody();
      }
    );
  };

  handlerObservation = (obser) => {
    this.setState({
      sectionAilment: { ...this.state.sectionAilment, observations: obser },
    });
  };

  handlerAlimentTable = (table, section, sectionIndex, index) => {
    var ailments = this.state.sectionAilment.ailments;
    ailments[sectionIndex][section][index] = {
      ...ailments[sectionIndex][section][index],
      table: table,
    };
    this.setState({
      sectionAilment: { ...this.state.sectionAilment, ailments: ailments },
    });
  };

  handlerSize = (size) => {
    this.setState(
      { PhysicalExam: { ...this.state.PhysicalExam, size: size } },
      () => {
        this.caculateBMIandSurfaceBody();
      }
    );
  };

  calculateSurfaceBody = () => {
    var SC = Math.sqrt(
      (this.state.PhysicalExam.weight * this.state.PhysicalExam.size) / 3600
    );
    this.setState({
      PhysicalExam: { ...this.state.PhysicalExam, bodySurface: SC },
    });
  };

  caculateBMIandSurfaceBody = () => {
    if (
      this.state.PhysicalExam.weight !== 0 &&
      this.state.PhysicalExam.size !== 0
    ) {
      let isDecimal = this.state.PhysicalExam.size % 1 !== 0;
      let height = isDecimal
        ? this.state.PhysicalExam.size
        : this.state.PhysicalExam.size / 100;
      let heightForSC = isDecimal
        ? this.state.PhysicalExam.size * 100
        : this.state.PhysicalExam.size;
      var BMI = (this.state.PhysicalExam.weight / Math.pow(height, 2)).toFixed(
        2
      );
      var SC = Math.sqrt(
        (this.state.PhysicalExam.weight * heightForSC) / 3600
      ).toFixed(2);
      this.setState(
        {
          imc: BMI,
          bodySurface: SC,
          PhysicalExam: {
            ...this.state.PhysicalExam,
            BMI: BMI,
            bodySurface: SC,
          },
        },
        () => {
          console.log(
            "weight",
            this.state.PhysicalExam.weight,
            "height",
            this.state.PhysicalExam.size,
            "IMC ",
            this.state.PhysicalExam.BMI,
            " bodySurface",
            this.state.PhysicalExam.bodySurface,
            "isDecimal",
            isDecimal
          );
        }
      );
    }
  };

  handlerCUPS = (cups) => {
    this.setState({ Diagnostic: { ...this.state.Diagnostic, cups: cups } });
  };

  handlerDiagnosticName = (name) => {
    this.setState({ Diagnostic: { ...this.state.Diagnostic, name: name } });
  };

  handlerMedicalOrdersCUPS = (cups) => {
    this.setState({
      MedicalOrders: { ...this.state.MedicalOrders, cups: cups },
    });
  };

  handlerMedicalOrdersDiagnosticName = (name) => {
    this.setState({
      MedicalOrders: { ...this.state.MedicalOrders, name: name },
    });
  };

  handlerAddObservationDiagnostic = (index, observation) => {
    var observations = this.state.Diagnostic.observations;
    observations[index] = observation;
    this.setState({
      Diagnostic: { ...this.state.Diagnostic, observations: observations },
    });
  };

  handlerAddTypeDiagnostic = (index, type) => {
    var typeDiag = this.state.Diagnostic.typesDiag;
    typeDiag[index] = type;
    this.setState({
      Diagnostic: { ...this.state.Diagnostic, typesDiag: typeDiag },
    });
  };

  handlerAddObservation = (index, observation) => {
    var observations = this.state.MedicalOrders.observations;
    observations[index] = observation;
    this.setState({
      MedicalOrders: {
        ...this.state.MedicalOrders,
        observations: observations,
      },
    });
  };

  handlerAmountExams = (index, cantidad) => {
    var amount = this.state.MedicalOrders.amount;
    amount[index] = cantidad;
    this.setState({
      MedicalOrders: { ...this.state.MedicalOrders, amount: amount },
    });
  };

  handlerMedicalOrderTime = (time) => {
    this.setState({
      MedicalOrders: { ...this.state.MedicalOrders, time: time },
    });
  };

  searchMedicalOrders = () => {
    var data = {
      cupscod: this.state.MedicalOrders.cups,
      cupsnom: this.state.MedicalOrders.name,
    };
    console.log(data);
    return new Promise((resolve, reject) => {
      fetch(process.env.REACT_APP_PUBLIC_URL + "cups/consultar", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
        body: JSON.stringify(data),
      })
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          console.log(data);
          if (data.existe) {
            resolve(data.contenido);
          } else {
            alert(data.contenido);
            resolve([]);
          }
        })
        .catch((error) => {
          console.error("Error:", error);
          resolve(error);
        });
    });
  };

  searchMedicaments = (name) => {
    var data = {
      principio_activo: name,
    };

    return new Promise((resolve, reject) => {
      fetch(process.env.REACT_APP_PUBLIC_URL + "medicamento/consultar", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
        body: JSON.stringify(data),
      })
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          console.log(data);
          if (data.existe) {
            resolve(data.contenido);
          } else {
            resolve([]);
          }
        })
        .catch((error) => {
          console.error("Error:", error);
          resolve(error);
        });
    });
  };

  searchDiagnostic = (name, cups) => {
    this.setState({
      Diagnostic: { ...this.state.Diagnostic, name: name, cups: cups },
    });

    var data = {
      cupscod: cups,
      cupsnom: name,
    };
    console.log(data);

    return new Promise((resolve, reject) => {
      fetch(process.env.REACT_APP_PUBLIC_URL + "cups/consultar", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
        body: JSON.stringify(data),
      })
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          console.log(data);
          if (data.existe) {
            resolve(data.contenido);
          } else {
            resolve([]);
          }
        })
        .catch((error) => {
          console.error("Error:", error);
          resolve(error);
        });
    });
  };

  searchCIE = (name, code) => {
    this.setState({
      Diagnostic: { ...this.state.Diagnostic, codigo: code, nombre: name },
    });

    var data = {
      codigo: code.toUpperCase(),
      nombre: name,
    };

    return new Promise((resolve, reject) => {
      fetch(process.env.REACT_APP_PUBLIC_URL + "cie10/consultar", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
        body: JSON.stringify(data),
      })
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          if (data.existe) {
            resolve(data.contenido);
          } else {
            resolve([]);
          }
        })
        .catch((error) => {
          console.error("Error:", error);
          resolve(error);
        });
    });
  };

  searchMedications = (section, name, code) => {
    console.log(this.state.MedicalProcedures[section]);
    var data = {
      codigo: code,
      nombre: name,
    };
    console.log(data);
    return new Promise((resolve, reject) => {
      fetch(process.env.REACT_APP_PUBLIC_URL + "medidci/consultar", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
        body: JSON.stringify(data),
      })
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          console.log(data);
          if (data.existe) {
            resolve(data.contenido);
          } else {
            resolve([]);
          }
        })
        .catch((error) => {
          console.error("Error:", error);
          resolve(error);
        });
    });
  };

  selectDiagnostic = (diagnostic) => {
    this.setState({
      Diagnostic: { ...this.state.Diagnostic, diagnostic: diagnostic },
    });
  };

  selectMedicament = (section, medicament) => {
    this.setState({
      MedicalProcedures: {
        ...this.state.MedicalProcedures,
        [section]: {
          ...this.state.MedicalProcedures[section],
          medicament: medicament,
        },
      },
    });
  };

  selectMedicalOrdersDiagnostic = (diagnostic) => {
    this.setState({
      MedicalOrders: { ...this.state.MedicalOrders, diagnostic: diagnostic },
    });
  };

  addDiagnostic = (diagnostic) => {
    console.log(diagnostic);
    this.setState({
      Diagnostic: {
        ...this.state.Diagnostic,
        addedDiagnostics: [
          ...this.state.Diagnostic.addedDiagnostics,
          diagnostic,
        ],
      },
    });
  };

  addMedicament = (section, medicament) => {
    this.setState({
      MedicalProcedures: {
        ...this.state.MedicalProcedures,
        [section]: {
          ...this.state.MedicalProcedures[section],
          addedMedicaments: [
            ...this.state.MedicalProcedures[section].addedMedicaments,
            medicament,
          ],
        },
      },
    });
  };

  removeDiagnostic = (index) => {
    var addedDiagnostics = this.state.Diagnostic.addedDiagnostics;
    addedDiagnostics = addedDiagnostics.filter((value, indexDiag) => {
      return indexDiag !== index;
    });
    var observations = this.state.Diagnostic.observations;
    observations = observations.filter((value, indexDiag) => {
      return indexDiag !== index;
    });
    let typesDiagnostic = this.state.Diagnostic.typesDiag;
    typesDiagnostic = typesDiagnostic.filter(
      (value, indexDiag) => indexDiag !== index
    );
    this.setState({
      Diagnostic: {
        ...this.state.Diagnostic,
        addedDiagnostics: addedDiagnostics,
        observations: observations,
        typesDiag: typesDiagnostic,
      },
    });
  };

  handlerDiagnosticGeneralObervation = (observation) => {
    this.setState({
      Diagnostic: { ...this.state.Diagnostic, generalObservation: observation },
    });
  };

  removeMedicament = (section, index) => {
    var addedMedicaments =
      this.state.MedicalProcedures[section].addedMedicaments;
    addedMedicaments = addedMedicaments.filter((value, indexDiag) => {
      return indexDiag !== index;
    });
    this.setState({
      MedicalProcedures: {
        ...this.state.MedicalProcedures,
        [section]: {
          ...this.state.MedicalProcedures[section],
          addedMedicaments: addedMedicaments,
        },
      },
    });
  };

  addMedicalOrderDiagnostic = (diagnostic) => {
    let defaultObservation = "";
    let currentAmounts = this.state.MedicalOrders.amount;
    let currentObservations = this.state.MedicalOrders.observations;
    if (!Array.isArray(diagnostic)) {
      this.setState(
        {
          MedicalOrders: {
            ...this.state.MedicalOrders,
            addedDiagnostics: [
              ...this.state.MedicalOrders.addedDiagnostics,
              diagnostic,
            ],
          },
        },
        () => {
          let serachIdx = this.state.MedicalOrders.addedDiagnostics.findIndex(
            (serv) => serv.cupscod.toString() === diagnostic.cupscod.toString()
          );
          if (serachIdx >= 0) {
            currentAmounts[serachIdx] = !!currentAmounts[serachIdx]
              ? currentAmounts[serachIdx] !== "1"
                ? currentAmounts[serachIdx]
                : "1"
              : "1";
            currentObservations[serachIdx] =
              currentObservations[serachIdx] ?? defaultObservation;
            this.setState({
              MedicalOrders: {
                ...this.state.MedicalOrders,
                amount: currentAmounts,
                observations: currentObservations,
              },
            });
          }
        }
      );
    } else {
      let newServices = [
        ...this.state.MedicalOrders.addedDiagnostics,
        ...diagnostic,
      ];
      console.log({ newServices });
      const uniqueServs = [];
      let uniquesServices = newServices.filter((serv) => {
        console.log({ serv });
        let searchServ = uniqueServs.find((sevUniq) => {
          console.log({ sevUniq });
          if (!!sevUniq) return sevUniq.cupscod === serv.cupscod;
        });
        if (!searchServ) {
          uniqueServs.push(searchServ);
          return true;
        } else {
          return false;
        }
      });
      console.log({ uniquesServices });
      this.setState(
        {
          MedicalOrders: {
            ...this.state.MedicalOrders,
            addedDiagnostics: uniquesServices,
          },
        },
        () => {
          uniquesServices.forEach((servToAdd) => {
            let serachIdx = this.state.MedicalOrders.addedDiagnostics.findIndex(
              (serv) => serv.cupscod.toString() === servToAdd.cupscod.toString()
            );
            if (serachIdx >= 0) {
              currentAmounts[serachIdx] = !!currentAmounts[serachIdx]
                ? currentAmounts[serachIdx] !== "1"
                  ? currentAmounts[serachIdx]
                  : "1"
                : "1";
              currentObservations[serachIdx] =
                currentObservations[serachIdx] ?? defaultObservation;
              this.setState({
                MedicalOrders: {
                  ...this.state.MedicalOrders,
                  amount: currentAmounts,
                  observations: currentObservations,
                },
              });
            }
          });
        }
      );
    }
  };

  removeMedicalOrderDiagnostic = (index) => {
    var addedDiagnostics = this.state.MedicalOrders.addedDiagnostics;
    addedDiagnostics = addedDiagnostics.filter((value, indexDiag) => {
      return indexDiag !== index;
    });
    var observations = this.state.MedicalOrders.observations;
    console.log(observations);
    observations = observations.filter((value, indexDiag) => {
      return indexDiag !== index;
    });
    let amounts = this.state.MedicalOrders.amount;
    amounts = amounts.filter((value, indexDiag) => indexDiag !== index);
    this.setState({
      MedicalOrders: {
        ...this.state.MedicalOrders,
        addedDiagnostics: addedDiagnostics,
        observations: observations,
        amount: amounts,
      },
    });
  };

  handlerFormulasNew = (formula, reset) => {
    var formulas = this.state.MedicalOrders.formulas;
    formulas.push(formula);
    this.setState(
      { MedicalOrders: { ...this.state.MedicalOrders, formulas: formulas } },
      () => {
        reset();
      }
    );
  };

  handlerFormulasNewFunctional = (formula) => {
    let formulas = this.state.MedicalOrders.formulas;
    let searchIfFormulaIsAlreadyInFormulasToSend = formulas.find(
      (form) => form.activePrinciple === formula.activePrinciple
    );
    if (!searchIfFormulaIsAlreadyInFormulasToSend) {
      console.log(
        "formulaComing",
        formula,
        "formulasOld",
        this.state.MedicalOrders.formulas,
        "formulasNew",
        formulas
      );
      formulas.push(formula);
    }
    this.setState({
      MedicalOrders: { ...this.state.MedicalOrders, formulas: formulas },
    });
  };

  onEditFormulaFromMedicalOrders = (indexFromTable, formula) => {
    let formulas = this.state.MedicalOrders.formulas;
    let findFormula = formulas.find(
      (formu, index) =>
        index === indexFromTable &&
        formu.activePrinciple === formula.activePrinciple
    );
    formulas[indexFromTable] = formula;
    this.setState({
      MedicalOrders: { ...this.state.MedicalOrders, formulas: formulas },
    });
  };

  handlerSharedFormulasToMedicalOrders = (formula) => {
    let formulas = this.state.MedicalOrders.formulas;
    formulas.push(formula);
    //this.setState({sharedFormulas: {...this.state.sharedFormulas, formula}})
    this.setState({
      MedicalOrders: { ...this.state.MedicalOrders, formulas: formulas },
    });
  };

  removeFormula = () => {
    var formulas = this.state.MedicalOrders.formulas;
    formulas.pop();
    this.setState({
      MedicalOrders: { ...this.state.MedicalOrders, formulas: formulas },
    });
  };
  removeFormulaByIndex = (indexComing) => {
    console.log("indexComing", indexComing);
    let formulas = this.state.MedicalOrders.formulas;
    let newFormulas = formulas.filter((formu, index) => indexComing !== index);
    console.log("newFormulas", newFormulas);
    this.setState({
      MedicalOrders: { ...this.state.MedicalOrders, formulas: newFormulas },
    });
  };

  handlerMedicalProcedures = (
    section,
    variable,
    value,
    vartToChange,
    nameTemplete
  ) => {
    this.setState({
      MedicalProcedures: {
        ...this.state.MedicalProcedures,
        [section]: {
          ...this.state.MedicalProcedures[section],
          [variable]: value,
          [vartToChange]: nameTemplete,
        },
      },
    });
  };

  handlerDefineNameTemplMedicalProcedures = (section, variable, value) => {
    this.setState({
      MedicalProcedures: {
        ...this.state.MedicalProcedures,
        [section]: {
          ...this.state.MedicalProcedures[section],
          [variable]: value,
        },
      },
    });
  };

  handlerMedications = (section, variable, value) => {
    this.setState({
      MedicalProcedures: {
        ...this.state.MedicalProcedures,
        [section]: {
          ...this.state.MedicalProcedures[section],
          cie: {
            ...this.state.MedicalProcedures[section].cie,
            [variable]: value,
          },
        },
      },
    });
  };

  validateClinicHistory = () => {
    var errors = {
      anamesis: {},
      analysisAndMedicalPlan: {},
      habits: {},
    };

    if (
      !this.state.anamesis.cause &&
      (this.state.hiddenQuerysTabs == false ||
        this.state.hiddenAnamnesis == false)
    ) {
      errors.anamesis.cause = "Ingrese un anamesis";
    } else {
      delete errors.anamesis.cause;
    }

    if (
      !this.state.anamesis.reasonForConsultation &&
      (this.state.hiddenQuerysTabs == false ||
        this.state.hiddenAnamnesis == false)
    ) {
      errors.anamesis.reasonForConsultation = "Ingrese la razón de la consulta";
    } else {
      delete errors.anamesis.reasonForConsultation;
    }

    if (
      !this.state.anamesis.currentIllness &&
      (this.state.hiddenQuerysTabs == false ||
        this.state.hiddenAnamnesis == false)
    ) {
      errors.anamesis.currentIllness = "Ingrese la enfermedad actual";
    } else {
      delete errors.anamesis.currentIllness;
    }

    if (Object.keys(errors.anamesis).length === 0) {
      delete errors.anamesis;
    }

    if (
      !this.state.AnalysisAndMedicalPlan.analysis &&
      this.state.hiddenQuerysTabs == false
    ) {
      errors.analysisAndMedicalPlan.analysis = "Ingrese un analisis";
    } else {
      delete errors.analysisAndMedicalPlan.analysis;
    }

    if (
      !this.state.AnalysisAndMedicalPlan.plan &&
      this.state.hiddenQuerysTabs == false
    ) {
      errors.analysisAndMedicalPlan.plan = "Ingrese un plan";
    } else {
      delete errors.analysisAndMedicalPlan.plan;
    }

    if (
      !this.state.AnalysisAndMedicalPlan.recommendations &&
      this.state.hiddenQuerysTabs == false
    ) {
      errors.analysisAndMedicalPlan.recommendations =
        "Ingrese las recomendaciones";
    } else {
      delete errors.analysisAndMedicalPlan.recommendations;
    }

    if (Object.keys(errors.analysisAndMedicalPlan).length === 0) {
      delete errors.analysisAndMedicalPlan;
    }

    if (
      this.state.Diagnostic.addedDiagnostics.length <= 0 &&
      this.state.hiddenQuerysTabs == false
    ) {
      errors.Diagnostic = "Ingrese minimo un Diagnostico";
    } else {
      delete errors.Diagnostic;
    }

    //obligatiriedad de presion arterial en examen fisico
    if (!this.state.userPermits.includes(34)) {
      if (
        this.state.PhysicalExam.bloodPressureMM === "" &&
        this.state.PhysicalExam.bloodPressureHg === "" &&
        this.state.hiddenQuerysTabs == false
      ) {
        errors.PhysicalExam =
          "Debe diligenciar los campos de presión arterial en examen físico";
      } else {
        delete errors.PhysicalExam;
      }
    }

    //Si el Doctor puede realizar el Procedimiento Audiologico, se le OBLIGA a que lo Diligencie
    if (this.state.userPermits.includes(34)) {
      if (
        this.state.SpeechTerapyText == null ||
        this.state.SpeechTerapyText == "" ||
        this.state.SpeechTerapyText == undefined
      ) {
        errors.SpeechTerapyText =
          "Debe diligenciar el Procedimiento Audiologico";
      }
    }

    //Validacion de Habitos
    if (this.state.sectionAilment.habits.yearStart) {
      let errorYear = this.validateHabitYearWithPatientAge(
        this.state.sectionAilment.habits.yearStart
      );
      if (errorYear) {
        errors.habits.differenceYearStartSmoke =
          "El año de inicio de Consumo de Cigarrillo es menor a al año de Nacimiento";
      }
    }

    if (this.state.sectionAilment.habits.yearEnd) {
      let errorYear = this.validateHabitYearWithPatientAge(
        this.state.sectionAilment.habits.yearEnd
      );
      if (errorYear) {
        errors.habits.differenceYearEndSmoke =
          "El año de finalización de Consumo de Cigarrillo es menor a al año de Nacimiento";
      }
    }

    if (Object.keys(errors.habits).length === 0) {
      delete errors.habits;
    }

    //Gestión de Validación si es un Paciente que pertenece a Estudios Clinicos
    if (this.state.anamesis.participate == true) {
      errors.clinicalStudio = {};

      //Validación de Criterios de Inclusión
      if (
        this.state.detailsClinicalStudio.criterialExcIncData.inclusion.length >
        0
      ) {
        if (
          this.state.detailsClinicalStudio.criterialExcIncData.inclusion.some(
            (dat) => dat.confirmacion == null || dat.confirmacion == undefined
          )
        ) {
          errors.clinicalStudio.criterialInclusion =
            "Debe diligenciar los Criterios de Inclusión";
        }
      }

      //Validación de Criterios de Exclusión
      if (
        this.state.detailsClinicalStudio.criterialExcIncData.exclusion.length >
        0
      ) {
        if (
          this.state.detailsClinicalStudio.criterialExcIncData.exclusion.some(
            (dat) => dat.confirmacion == null || dat.confirmacion == undefined
          )
        ) {
          errors.clinicalStudio.criterialExclusion =
            "Debe diligenciar los Criterios de Exclusión";
        }
      }

      console.log(
        "dataInformedConsent",
        this.state.detailsClinicalStudio.dataInformedConsent
      );

      if (this.state.detailsClinicalStudio.dataInformedConsent.length <= 0) {
        errors.clinicalStudio.dataInformedConsent =
          "Debe subir el Consentimiento Informado del Estudio Clinico";
      }

      if (Object.keys(errors.clinicalStudio).length <= 0) {
        delete errors.clinicalStudio;
      }
    } else {
      delete errors.clinicalStudio;
    }

    console.log("erroresData", errors);

    this.setState({
      errors: errors,
      openErrors: Object.keys(errors).length > 0,
    });

    if (Object.keys(errors).length > 0) {
      return true;
    } else {
      return false;
    }
  };

  //Construye el JSON de los Habitos para guardarlos en SAC
  getHabitsPatientToSave = () => {
    var habitos = {};
    //Cigarrillos
    habitos.fumador = this.state.sectionAilment.habits.smoke;
    habitos.ano_inicio = this.state.sectionAilment.habits.yearStart;
    habitos.ano_fin = this.state.sectionAilment.habits.yearEnd;
    habitos.cigarillos_dia = this.state.sectionAilment.habits.cigarretsPerDay;
    habitos.paquetes_anio = this.state.sectionAilment.habits.packegesPerYear;

    //Humo de Leña
    habitos.humo_lena = this.state.sectionAilment.habits.firewood;
    habitos.tiempo_anios = this.state.sectionAilment.habits.years;

    //Sustancias Psicoactivas
    habitos.sustancia_psico = this.state.sectionAilment.habits.comsuption;
    habitos.sustancia_frecuencia = this.state.sectionAilment.habits.frecuency;
    habitos.cocaina = this.state.sectionAilment.habits.substaces.includes(
      "Cocaina"
    )
      ? "Si"
      : "No";
    habitos.ghb = this.state.sectionAilment.habits.substaces.includes("GHB")
      ? "Si"
      : "No";
    habitos.extasis = this.state.sectionAilment.habits.substaces.includes(
      "Extasis"
    )
      ? "Si"
      : "No";
    habitos.lsd = this.state.sectionAilment.habits.substaces.includes("LSD")
      ? "Si"
      : "No";
    habitos.bazuco = this.state.sectionAilment.habits.substaces.includes(
      "Bazuco"
    )
      ? "Si"
      : "No";
    habitos.hongos = this.state.sectionAilment.habits.substaces.includes(
      "Hongos"
    )
      ? "Si"
      : "No";
    habitos.heroina = this.state.sectionAilment.habits.substaces.includes(
      "Heroina"
    )
      ? "Si"
      : "No";
    habitos.marihuana = this.state.sectionAilment.habits.substaces.includes(
      "Marihuana"
    )
      ? "Si"
      : "No";
    habitos.sustancias_otras = this.state.sectionAilment.habits.substace;

    //Alcohol
    habitos.alcohol = this.state.sectionAilment.habits.alcohol;
    habitos.alcohol_ultimo_anio =
      this.state.sectionAilment.habits.alcoholLastYear;
    habitos.alcohol_frecuencia =
      this.state.sectionAilment.habits.frecuencyAlcohol;

    //Actividad Fisica
    habitos.actividad_fisica =
      this.state.sectionAilment.habits.physicalActivity;
    habitos.actividad_tiempo =
      this.state.sectionAilment.habits.timePhysicalActivity;
    habitos.actividades_cuales = this.state.sectionAilment.habits.activities;

    //Nutricion
    habitos.nutricional = this.state.sectionAilment.habits.nutricional;
    return habitos;
  };

  handlerFileProcedure = async (fileProcedure, id_servicio) => {
    if (fileProcedure != null && fileProcedure != undefined) {
      let id_service = !!id_servicio ? parseInt(id_servicio) : null;
      let dataFile = new FormData();
      dataFile.append("id_admision", this.props.data.id_admision);
      dataFile.append("adjunto", fileProcedure);
      dataFile.append("id_servicio", id_service);

      await fetch(
        process.env.REACT_APP_PUBLIC_URL + "procedimientos-adjunto/create",
        {
          method: "POST",
          headers: {
            authorization: "Bearer " + sessionStorage.getItem("token"),
          },
          body: dataFile,
        }
      )
        .then((response) => {
          if (response.status != 500 && response.status != 403) {
            return response.json();
          } else {
            throw new Error("Error subiendo el Archivo");
          }
        })
        .then((res) => {
          let adjunto = res.adjunto;
          //resolve(res.adjunto);
          if (!!adjunto) {
            /* this.setState({
            FileProcedure: adjunto
          }); */
            /* let currentlyFileProcedure = !!this.state.FileProcedure ? this.state.FileProcedure : [];
          currentlyFileProcedure.push(adjunto);
          this.setState({ FileProcedure: currentlyFileProcedure }) */
            let currFileProcedure = this.state.FileProcedure;
            let findFileProcedure = currFileProcedure.find(
              (file) =>
                file.id_procedimiento_adjunto ===
                adjunto.id_procedimiento_adjunto
            );
            !findFileProcedure && currFileProcedure.push(adjunto);
            //this.setState({ FileProcedure: currFileProcedure }, () => this.loadFileProcedure());
            this.setState(
              { shouldResultsBeUpdated: !this.state.shouldResultsBeUpdated },
              () => this.loadFileProcedure()
            );
            //this.loadFileProcedure();
          }
        })
        .catch((error) => {
          console.log("responseFile", error);
        });
    }
  };

  dropDeletedFileProcedureFromState = (fileProcedure, nameProcedure) => {
    console.log(
      "dropDeletedFileProcedureFromState",
      fileProcedure,
      nameProcedure
    );
    let labFiles = [];
    this.setState(
      {
        uploadFileProcedure: true,
        shouldResultsBeUpdated: !this.state.shouldResultsBeUpdated,
      },
      () => this.loadFileProcedure()
    );
    const procedureToSearch = fileProcedure.adjunto;
    if (!!procedureToSearch) {
      switch (nameProcedure) {
        case "ECO":
          let ecoFiles = this.state.MedicalProcedures.ECO.ecoFiles;
          let newEcoFiles = ecoFiles.filter(
            (file) =>
              file.id_procedimiento_adjunto !==
              procedureToSearch.id_procedimiento_adjunto
          );
          console.log(
            "dropDeletedFileProcedureFromStateECO",
            ecoFiles,
            newEcoFiles
          );
          this.setState({
            MedicalProcedures: {
              ...this.state.MedicalProcedures,
              ["ECO"]: {
                ...this.state.MedicalProcedures["ECO"],
                ["ecoFiles"]: newEcoFiles,
              },
            },
            uploadFileProcedure: false,
          });
          break;
        case "EKG":
          let ekgFiles = this.state.MedicalProcedures.EKG.ekgFiles;
          let newEkgFiles = ekgFiles.filter(
            (file) =>
              file.id_procedimiento_adjunto !==
              procedureToSearch.id_procedimiento_adjunto
          );
          this.setState({
            MedicalProcedures: {
              ...this.state.MedicalProcedures,
              ["EKG"]: {
                ...this.state.MedicalProcedures["EKG"],
                ["ekgFiles"]: newEkgFiles,
              },
            },
            uploadFileProcedure: false,
          });
          break;
        case "Holter":
          let holterFiles = this.state.MedicalProcedures.Holter.holterFiles;
          let newHolterFiles = holterFiles.filter(
            (file) =>
              file.id_procedimiento_adjunto !==
              procedureToSearch.id_procedimiento_adjunto
          );
          this.setState({
            MedicalProcedures: {
              ...this.state.MedicalProcedures,
              ["Holter"]: {
                ...this.state.MedicalProcedures["Holter"],
                ["holterFiles"]: newHolterFiles,
              },
            },
            uploadFileProcedure: false,
          });
          break;
        case "LAB":
          labFiles.push(file);
          //this.setState({ labFiles });
          break;
        case "Map":
          let mapFiles = this.state.MedicalProcedures.Map.mapFiles;
          let newMapFiles = mapFiles.filter(
            (file) =>
              file.id_procedimiento_adjunto !==
              procedureToSearch.id_procedimiento_adjunto
          );
          this.setState({
            MedicalProcedures: {
              ...this.state.MedicalProcedures,
              ["Map"]: {
                ...this.state.MedicalProcedures["Map"],
                ["mapFiles"]: newMapFiles,
              },
            },
            uploadFileProcedure: false,
          });
          break;
        case "Stress":
          let stressFiles = this.state.MedicalProcedures.Stress.stressFiles;
          let newStressFiles = stressFiles.filter(
            (file) =>
              file.id_procedimiento_adjunto !==
              procedureToSearch.id_procedimiento_adjunto
          );
          this.setState({
            MedicalProcedures: {
              ...this.state.MedicalProcedures,
              ["Stress"]: {
                ...this.state.MedicalProcedures["Stress"],
                ["stressFiles"]: newStressFiles,
              },
            },
            uploadFileProcedure: false,
          });
          break;
        case "Test":
          let testFiles = this.state.MedicalProcedures.Test.testFiles;
          let newTestFiles = testFiles.filter(
            (file) =>
              file.id_procedimiento_adjunto !==
              procedureToSearch.id_procedimiento_adjunto
          );
          this.setState({
            MedicalProcedures: {
              ...this.state.MedicalProcedures,
              ["Test"]: {
                ...this.state.MedicalProcedures["Test"],
                ["testFiles"]: newTestFiles,
              },
            },
            uploadFileProcedure: false,
          });
          break;

        default:
          break;
      }
    }
  };

  validateHabitYearWithPatientAge = (yearData) => {
    let birthdayPatientYear = moment(this.props.data.birthday).format("YYYY");
    let difference = parseInt(yearData) - parseInt(birthdayPatientYear);
    if (difference <= 0) {
      return true;
    } else {
      return false;
    }
  };

  createHistory = async () => {
    let usuario = JSON.parse(sessionStorage.getItem("usuario"));
    //this.setState({ btnActive: false });

    var patologicos = {};
    patologicos.hipertension =
      this.state.sectionAilment.pathologicals.hipertension;
    patologicos.metabolicos =
      this.state.sectionAilment.pathologicals.metabolicos;
    patologicos.cardiacos = this.state.sectionAilment.pathologicals.cardiacos;
    patologicos.infecciosos =
      this.state.sectionAilment.pathologicals.infecciosos;
    patologicos.vasculares = this.state.sectionAilment.pathologicals.vasculares;
    patologicos.alergicos = this.state.sectionAilment.pathologicals.alergicos;
    patologicos.cancer = this.state.sectionAilment.pathologicals.cancer;
    patologicos.transfusiones =
      this.state.sectionAilment.pathologicals.transfusiones;
    patologicos.autoinmunes =
      this.state.sectionAilment.pathologicals.autoinmunes;
    patologicos.traumatico = this.state.sectionAilment.pathologicals.traumatico;
    patologicos.diabetes = this.state.sectionAilment.pathologicals.diabetes;
    patologicos.hiperlipidemia =
      this.state.sectionAilment.pathologicals.hiperlipidemia;
    patologicos.enfermedad_coronaria =
      this.state.sectionAilment.pathologicals.enfermedad_coronaria;
    patologicos.enf_vascular_per =
      this.state.sectionAilment.pathologicals.enf_vascular_per;
    patologicos.hepatitis = this.state.sectionAilment.pathologicals.hepatitis;
    patologicos.observation =
      this.state.sectionAilment.pathologicals.observacion;
    //patologicos.otros = this.state.sectionAilment.commentary[0];

    var quirurgicos = {};
    quirurgicos.quirurgico = this.state.sectionAilment.surgicals.quirurjico;
    quirurgicos.observation = this.state.sectionAilment.surgicals.observacion;
    //quirurgicos.otros = this.state.sectionAilment.commentary[1];

    var farmacologicos = {};
    farmacologicos.farmacologico =
      this.state.sectionAilment.pharmacological.farmacologico;
    farmacologicos.observation =
      this.state.sectionAilment.pharmacological.observacion;
    //farmacologicos.otros = this.state.sectionAilment.commentary[2];

    var ginecoobstetricos = {};
    ginecoobstetricos.ginecoobstetrico =
      this.state.sectionAilment.gynecologists.ginecoobstetrico;
    ginecoobstetricos.observation =
      this.state.sectionAilment.gynecologists.observacion;
    //ginecoobstetricos.otros = this.state.sectionAilment.commentary[2];

    var familiares = {};
    familiares.enf_coronaria =
      this.state.sectionAilment.family.enfermedad_coronaria;
    familiares.diabetes = this.state.sectionAilment.family.diabetes;
    familiares.cancer = this.state.sectionAilment.family.cancer;
    familiares.muerte_subita = this.state.sectionAilment.family.muerte_subita;
    familiares.hipertension = this.state.sectionAilment.family.hipertension;
    familiares.otros = this.state.sectionAilment.commentary[1];
    familiares.observation = this.state.sectionAilment.family.observacion;

    var otros = {};
    otros.alergias = this.state.sectionAilment.others.alergias;
    otros.traumatico = this.state.sectionAilment.others.traumatico;
    otros.hospitalario = this.state.sectionAilment.others.hospitalario;
    otros.psiquiatricos = this.state.sectionAilment.others.psiquiatricos;
    otros.enfermades_t_sexual =
      this.state.sectionAilment.others.enfermades_t_sexual;
    otros.observation = this.state.sectionAilment.others.observacion;
    //otros.otros = this.state.sectionAilment.others.otros;

    var inmunizaciones = {};
    inmunizaciones.inmunizaciones =
      this.state.sectionAilment.inmunizations.inmunizaciones;
    inmunizaciones.observation =
      this.state.sectionAilment.inmunizations.observacion;
    //inmunizaciones.otros = this.state.sectionAilment.commentary[4];

    var habitos = this.getHabitsPatientToSave();

    var formulas = this.state.MedicalOrders.formulas.map((formula) => {
      return {
        principio_activo: formula.activePrinciple,
        concentracion: formula.concentration,
        forma_farmaceutica: formula.pharmaceuticalForm,
        via_administracion: formula.route,
        dosis: formula.dose,
        frecuencia: formula.frequency,
        duracion: formula.duration,
        unidades_requeridas: formula.units,
        otra_frecuencia: formula.otherFrequency,
      };
    });

    var diagnostics = this.state.Diagnostic.addedDiagnostics.map(
      (diagnostic, index) => {
        diagnostic.observacion = this.state.Diagnostic.observations[index];
        diagnostic.tipo = this.state.Diagnostic.typesDiag[index];
        return diagnostic;
      }
    );

    var dataHistory = {
      id_historia: this.props.data.id_historia,
      id_admision: this.props.data.id_admision,
      id_usuario: !!usuario ? usuario.id_usuario : 0,
      antecedentes: {
        patologicos: [patologicos],
        quirurgicos: [quirurgicos],
        farmacologicos: [farmacologicos],
        ginecoobstetricos: [ginecoobstetricos],
        inmunizaciones: [inmunizaciones],
        habitos: [habitos],
        otros: [otros],
        familiares: [familiares],
      },
      anamnesis: {
        causa_ingreso: this.state.anamesis.cause,
        motivo_consulta: this.state.anamesis.reasonForConsultation,
        enfermedad_actual: this.state.anamesis.currentIllness,
        candidato_estudio: this.state.anamesis.candidate,
        acronimo_estudio: this.state.anamesis.acronym,
        participa_estudio: this.state.anamesis.participate,
        id_estudio:
          this.state.dataClinicalStudio != null
            ? this.state.dataClinicalStudio.estudio.id_estudio
            : null,
      },
      fisico: {
        peso: this.state.PhysicalExam.weight,
        talla: this.state.PhysicalExam.size,
        masa_corporal: this.state.PhysicalExam.BMI,
        peri_abdominal: this.state.PhysicalExam.abdominalPerimeter,
        superficie_corporal: this.state.bodySurface,
        dominancia: this.state.PhysicalExam.dominance,
        frecuencia_cardiaca: this.state.PhysicalExam.heartRate,
        frecuencia_respiratoria: this.state.PhysicalExam.breathingFrequency,
        temperatura: this.state.PhysicalExam.temperature,
        presion_arterial: this.state.PhysicalExam.bloodPressureMM,
        presion_arterial2: this.state.PhysicalExam.bloodPressureHg,
        aspecto_general: this.state.PhysicalExam.generalFeatures,
        cabeza_cara: this.state.PhysicalExam.headAndFace,
        otorrino: this.state.PhysicalExam.otorhino,
        ojos: this.state.PhysicalExam.eyes,
        cuello: this.state.PhysicalExam.neck,
        torax: this.state.PhysicalExam.chest,
        cardiovascular: this.state.PhysicalExam.cardioVascular,
        pulmonar: this.state.PhysicalExam.pulmonary,
        abdomen: this.state.PhysicalExam.abdomen,
        extremidades: this.state.PhysicalExam.limbs,
        neurologico: this.state.PhysicalExam.genitourinary,
        genitourinario: this.state.PhysicalExam.skin_appendages,
        piel_faneras: this.state.PhysicalExam.skin_appendages,
        genero: this.state.PhysicalExam.gender,
      },
      diagnostico: {
        diagnostico: diagnostics,
        observaciones: this.state.Diagnostic.generalObservation,
      },
      procedimiento: {
        fecha: moment(new Date()).format("YYYY/MM/DD"),
        hora: moment(new Date()).format("hh:mm A"),
        eco: [
          {
            profesional: this.state.MedicalProcedures.ECO.professional,
            vid: this.state.MedicalProcedures.ECO.vid,
            pp: this.state.MedicalProcedures.ECO.pp,
            ps: this.state.MedicalProcedures.ECO.ps,
            vis: this.state.MedicalProcedures.ECO.vis,
            fe: this.state.MedicalProcedures.ECO.fe,
            rao: this.state.MedicalProcedures.ECO.rao,
            anillo_ao: this.state.MedicalProcedures.ECO.ao,
            vd: this.state.MedicalProcedures.ECO.vd,
            ai: this.state.MedicalProcedures.ECO.ai,
            e: this.state.MedicalProcedures.ECO.e,
            a: this.state.MedicalProcedures.ECO.a,
            tap_se: this.state.MedicalProcedures.ECO.tapse,
            ad: this.state.MedicalProcedures.ECO.ad,
            descripcion: this.state.MedicalProcedures.ECO.description,
            conclusiones: this.state.MedicalProcedures.ECO.conclusions,
            diagnostico: this.state.MedicalProcedures.ECO.addedMedicaments,
            adulto: this.state.MedicalProcedures.ECO.adult,
          },
        ],
        estres: [
          {
            profesional: this.state.MedicalProcedures.Stress.professional,
            vid: this.state.MedicalProcedures.Stress.vid,
            pp: this.state.MedicalProcedures.Stress.pp,
            ps: this.state.MedicalProcedures.Stress.ps,
            vis: this.state.MedicalProcedures.Stress.vis,
            fe: this.state.MedicalProcedures.Stress.fe,
            rao: this.state.MedicalProcedures.Stress.rao,
            anillo_ao: this.state.MedicalProcedures.Stress.ao,
            vd: this.state.MedicalProcedures.Stress.vd,
            ai: this.state.MedicalProcedures.Stress.ai,
            e: this.state.MedicalProcedures.Stress.e,
            a: this.state.MedicalProcedures.Stress.a,
            tap_se: this.state.MedicalProcedures.Stress.tapse,
            ad: this.state.MedicalProcedures.Stress.ad,
            reposo: "",
            ejercicio: "",
            conclusiones: this.state.MedicalProcedures.Stress.conclusions,
            diagnostico: this.state.MedicalProcedures.Stress.addedMedicaments,
            adulto: this.state.MedicalProcedures.Stress.adult,
            descripcion: this.state.MedicalProcedures.Stress.description,
          },
        ],
        prueba: [
          {
            profesional: this.state.MedicalProcedures.Test.professional,
            conclusiones: this.state.MedicalProcedures.Test.conclusions,
            conclusion: this.state.MedicalProcedures.Test.conclusion,
            diagnostico: this.state.MedicalProcedures.Test.addedMedicaments,
          },
        ],
        ekg: [
          {
            profesional: this.state.MedicalProcedures.EKG.professional,
            ritmo: this.state.MedicalProcedures.EKG.ritmo,
            fc: this.state.MedicalProcedures.EKG.fc,
            onda_p: this.state.MedicalProcedures.EKG.ondaP,
            pr: this.state.MedicalProcedures.EKG.pr,
            qr_s: this.state.MedicalProcedures.EKG.qrs,
            eje_qrs: this.state.MedicalProcedures.EKG.ejeQRS,
            conclusion: this.state.MedicalProcedures.EKG.conclusions,
            diagnostico: this.state.MedicalProcedures.EKG.addedMedicaments,
            qtc: this.state.MedicalProcedures.EKG.qtc,
            styt: this.state.MedicalProcedures.EKG.styt,
          },
        ],
        holter: [
          {
            profesional: this.state.MedicalProcedures.Holter.professional,
            conclusion: this.state.MedicalProcedures.Holter.conclusion,
            diagnostico: this.state.MedicalProcedures.Holter.addedMedicaments,
          },
        ],
        mapa: [
          {
            profesional: this.state.MedicalProcedures.Map.professional,
            conclusion: this.state.MedicalProcedures.Map.conclusion,
            diagnostico: this.state.MedicalProcedures.Map.addedMedicaments,
          },
        ],
      },
      sistemas: {
        sintomas_generales: this.state.SystemReview.ailments[0].commentary,
        respiratorio: this.state.SystemReview.ailments[1].commentary,
        cardiovascular: this.state.SystemReview.ailments[2].commentary,
        gastrointestinal: this.state.SystemReview.ailments[3].commentary,
        genitourinario: this.state.SystemReview.ailments[4].commentary,
        osteomuscular: this.state.SystemReview.ailments[5].commentary,
        dermatologico: this.state.SystemReview.ailments[6].commentary,
        endocrino: this.state.SystemReview.ailments[7].commentary,
        neurologico: this.state.SystemReview.ailments[8].commentary,
      },
      ordenes: {
        tratamiento: formulas,
        ordenes: this.state.MedicalOrders,
        observaciones: this.state.MedicalOrders.observations,
        vigencia: this.state.MedicalOrders.time,
        cantidad: this.state.MedicalOrders.amount,
      },
      plan: {
        analisis: this.state.AnalysisAndMedicalPlan.analysis,
        plan_medico: this.state.AnalysisAndMedicalPlan.plan,
        recomendaciones: this.state.AnalysisAndMedicalPlan.recommendations,
      },
      fonoaudiologia: this.state.SpeechTerapyText,
    };

    //La participacion en el Estudio Clinico guarda sus datos respectivos
    if (this.state.anamesis.participate == true) {
      dataHistory.detallesEstudioClinico = {
        criterios: {
          inclusion:
            this.state.detailsClinicalStudio.criterialExcIncData.inclusion,
          exclusion:
            this.state.detailsClinicalStudio.criterialExcIncData.exclusion,
          enrolado:
            this.state.detailsClinicalStudio.criterialExcIncData.enrolado,
        },
      };
    } else {
      dataHistory.detallesEstudioClinico = null;
    }
    await fetch(process.env.REACT_APP_PUBLIC_URL + "evento/create", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + sessionStorage.getItem("token"),
      },
      body: JSON.stringify(dataHistory),
    })
      .then((response) => {
        if (
          response.status != 500 &&
          response.status != 403 &&
          response.status != 403
        ) {
          return response.text();
        } else {
          throw new Error("Ha ocurrido un error en el servidor");
        }
      })
      .then((data) => {
        console.log(data);
        //alert("Historia creada con exito ")
        this.setState({
          openAlert: true,
          modalAlert: {
            title: "Exitoso!",
            message: "Historia creada con exito ",
            color: "success",
          },
        });
        this.setState({ stateClinicistory: true }, () => {
          history.push({
            pathname:
              process.env.PUBLIC_URL + "/assitencial/search-clinic-history",
            state: { date: this.props.data.fecha },
          });
        });
      })
      .catch((error) => {
        alert("Ha ocurrido un error creando la historia clinica");
        console.error("Error:", error);
      });
  };

  handlerPathologicalBackgroundRadio = (value, pathologicalBackground) => {
    this.setState(
      {
        sectionAilment: {
          ...this.state.sectionAilment,
          pathologicals: {
            ...this.state.sectionAilment.pathologicals,
            [pathologicalBackground]: {
              ...this.state.sectionAilment.pathologicals[
                pathologicalBackground
              ],
              value: value,
            },
          },
        },
      },
      () => {
        if (value == "No") {
          this.handlerPathologicalBackgroundText("", pathologicalBackground);
        }
      }
    );
  };

  handlerPathologicalBackgroundText = (value, pathologicalBackground) => {
    this.setState({
      sectionAilment: {
        ...this.state.sectionAilment,
        pathologicals: {
          ...this.state.sectionAilment.pathologicals,
          [pathologicalBackground]: {
            ...this.state.sectionAilment.pathologicals[pathologicalBackground],
            comentario: value,
          },
        },
      },
    });
  };

  handlerPathologicsObservation = (value, pathologicalBackground) => {
    this.setState({
      sectionAilment: {
        ...this.state.sectionAilment,
        pathologicals: {
          ...this.state.sectionAilment.pathologicals,
          [pathologicalBackground]: value,
        },
      },
    });
  };

  handlerSurgicalsBackgroundRadio = (value, surgicalBackground) => {
    this.setState(
      {
        sectionAilment: {
          ...this.state.sectionAilment,
          surgicals: {
            ...this.state.sectionAilment.surgicals,
            [surgicalBackground]: {
              ...this.state.sectionAilment.surgicals[surgicalBackground],
              value: value,
            },
          },
        },
      },
      () => {
        if (value == "No") {
          this.handlerSurgicalsBackgroundText("", surgicalBackground);
        }
      }
    );
  };

  handlerSurgicalsBackgroundText = (value, surgicalBackground) => {
    this.setState({
      sectionAilment: {
        ...this.state.sectionAilment,
        surgicals: {
          ...this.state.sectionAilment.surgicals,
          [surgicalBackground]: {
            ...this.state.sectionAilment.surgicals[surgicalBackground],
            comentario: value,
          },
        },
      },
    });
  };

  handlerSurgicalsBackgroundObservation = (value, surgicalBackground) => {
    this.setState({
      sectionAilment: {
        ...this.state.sectionAilment,
        surgicals: {
          ...this.state.sectionAilment.surgicals,
          [surgicalBackground]: value,
        },
      },
    });
  };

  handlerPharmacologicalBackgroundRadio = (value, pharmacologicBackground) => {
    this.setState(
      {
        sectionAilment: {
          ...this.state.sectionAilment,
          pharmacological: {
            ...this.state.sectionAilment.pharmacological,
            [pharmacologicBackground]: {
              ...this.state.sectionAilment.pharmacological[
                pharmacologicBackground
              ],
              value: value,
            },
          },
        },
      },
      () => {
        if (value == "No") {
          this.handlerPharmacologicalBackgroundText(
            "",
            pharmacologicBackground
          );
        }
      }
    );
  };

  handlerPharmacologicalBackgroundText = (value, pharmacologicBackground) => {
    this.setState({
      sectionAilment: {
        ...this.state.sectionAilment,
        pharmacological: {
          ...this.state.sectionAilment.pharmacological,
          [pharmacologicBackground]: {
            ...this.state.sectionAilment.pharmacological[
              pharmacologicBackground
            ],
            comentario: value,
          },
        },
      },
    });
  };

  handlerPharmacologicalBackgroundTableAdd = (pharmacologicBackground, row) => {
    console.log("addFomula", pharmacologicBackground, "row", row);
    let tableData =
      this.state.sectionAilment.pharmacological[pharmacologicBackground].table;
    tableData.push(row);
    this.savePharmacologicalBackgroundTable(tableData, pharmacologicBackground);
  };

  handlerPharmacologicalBackgroundTableDelete = (
    pharmacologicBackground,
    rowNumber
  ) => {
    let tableData =
      this.state.sectionAilment.pharmacological[pharmacologicBackground].table;
    tableData.splice(rowNumber, 1);
    this.savePharmacologicalBackgroundTable(tableData, pharmacologicBackground);
  };

  savePharmacologicalBackgroundTable = (tableData, pharmacologicBackground) => {
    try {
      this.setState({
        sectionAilment: {
          ...this.state.sectionAilment,
          pharmacological: {
            ...this.state.sectionAilment.pharmacological,
            [pharmacologicBackground]: {
              ...this.state.sectionAilment.pharmacological[
                pharmacologicBackground
              ],
              table: tableData,
            },
          },
        },
      });
    } catch (e) {
      console.log(e);
    }
  };

  handlerPharmacologicalBackgroundObservation = (
    value,
    pharmacologicalBackground
  ) => {
    this.setState({
      sectionAilment: {
        ...this.state.sectionAilment,
        pharmacological: {
          ...this.state.sectionAilment.pharmacological,
          [pharmacologicalBackground]: value,
        },
      },
    });
  };

  handlerGynecologistBackgroundRadio = (value, gynecologistsBackground) => {
    this.setState(
      {
        sectionAilment: {
          ...this.state.sectionAilment,
          gynecologists: {
            ...this.state.sectionAilment.gynecologists,
            [gynecologistsBackground]: {
              ...this.state.sectionAilment.gynecologists[
                gynecologistsBackground
              ],
              value: value,
            },
          },
        },
      },
      () => {
        if (value == "No") {
          this.handlerGynecologistBackgroundText("", gynecologistsBackground);
        }
      }
    );
  };

  handlerGynecologistBackgroundText = (value, gynecologistsBackground) => {
    this.setState({
      sectionAilment: {
        ...this.state.sectionAilment,
        gynecologists: {
          ...this.state.sectionAilment.gynecologists,
          [gynecologistsBackground]: {
            ...this.state.sectionAilment.gynecologists[gynecologistsBackground],
            comentario: value,
          },
        },
      },
    });
  };

  handlerGynecologistBackgroundObservation = (
    value,
    GynecologistBackground
  ) => {
    this.setState({
      sectionAilment: {
        ...this.state.sectionAilment,
        gynecologists: {
          ...this.state.sectionAilment.gynecologists,
          [GynecologistBackground]: value,
        },
      },
    });
  };

  handlerFamilyBackgroundRadio = (value, familyBackground) => {
    this.setState(
      {
        sectionAilment: {
          ...this.state.sectionAilment,
          family: {
            ...this.state.sectionAilment.family,
            [familyBackground]: {
              ...this.state.sectionAilment.family[familyBackground],
              value: value,
            },
          },
        },
      },
      () => {
        if (value == "No") {
          this.handlerFamilyBackgroundText("", familyBackground);
        }
      }
    );
  };

  handlerFamilyBackgroundText = (value, familyBackground) => {
    this.setState({
      sectionAilment: {
        ...this.state.sectionAilment,
        family: {
          ...this.state.sectionAilment.family,
          [familyBackground]: {
            ...this.state.sectionAilment.family[familyBackground],
            comentario: value,
          },
        },
      },
    });
  };

  handlerFamilyBackgroundObservation = (value, familyBackground) => {
    this.setState({
      sectionAilment: {
        ...this.state.sectionAilment,
        family: {
          ...this.state.sectionAilment.family,
          [familyBackground]: value,
        },
      },
    });
  };

  handlerOthersBackgroundRadio = (value, otherBackground) => {
    this.setState(
      {
        sectionAilment: {
          ...this.state.sectionAilment,
          others: {
            ...this.state.sectionAilment.others,
            [otherBackground]: {
              ...this.state.sectionAilment.others[otherBackground],
              value: value,
            },
          },
        },
      },
      () => {
        if (value == "No") {
          this.handlerOthersBackgroundText("", otherBackground);
        }
      }
    );
  };

  handlerOthersBackgroundText = (value, otherBackground) => {
    this.setState({
      sectionAilment: {
        ...this.state.sectionAilment,
        others: {
          ...this.state.sectionAilment.others,
          [otherBackground]: {
            ...this.state.sectionAilment.others[otherBackground],
            comentario: value,
          },
        },
      },
    });
  };

  handlerOthersBackgroundObservation = (value, othersBackground) => {
    this.setState({
      sectionAilment: {
        ...this.state.sectionAilment,
        others: {
          ...this.state.sectionAilment.others,
          [othersBackground]: value,
        },
      },
    });
  };

  handlerInmunizationsBackgroundRadio = (value, inmunizationsBackground) => {
    this.setState(
      {
        sectionAilment: {
          ...this.state.sectionAilment,
          inmunizations: {
            ...this.state.sectionAilment.inmunizations,
            [inmunizationsBackground]: {
              ...this.state.sectionAilment.inmunizations[
                inmunizationsBackground
              ],
              value: value,
            },
          },
        },
      },
      () => {
        if (value == "No") {
          this.handlerInmunizationsBackgroundText("", inmunizationsBackground);
        }
      }
    );
  };

  handlerInmunizationsBackgroundText = (value, inmunizationsBackground) => {
    this.setState({
      sectionAilment: {
        ...this.state.sectionAilment,
        inmunizations: {
          ...this.state.sectionAilment.inmunizations,
          [inmunizationsBackground]: {
            ...this.state.sectionAilment.inmunizations[inmunizationsBackground],
            comentario: value,
          },
        },
      },
    });
  };

  handlerInmunizationsBackgroundObservation = (
    value,
    inmunizationsBackground
  ) => {
    this.setState({
      sectionAilment: {
        ...this.state.sectionAilment,
        inmunizations: {
          ...this.state.sectionAilment.inmunizations,
          [inmunizationsBackground]: value,
        },
      },
    });
  };

  handlerHabits = (habit, valueHabit) => {
    this.setState(
      {
        sectionAilment: {
          ...this.state.sectionAilment,
          habits: {
            ...this.state.sectionAilment.habits,
            [habit]: valueHabit,
          },
        },
      },
      () => {
        console.log("HABITOS", this.state.sectionAilment.habits);
      }
    );
  };

  calculateSmoke = (cigarrets) => {
    let value = 0;
    if (
      this.state.sectionAilment.habits.yeardEnd !== "" &&
      this.state.sectionAilment.habits.yeardEnd !== undefined &&
      this.state.sectionAilment.habits.yeardEnd !== null
    ) {
      value =
        ((this.state.sectionAilment.habits.yeardEnd -
          this.state.sectionAilment.habits.yearStart) *
          cigarrets) /
        20;
    } else {
      value =
        ((new Date().getFullYear() -
          this.state.sectionAilment.habits.yearStart) *
          cigarrets) /
        20;
    }

    this.setState(
      {
        sectionAilment: {
          ...this.state.sectionAilment,
          habits: {
            ...this.state.sectionAilment.habits,
            ["cigarretsPerDay"]: cigarrets,
          },
        },
      },
      () => {
        this.setState(
          {
            sectionAilment: {
              ...this.state.sectionAilment,
              habits: {
                ...this.state.sectionAilment.habits,
                ["packegesPerYear"]: value,
              },
            },
          },
          () => {}
        );
      }
    );
  };

  handlerInmunizationsBackgroundTableAdd = (inmunizationsBackground, row) => {
    let tableData =
      this.state.sectionAilment.inmunizations[inmunizationsBackground].table;
    tableData.push(row);
    this.savePharmacologicalBackgroundTable(tableData, inmunizationsBackground);
  };

  handlerInmunizationsBackgroundTableDelete = (
    inmunizationsBackground,
    rowNumber
  ) => {
    let tableData =
      this.state.sectionAilment.inmunizations[inmunizationsBackground].table;
    tableData.splice(rowNumber, 1);
    this.savePharmacologicalBackgroundTable(tableData, inmunizationsBackground);
  };

  handlerObservationAndProcedureTextMedicalOrder = (text) => {
    this.setState({
      MedicalOrders: {
        ...this.state.MedicalOrders,
        observationAndProcedure: text,
      },
    });
  };

  handlerMedicalObservationTextMedicalOrder = (text) => {
    this.setState({
      MedicalOrders: { ...this.state.MedicalOrders, medicalObservation: text },
    });
  };

  handlerChangeColorAlergies = (colorToChange) => {
    this.setState({ colorAlergiesIcon: colorToChange });
  };
  saveProceduresPatient = () => {
    return new Promise((resolve, reject) => {
      let procedimiento = {
        id_historia: this.props.data.id_historia,
        id_admision: this.props.data.id_admision,
        fecha: moment(new Date()).format("YYYY-MM-DD"),
        hora: moment(new Date()).format("hh:mm A"),
        eco: [
          {
            profesional: this.state.MedicalProcedures.ECO.professional,
            vid: this.state.MedicalProcedures.ECO.vid,
            pp: this.state.MedicalProcedures.ECO.pp,
            ps: this.state.MedicalProcedures.ECO.ps,
            vis: this.state.MedicalProcedures.ECO.vis,
            fe: this.state.MedicalProcedures.ECO.fe,
            rao: this.state.MedicalProcedures.ECO.rao,
            anillo_ao: this.state.MedicalProcedures.ECO.ao,
            vd: this.state.MedicalProcedures.ECO.vd,
            ai: this.state.MedicalProcedures.ECO.ai,
            e: this.state.MedicalProcedures.ECO.e,
            a: this.state.MedicalProcedures.ECO.a,
            tap_se: this.state.MedicalProcedures.ECO.tapse,
            ad: this.state.MedicalProcedures.ECO.ad,
            descripcion: this.state.MedicalProcedures.ECO.description,
            conclusiones: this.state.MedicalProcedures.ECO.conclusions,
            diagnostico: this.state.MedicalProcedures.ECO.addedMedicaments,
            adulto: this.state.MedicalProcedures.ECO.adult,
            nameTemplete: this.state.MedicalProcedures.ECO.nameTemplete,
            id_servicio: this.state.MedicalProcedures.ECO.id_servicio,
          },
        ],
        estres: [
          {
            profesional: this.state.MedicalProcedures.Stress.professional,
            vid: this.state.MedicalProcedures.Stress.vid,
            pp: this.state.MedicalProcedures.Stress.pp,
            ps: this.state.MedicalProcedures.Stress.ps,
            vis: this.state.MedicalProcedures.Stress.vis,
            fe: this.state.MedicalProcedures.Stress.fe,
            rao: this.state.MedicalProcedures.Stress.rao,
            anillo_ao: this.state.MedicalProcedures.Stress.ao,
            vd: this.state.MedicalProcedures.Stress.vd,
            ai: this.state.MedicalProcedures.Stress.ai,
            e: this.state.MedicalProcedures.Stress.e,
            a: this.state.MedicalProcedures.Stress.a,
            tap_se: this.state.MedicalProcedures.Stress.tapse,
            ad: this.state.MedicalProcedures.Stress.ad,
            reposo: "",
            ejercicio: "",
            conclusiones: this.state.MedicalProcedures.Stress.conclusions,
            diagnostico: this.state.MedicalProcedures.Stress.addedMedicaments,
            adulto: this.state.MedicalProcedures.Stress.adult,
            descripcion: this.state.MedicalProcedures.Stress.description,
            nameTemplete: this.state.MedicalProcedures.Stress.nameTemplete,
            id_servicio: this.state.MedicalProcedures.Stress.id_servicio,
          },
        ],
        prueba: [
          {
            profesional: this.state.MedicalProcedures.Test.professional,
            conclusiones: this.state.MedicalProcedures.Test.conclusions,
            conclusion: this.state.MedicalProcedures.Test.conclusion,
            diagnostico: this.state.MedicalProcedures.Test.addedMedicaments,
            nameTemplete: this.state.MedicalProcedures.Test.nameTemplete,
            id_servicio: this.state.MedicalProcedures.Test.id_servicio,
          },
        ],
        ekg: [
          {
            profesional: this.state.MedicalProcedures.EKG.professional,
            ritmo: this.state.MedicalProcedures.EKG.ritmo,
            fc: this.state.MedicalProcedures.EKG.fc,
            onda_p: this.state.MedicalProcedures.EKG.ondaP,
            pr: this.state.MedicalProcedures.EKG.pr,
            qr_s: this.state.MedicalProcedures.EKG.qrs,
            eje_qrs: this.state.MedicalProcedures.EKG.ejeQRS,
            conclusion: this.state.MedicalProcedures.EKG.conclusions,
            diagnostico: this.state.MedicalProcedures.EKG.addedMedicaments,
            qtc: this.state.MedicalProcedures.EKG.qtc,
            styt: this.state.MedicalProcedures.EKG.styt,
            nameTemplete: this.state.MedicalProcedures.EKG.nameTemplete,
            id_servicio: this.state.MedicalProcedures.EKG.id_servicio,
          },
        ],
        holter: [
          {
            profesional: this.state.MedicalProcedures.Holter.professional,
            conclusion: this.state.MedicalProcedures.Holter.conclusion,
            diagnostico: this.state.MedicalProcedures.Holter.addedMedicaments,
            nameTemplete: this.state.MedicalProcedures.Holter.nameTemplete,
            id_servicio: this.state.MedicalProcedures.Holter.id_servicio,
          },
        ],
        mapa: [
          {
            profesional: this.state.MedicalProcedures.Map.professional,
            conclusion: this.state.MedicalProcedures.Map.conclusion,
            diagnostico: this.state.MedicalProcedures.Map.addedMedicaments,
            nameTemplete: this.state.MedicalProcedures.Map.nameTemplete,
            id_servicio: this.state.MedicalProcedures.Map.id_servicio,
          },
        ],
      };
      console.log("MedicalProcedures", this.state.MedicalProcedures);
      if (!this.state.MedicalProceduresExist) {
        fetch(process.env.REACT_APP_PUBLIC_URL + "procedimientos/create", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            authorization: "Bearer " + sessionStorage.getItem("token"),
          },
          body: JSON.stringify(procedimiento),
        })
          .then((response) => {
            if (response.status != 500 && response.status != 403) {
              resolve(true);
              this.setState({
                shouldResultsBeUpdated: !this.state.shouldResultsBeUpdated,
              });
            }
          })
          .catch((error) => {
            console.log(error);
            alert("Ha ocurrido un error guardando el Procedimiento");
            reject(false);
          });
      } else {
        fetch(process.env.REACT_APP_PUBLIC_URL + "procedimientos/update", {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            authorization: "Bearer " + sessionStorage.getItem("token"),
          },
          body: JSON.stringify(procedimiento),
        })
          .then((response) => {
            if (response.status != 500 && response.status != 403) {
              this.setState({
                MedicalProceduresExist: true,
                shouldResultsBeUpdated: !this.state.shouldResultsBeUpdated,
              });
              resolve(true);
            }
          })
          .catch((error) => {
            console.log(error);
            alert("Ha ocurrido un error guardando el Procedimiento");
            reject(false);
          });
      }
    });
  };

  handlerSpeechTerapy = (dataValue) => {
    this.setState({ SpeechTerapyText: dataValue });
  };

  handleChangeActiveTabAccordion = (panel) => (event, newExpanded) => {
    if (newExpanded) {
      this.setState({ expanded: panel });
    } else {
      this.setState({ expanded: false });
    }
  };

  onOkModal = () => {
    switch (this.state.modalAlert.color) {
      case "success":
        history.push({
          pathname:
            process.env.PUBLIC_URL + "/assitencial/search-clinic-history",
          state: { date: this.props.data.fecha },
        });
        break;
      case "warning":
        console.log("Warning");
        this.preFinishSuccessHC();
        break;
    }
    this.setState({ openAlert: !this.state.openAlert });
  };

  preFinishSuccessHC = async () => {
    switch (this.state.creationProcess) {
      case 1:
        this.createHistory();
        break;
      case 2:
        this.createHistory();
        this.makePdfProcedureAndFormula();
        break;
      case 3:
        this.goBackFromHistory();
        break;
    }
  };
  validateOrdenes = (opt) => {
    let mensaje = "";
    if (!this.validateClinicHistory()) {
      switch (opt) {
        case 1:
          if (!this.state.hiddenQuerysTabs) {
            if (
              this.state.MedicalOrders.addedDiagnostics.length <= 0 &&
              this.state.MedicalOrders.formulas.length <= 0
            ) {
              mensaje =
                "No se diligenció un Procedimiento ni Formulas al paciente. \n ¿Desea guardar la Historia Clínica? ";
              this.setState({
                creationProcess: 1,
                openAlert: true,
                modalAlert: {
                  title: "Advertencia",
                  message: mensaje,
                  color: "warning",
                },
              });
            } else if (this.state.MedicalOrders.addedDiagnostics.length <= 0) {
              mensaje =
                "No se diligenció un Procedimiento o servicio al paciente. \n ¿Desea guardar la Historia Clínica? ";
              this.setState({
                creationProcess: 1,
                openAlert: true,
                modalAlert: {
                  title: "Advertencia",
                  message: mensaje,
                  color: "warning",
                },
              });
            } else if (this.state.MedicalOrders.formulas.length <= 0) {
              mensaje =
                "No se diligenció una formula al paciente. \n ¿Desea guardar la Historia Clínica? ";
              this.setState({
                creationProcess: 1,
                openAlert: true,
                modalAlert: {
                  title: "Advertencia",
                  message: mensaje,
                  color: "warning",
                },
              });
            } else {
              this.createHistory();
            }
          } else {
            this.createHistory();
          }
          break;
        case 2:
          if (!this.state.hiddenQuerysTabs) {
            if (
              this.state.MedicalOrders.addedDiagnostics.length <= 0 &&
              this.state.MedicalOrders.formulas.length <= 0
            ) {
              mensaje =
                "No se diligenció un Procedimiento ni Formulas al paciente. \n ¿Desea guardar la Historia Clínica? ";
              this.setState({
                creationProcess: 2,
                openAlert: true,
                modalAlert: {
                  title: "Advertencia",
                  message: mensaje,
                  color: "warning",
                },
              });
            } else if (this.state.MedicalOrders.addedDiagnostics.length <= 0) {
              mensaje =
                "No se diligenció un Procedimiento o servicio al paciente. \n ¿Desea guardar la Historia Clínica? ";
              this.setState({
                creationProcess: 2,
                openAlert: true,
                modalAlert: {
                  title: "Advertencia",
                  message: mensaje,
                  color: "warning",
                },
              });
            } else if (this.state.MedicalOrders.formulas.length <= 0) {
              mensaje =
                "No se diligenció una formula al paciente. \n ¿Desea guardar la Historia Clínica? ";
              this.setState({
                creationProcess: 2,
                openAlert: true,
                modalAlert: {
                  title: "Advertencia",
                  message: mensaje,
                  color: "warning",
                },
              });
            } else {
              this.makePdfProcedureAndFormula();
              this.createHistory();
            }
          } else {
            this.makePdfProcedureAndFormula();
            this.createHistory();
          }
          break;
      }
    }
  };

  makePdfFormula = () => {
    const data = {
      from: "HC", //Desde donde se consulta la Formula IMP(impresiones/listadoHC o Admisiones) HC desde dentro de Historia Clinica
      today: new Date(),
      urlLogo: this.state.urlLogo,
      names: this.props.data.fullname,
      day: this.props.data.fecha,
      ordenes: this.state.MedicalOrders.formulas,
      gender: this.props.data.sexo,
      typeOfDocument: this.props.data.tip_documento,
      documentNumber: this.props.data.num_documento,
      profile: this.state.clinic_profile,
      age: calculateAgeParse(this.props.data.birthday),
      birthday: this.props.data.birthday,
      id_admision: this.props.data.id_admision,
      regime: !!this.state.contractInfo
        ? this.state.contractInfo.hasOwnProperty("nom_regimen")
          ? this.state.contractInfo.nom_regimen
          : ""
        : "",
      bloodType: this.state.infoAdmissionPatient.tipo_sangre,
      professional: this.state.professional,
      id_historia: this.props.data.id_historia,
      id_profesional: this.state.id_profesional,
      medicalObservation: this.state.MedicalOrders.medicalObservation,
      third: this.state.third,
      infoAdmission: this.state.infoAdmissionPatient,
    };
    console.log("DATATOPDF", data);
    if (this.state.MedicalOrders.formulas.length != 0) {
      this.setState({ showPDf: true });
      pdfFormula(data);
    } /* else {
      alert("No se han registrado los datos de la formula medica");
    } */
  };

  makePdfProcedure = () => {
    if (this.state.MedicalOrders.addedDiagnostics.length != 0) {
      const data = {
        from: "HC",
        today: new Date(),
        urlLogo: this.state.urlLogo,
        names: this.props.data.fullname,
        gender: this.props.data.sexo,
        typeOfDocument: this.props.data.tip_documento,
        documentNumber: this.props.data.num_documento,
        profile: this.state.clinic_profile,
        age: calculateAgeParse(this.props.data.birthday),
        day: this.props.data.fecha,
        birthday: this.props.data.birthday,
        regime: !!this.state.contractInfo
          ? this.state.contractInfo.hasOwnProperty("nom_regimen")
            ? this.state.contractInfo.nom_regimen
            : ""
          : "",
        bloodType: this.state.infoAdmissionPatient.tipo_sangre,
        ordenes: this.state.MedicalOrders.addedDiagnostics,
        professional: this.state.professional,
        id_profesional: this.state.id_profesional,
        observationAndProcedure:
          this.state.MedicalOrders.observationAndProcedure,
        observations: this.state.MedicalOrders.observations,
        id_historia: this.props.data.id_historia,
        third: this.state.third,
        infoAdmission: this.state.infoAdmissionPatient,
        diagnostico: this.state.Diagnostic,
      };
      console.log("DATATOPDF", data);
      this.setState({ showPDf: true });
      pdfProceduresFormat(data);
    } /* else {
      alert("No se han agregado procedimientos al paciente");
    } */
  };

  loadIncapacityByThisAdmission = () => {
    return new Promise((resolve, reject) => {
      fetch(
        process.env.REACT_APP_PUBLIC_URL +
          "incapacidades-clinicas/consultar-por-admision?id_admision=" +
          this.props.data.id_admision,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            authorization: "Bearer " + sessionStorage.getItem("token"),
          },
        }
      )
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          console.log("cargar incapacidad", data);
          if (!!data) {
            if (!!data.length) {
              resolve(data);
            } else {
              resolve(null);
            }
          } else {
            resolve(null);
          }
        })
        .catch((error) => {
          console.error("Error:", error);
          reject(error);
        });
    });
  };

  makePdfProcedureAndFormula = async () => {
    let isThereAnIncapacityByThisAdmission =
      await this.loadIncapacityByThisAdmission();

    const data = {
      today: new Date(),
      urlLogo: this.state.urlLogo,
      names: this.props.data.fullname,
      gender: this.props.data.sexo,
      typeOfDocument: this.props.data.tip_documento,
      documentNumber: this.props.data.num_documento,
      profile: this.state.clinic_profile,
      age: calculateAgeParse(this.props.data.birthday),
      day: this.props.data.fecha,
      birthday: this.props.data.birthday,
      regime: !!this.state.contractInfo
        ? this.state.contractInfo.hasOwnProperty("nom_regimen")
          ? this.state.contractInfo.nom_regimen
          : ""
        : "",
      ordenes: this.state.MedicalOrders.addedDiagnostics, // ordenes procedimientos
      professional: this.state.professional,
      id_profesional: this.state.id_profesional,
      observationAndProcedure: this.state.MedicalOrders.observationAndProcedure,
      observations: this.state.MedicalOrders.observations, // observaciones de los procedimientos
      today: new Date(),
      ordenes_formula: this.state.MedicalOrders.formulas, // ordenes Formula medica
      id_admision: this.props.data.id_admision,
      id_historia: this.props.data.id_historia,
      medicalObservation: this.state.MedicalOrders.medicalObservation, // observaciones de la formula
      third: this.state.third,
      infoAdmission: this.state.infoAdmissionPatient,
      diagnostico: this.state.Diagnostic,
      address: this.state.infoAdmissionPatient.direccion.direccion,
      city: this.state.infoAdmissionPatient.direccion.ciudad,
      telephone: this.state.infoAdmissionPatient.telefono1,
      cellphone: this.state.infoAdmissionPatient.celu,
      civilStatus: this.state.infoAdmissionPatient.e_civil,
      bloodType: this.state.infoAdmissionPatient.tipo_sangre,
      anamnesis: this.state.anamesis,
      antecedentes: this.state.sectionAilment,
      sistemas: this.state.SystemReview,
      fisico: this.state.PhysicalExam,
      plan: this.state.AnalysisAndMedicalPlan,
      speechTerapy: this.state.SpeechTerapyText,
      otherProcedures: this.state.MedicalProcedures,
      infoIncapacityCurrentAdmision: isThereAnIncapacityByThisAdmission,
      showClinicEvent: this.state.hiddenQuerysTabs,
      amounts: this.state.MedicalOrders.amount, //cantidad de procedimiento y consultas a realizar
    };
    console.log("c3StepPr", data);
    this.setState({ showPDf: true });
    pdfProceduresAndFormula(data);
  };

  loadDataCita = () => {
    var data = { id_cita: parseInt(this.props.data.id_cita) };

    fetch(process.env.REACT_APP_PUBLIC_URL + "agenda/consultarpaciente", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + sessionStorage.getItem("token"),
      },
      body: JSON.stringify(data),
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          infoAdmissionPatient: data.contenido,
          infoPlanCurrentHistory: data.contenido.plan,
          third: data.contenido.third_info,
          contractInfo: data.contenido.contrato,
        });
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  getCriteria = async () => {
    const dataSend = {
      id_visita: this.props.data.id_visita,
      id_estudio: this.props.data.id_estudio,
    };

    await fetch(process.env.REACT_APP_PUBLIC_URL + "criteriose/consultar", {
      // revisar el servicio para que traiga confirmacion
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + sessionStorage.getItem("token"),
      },
      body: JSON.stringify(dataSend),
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (typeof data.contenido != "string") {
          this.setState({
            detailsClinicalStudio: {
              ...this.state.detailsClinicalStudio,
              criterialExcIncData: {
                ...this.state.detailsClinicalStudio.criterialExcIncData,
                inclusion: data.contenido.inclusion,
                exclusion: data.contenido.exclusion,
              },
            },
          });
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  fetchDataProfessionals = async () => {
    await fetch(process.env.REACT_APP_PUBLIC_URL + "profesional/listar", {
      method: "GET",
      headers: {
        authorization: "Bearer " + sessionStorage.getItem("token"),
      },
    })
      .then((response) => {
        return response.json();
      })
      .then((professionals) => {
        this.catchProfessional(professionals);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  catchProfessional = (professionals) => {
    let professional = professionals.find(
      (prof) => prof.id_usuario === this.props.data.id_usuario_profesional
    );
    this.setState({
      professional: professional,
      id_profesional: professional.id_profesional,
    });
  };

  warningToGoBackToClinicsHistoryList = () => {
    let mensaje;
    //if (this.state.errors.anamesis === undefined && this.state.errors.Diagnostic === undefined && this.state.errors.analysisAndMedicalPlan === undefined) {
    if (
      !(
        typeof this.state.errors === "{}" &&
        typeof this.state.errors === "undefined"
      )
    ) {
      if (this.state.stateClinicistory === true) {
        this.goBackFromHistory();
        //console.log("sale");
      } else {
        mensaje =
          "No se ha guardado ninguna información. \n ¿Esta seguro que desea salir de la Historia Clínica que esta abierta actualmente? ";
        this.setState({
          creationProcess: 3,
          openAlert: true,
          modalAlert: {
            title: "Advertencia",
            message: mensaje,
            color: "warning",
          },
        });
      }
    } else {
      if (
        this.state.errors.hasOwnProperty("anamesis") ||
        this.state.errors.hasOwnProperty("Diagnostic") ||
        this.state.errors.hasOwnProperty("analysisAndMedicalPlan")
      ) {
        mensaje =
          "No se ha guardado ninguna información. \n ¿Esta seguro que desea salir de la Historia Clínica que esta abierta actualmente? ";
        this.setState({
          creationProcess: 3,
          openAlert: true,
          modalAlert: {
            title: "Advertencia",
            message: mensaje,
            color: "warning",
          },
        });
      } else {
        console.log(
          "sale",
          this.state.errors.hasOwnProperty("anamesis"),
          typeof this.state.errors === "{}"
        );
        this.goBackFromHistory();
      }
    }
  };

  goBackFromHistory = () => {
    if (this.state.profile === "11") {
      history.push({
        pathname: process.env.PUBLIC_URL + "/assitencial/admissions",
        state: { date: this.props.data.fecha },
      });
    } else {
      history.push({
        pathname: process.env.PUBLIC_URL + "/assitencial/search-clinic-history",
        state: {
          date: this.props.data.fecha,
          estado_list_form: this.props.data.estado_list_form,
          pageIndex: this.props.pageIndex,
        },
      });
    }
  };

  handlerCandidate = (candidate) => {
    if (candidate == true)
      this.setState({ anamesis: { ...this.state.anamesis, candidate: true } });
    else
      this.setState({ anamesis: { ...this.state.anamesis, candidate: false } });
  };

  handlerParticipate = (participate) => {
    if (participate === true) {
      this.setState(
        { anamesis: { ...this.state.anamesis, participate: true } },
        () => {
          this.getCriterialDataClinicalStudio();
        }
      );
    } else {
      this.setState(
        { anamesis: { ...this.state.anamesis, participate: false } },
        () => {}
      );
    }
  };

  handlerAcronym = (acronymValue) => {
    this.setState({
      anamesis: { ...this.state.anamesis, acronym: acronymValue },
    });
  };

  handlerSHouldResultBeUpdated = () => {
    this.setState({
      shouldResultsBeUpdated: !this.state.shouldResultsBeUpdated,
    });
  };

  handlerCriterialExclusionAndInclusion = (value, type, index) => {
    if (type == "INCLUSION") {
      //Radios de Criterios de Inclusion
      let confirmacionData = true;
      if (value === "Sí") {
        confirmacionData = true;
      } else {
        confirmacionData = false;
      }
      let newDataInc =
        this.state.detailsClinicalStudio.criterialExcIncData.inclusion.slice();
      newDataInc[index].confirmacion = confirmacionData;
      this.setState({
        detailsClinicalStudio: {
          ...this.state.detailsClinicalStudio,
          criterialExcIncData: {
            ...this.state.detailsClinicalStudio.criterialExcIncData,
            inclusion: newDataInc,
          },
        },
      });
    } else if (type == "EXCLUSION") {
      //Radios de Criterios de Exclusion
      let confirmacionData = true;
      if (value === "Sí") {
        confirmacionData = true;
      } else {
        confirmacionData = false;
      }
      let newDataInc =
        this.state.detailsClinicalStudio.criterialExcIncData.exclusion.slice();
      newDataInc[index].confirmacion = confirmacionData;
      this.setState({
        detailsClinicalStudio: {
          ...this.state.detailsClinicalStudio,
          criterialExcIncData: {
            ...this.state.detailsClinicalStudio.criterialExcIncData,
            exclusion: newDataInc,
          },
        },
      });
    } else if (type == "ENROLAMIENTO") {
      //Enrolamiento del Paciente
      this.setState(
        {
          detailsClinicalStudio: {
            ...this.state.detailsClinicalStudio,
            criterialExcIncData: {
              ...this.state.detailsClinicalStudio.criterialExcIncData,
              enrolado: value,
            },
          },
        },
        () => {
          console.log(
            "criterialExcIncData",
            this.state.detailsClinicalStudio.criterialExcIncData
          );
        }
      );
    } else {
      alert("Opción no Disponible");
    }
  };

  render() {
    const { activeTab } = this.state;

    return (
      <Col>
        <Col md={12}>
          <Row>
            <Col md={2}>
              <h3 className="title-inside-clinic-history">Historia Clínica</h3>
              <div className="top_info_buttons_hc">
                <div>
                  <Tooltip title="Regresar a la Agenda ">
                    <IconButton
                      aria-label="upload picture"
                      component="span"
                      className="tooltip-top"
                      onClick={() => {
                        this.warningToGoBackToClinicsHistoryList();
                      }}
                    >
                      <ArrowBackIcon style={{ color: "#153365" }} />
                    </IconButton>
                  </Tooltip>
                  <span style={{ marginLeft: "0.25em" }}>
                    Regresar a la Agenda
                  </span>
                </div>
                <div className="button-actions">
                  {this.state.stateClinicistory === true ||
                  (this.state.profile !== "9" &&
                    this.state.profile !== "10" &&
                    this.state.profile !== "11") ? (
                    !!this.state.dateAtReopenClinicHistory &&
                    !!this.state.dateFirstClosureClinicHistory ? (
                      moment().isBetween(
                        moment(this.state.dateFirstClosureClinicHistory),
                        moment(this.state.dateAtReopenClinicHistory),
                        "second"
                      ) ? (
                        <Fragment>
                          <div>
                            <Button
                              color="primary"
                              size="sm"
                              style={{ marginBottom: ".25em" }}
                              onClick={() => {
                                this.reopenEventHistory();
                              }}
                            >
                              <FontAwesomeIcon icon={faArrowRotateLeft} />
                              Reabrir Historia Clínica
                            </Button>
                          </div>
                          <div>
                            <span>
                              Esta Historia Clínica se puede volver abrir hasta
                              las{" "}
                              <b>
                                {moment(this.state.dateAtReopenClinicHistory)
                                  .tz("America/Bogota")
                                  .format("h:mm a")}
                              </b>{" "}
                              del día{" "}
                              <b>
                                {moment(this.state.dateAtReopenClinicHistory)
                                  .tz("America/Bogota")
                                  .format("DD-MM-YYYY")}{" "}
                              </b>
                            </span>
                          </div>
                        </Fragment>
                      ) : null
                    ) : null
                  ) : (
                    <Fragment>
                      <div>
                        <Button
                          color="primary"
                          size="sm"
                          style={{ marginBottom: ".25em" }}
                          onClick={() => {
                            this.validateOrdenes(1);
                          }}
                        >
                          Salir
                        </Button>
                      </div>
                      {this.state.profileName !== "RECEPCION" && (
                        <div>
                          <Button
                            color="primary"
                            size="sm"
                            style={{
                              marginLeft: "auto",
                              marginBottom: ".25em",
                            }}
                            onClick={() => {
                              this.validateOrdenes(2);
                            }}
                          >
                            Salir e Imprimir
                          </Button>
                        </div>
                      )}
                    </Fragment>
                  )}
                </div>
              </div>
            </Col>

            <Col md={10}>
              <PatientInformation
                num_documento={this.props.data.num_documento}
                nombres={this.props.data.nombres}
                tip_documento={this.props.data.tip_documento}
                birthday={this.props.data.birthday}
                remitente={this.props.data.remitente}
                servicios={this.props.data.servicios}
                infoPatient={this.props.data}
                weight={this.state.PhysicalExam.weight}
                height={this.state.PhysicalExam.size}
                refreshInfoPatient={this.state.refreshInfoPatient}
                imc={this.state.PhysicalExam.BMI}
                bodySurface={this.state.PhysicalExam.bodySurface}
                riesgo_caidas={this.props.data.riesgo_caidas}
                requerimientos_especiales={
                  this.props.data.requerimientos_especiales
                }
                id_admision={this.props.data.id_admision}
                stateClinicHistory={this.state.stateClinicistory}
                clinicalStudyHistory={this.props.data.studio}
                thirdInfo={this.state.third}
                colorAlergiesIcon={this.state.colorAlergiesIcon}
                infoPlanCurrentHistory={this.state.infoPlanCurrentHistory}
                contractInfo={this.state.contractInfo}
              />
            </Col>
          </Row>
          <Card>
            <CardBody>
              <div className="tabs tabs--bordered-top">
                <div className="tabs__wrap">
                  <Nav tabs>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "1" })}
                        onClick={() => {
                          this.toggle("1");
                        }}
                      >
                        Datos Básicos
                      </NavLink>
                    </NavItem>

                    {/* Estas tabs solo se permiten para el modulo 32 */}
                    {this.state.userPermits.includes(32) ? (
                      <>
                        {this.state.hiddenQuerysTabs == false ||
                        this.state.hiddenAnamnesis == false ? (
                          <NavItem>
                            <NavLink
                              className={classnames({
                                active: activeTab === "2",
                              })}
                              onClick={() => {
                                this.toggle("2");
                              }}
                            >
                              Anamnesis
                            </NavLink>
                          </NavItem>
                        ) : null}

                        {this.state.hiddenQuerysTabs == false ? (
                          <NavItem>
                            <NavLink
                              className={classnames({
                                active: activeTab === "3",
                              })}
                              onClick={() => {
                                this.toggle("3");
                              }}
                            >
                              Antecedentes
                            </NavLink>
                          </NavItem>
                        ) : null}

                        {this.state.hiddenQuerysTabs == false ? (
                          <NavItem>
                            <NavLink
                              className={classnames({
                                active: activeTab === "4",
                              })}
                              onClick={() => {
                                this.toggle("4");
                              }}
                            >
                              Revisión por Sistema
                            </NavLink>
                          </NavItem>
                        ) : null}

                        {this.state.hiddenQuerysTabs == false ? (
                          <NavItem>
                            <NavLink
                              className={classnames({
                                active: activeTab === "5",
                              })}
                              onClick={() => {
                                this.toggle("5");
                              }}
                            >
                              Examen Físico
                            </NavLink>
                          </NavItem>
                        ) : null}

                        {this.state.userPermits.includes(32) ||
                        this.state.userPermits.includes(33) ? (
                          <NavItem>
                            <NavLink
                              className={classnames({
                                active: activeTab === "6",
                              })}
                              onClick={() => {
                                this.toggle("6");
                              }}
                            >
                              Diagnostico
                            </NavLink>
                          </NavItem>
                        ) : null}

                        {this.state.hiddenQuerysTabs == false ? (
                          <NavItem>
                            <NavLink
                              className={classnames({
                                active: activeTab === "7",
                              })}
                              onClick={() => {
                                this.toggle("7");
                              }}
                            >
                              Análisis y Plan Médico
                            </NavLink>
                          </NavItem>
                        ) : null}

                        {this.state.userPermits.includes(34) ? (
                          <NavItem>
                            <NavLink
                              className={classnames({
                                active: activeTab === "12",
                              })}
                              onClick={() => {
                                this.toggle("12");
                              }}
                            >
                              Procedimiento Audiologico
                            </NavLink>
                          </NavItem>
                        ) : null}

                        {this.state.hiddenQuerysTabs == false ? (
                          <NavItem>
                            <NavLink
                              className={classnames({
                                active: activeTab === "8",
                              })}
                              onClick={() => {
                                this.toggle("8");
                              }}
                            >
                              Ordenes Médicas
                            </NavLink>
                          </NavItem>
                        ) : null}
                      </>
                    ) : null}

                    {/* Estas tabs solo se permiten para el modulo 32 o 33 */}
                    {this.state.userPermits.includes(32) ||
                    this.state.userPermits.includes(33) ? (
                      <>
                        {this.state.profileName === "RECEPCION" && (
                          <NavItem>
                            <NavLink
                              className={classnames({
                                active: activeTab === "6",
                              })}
                              onClick={() => {
                                this.toggle("6");
                              }}
                            >
                              Diagnostico
                            </NavLink>
                          </NavItem>
                        )}

                        <NavItem>
                          <NavLink
                            className={classnames({
                              active: activeTab === "19",
                            })}
                            onClick={() => {
                              this.toggle("19");
                            }}
                          >
                            Resultados Institucionales
                          </NavLink>
                        </NavItem>
                        {this.state.hiddenQuerysTabs ? (
                          <NavItem>
                            <NavLink
                              className={classnames({
                                active: activeTab === "9",
                              })}
                              onClick={() => {
                                this.toggle("9");
                              }}
                            >
                              Procedimientos
                            </NavLink>
                          </NavItem>
                        ) : null}
                        {/* {
                            this.state.hiddenQuerysTabs == false ? <NavItem>
                              <NavLink
                                className={classnames({ active: activeTab === '18' })}
                                onClick={() => {
                                  this.toggle('18');
                                }}
                              >
                                Incapacidad Médica
                              </NavLink>
                            </NavItem> : null
                          } */}
                        {/* <NavItem>
                            <NavLink
                              className={classnames({ active: activeTab === '10' })}
                              onClick={() => {
                                this.toggle('10');
                              }}
                            >
                              Notas Clinicas
                            </NavLink>
                          </NavItem> */}
                      </>
                    ) : null}

                    {this.state.userPermits.includes(32) ? (
                      <NavItem>
                        <NavLink
                          className={classnames({ active: activeTab === "11" })}
                          onClick={() => {
                            this.toggle("11");
                          }}
                        >
                          Documentos Fuente
                        </NavLink>
                      </NavItem>
                    ) : null}

                    {this.state.anamesis.participate == true ? (
                      <>
                        <NavItem>
                          <NavLink
                            className={classnames({
                              active: activeTab === "13",
                            })}
                            onClick={() => {
                              this.toggle("13");
                            }}
                          >
                            Criterios de Inclusión y Exclusión
                          </NavLink>
                        </NavItem>
                        <NavItem>
                          <NavLink
                            className={classnames({
                              active: activeTab === "14",
                            })}
                            onClick={() => {
                              this.toggle("14");
                            }}
                          >
                            Consentimiento Informado
                          </NavLink>
                        </NavItem>

                        {/*
                          <NavItem>
                            <NavLink
                              className={classnames({ active: activeTab === '15' })}
                              onClick={() => {
                                this.toggle('15');
                              }}
                            >
                              Eventos Adversos
                            </NavLink>
                          </NavItem>

                          <NavItem>
                            <NavLink
                              className={classnames({ active: activeTab === '16' })}
                              onClick={() => {
                                this.toggle('16');
                              }}
                            >
                              Desviaciones Protocolo
                            </NavLink>
                          </NavItem>*/}

                        {/*
                            <NavItem>
                              <NavLink
                                className={classnames({ active: activeTab === '17' })}
                                onClick={() => {
                                  this.toggle('17');
                                }}
                              >
                                Checkeo de Actividades
                              </NavLink>
                            </NavItem>
                          */}
                      </>
                    ) : null}
                  </Nav>
                </div>
                <TabContent activeTab={activeTab}>
                  <TabPane tabId="1">
                    <BasicDataPatient
                      dataPatient={
                        this.props.data !== undefined
                          ? this.props.data
                          : this.props.location.state.dataPatient.num_documento
                      }
                      handlerDocumentNumberDataInfo={
                        this.handlerDocumentNumberDataInfo
                      }
                      handlerTypeOfDocumentDataInfo={
                        this.handlerTypeOfDocumentDataInfo
                      }
                      handlerNamesDataInfo={this.handlerNamesDataInfo}
                      handlerFirstLastNameDataInfo={
                        this.handlerFirstLastNameDataInfo
                      }
                      handlerSecondLastNameDataInfo={
                        this.handlerSecondLastNameDataInfo
                      }
                      handlerBirthDateDataInfo={this.handlerBirthDateDataInfo}
                      refreshInfoPatient={this.state.refreshInfoPatient}
                      height={this.state.PhysicalExam.size}
                      weight={this.state.PhysicalExam.weight}
                      imc={this.state.PhysicalExam.BMI}
                      handlerWeightDataInfo={this.handlerWeight}
                      handlerHeightDataInfo={this.handlerSize}
                      handlerAgeDataInfo={this.handlerAgeDataInfo}
                      informacion_femenina={this.state.informacion_femenina}
                      handlerInfoFemMenopausia={this.handlerInfoFemMenopausia}
                      handlerInfoFemMenstruacion={
                        this.handlerInfoFemMenstruacion
                      }
                      handlerInfoFemPlanificacion={
                        this.handlerInfoFemPlanificacion
                      }
                      handlerInfoFemEmbarazo={this.handlerInfoFemEmbarazo}
                    />{" "}
                    {/*this.props.data.num_documento*/}
                  </TabPane>
                  <TabPane tabId="2">
                    {this.state.hiddenQuerysTabs == false ||
                    this.state.hiddenAnamnesis == false ? (
                      <Ananmesis
                        id_historia={this.props.data.id_historia}
                        id_admision={this.props.data.id_admision}
                        loadAnamesis={this.loadAnamesis}
                        anamesis={this.state.anamesis}
                        handlerSelectCauseOfAdmission={
                          this.handlerSelectCauseOfAdmission
                        }
                        handlerReasonForConsultation={
                          this.handlerReasonForConsultation
                        }
                        handlerCurrentIllness={this.handlerCurrentIllness}
                        dataClinicalStudio={this.state.dataClinicalStudio}
                        handlerParticipate={this.handlerParticipate}
                        handlerCandidate={this.handlerCandidate}
                        handlerAcronym={this.handlerAcronym}
                        isCloseClinicHistory={this.state.stateClinicistory}
                      />
                    ) : null}
                  </TabPane>
                  <TabPane tabId="3">
                    {this.state.hiddenQuerysTabs == false ? (
                      <PatientBackground
                        sectionAilment={this.state.sectionAilment}
                        searchMedicaments={this.searchMedicaments}
                        handlerPathologicalBackgroundRadio={
                          this.handlerPathologicalBackgroundRadio
                        }
                        handlerPathologicalBackgroundText={
                          this.handlerPathologicalBackgroundText
                        }
                        handlerPathologicsObservation={
                          this.handlerPathologicsObservation
                        }
                        handlerSurgicalsBackgroundRadio={
                          this.handlerSurgicalsBackgroundRadio
                        }
                        handlerSurgicalsBackgroundText={
                          this.handlerSurgicalsBackgroundText
                        }
                        handlerSurgicalsBackgroundObservation={
                          this.handlerSurgicalsBackgroundObservation
                        }
                        handlerPharmacologicalBackgroundRadio={
                          this.handlerPharmacologicalBackgroundRadio
                        }
                        handlerPharmacologicalBackgroundText={
                          this.handlerPharmacologicalBackgroundText
                        }
                        handlerPharmacologicalBackgroundTableAdd={
                          this.handlerPharmacologicalBackgroundTableAdd
                        }
                        handlerPharmacologicalBackgroundTableDelete={
                          this.handlerPharmacologicalBackgroundTableDelete
                        }
                        handlerPharmacologicalBackgroundObservation={
                          this.handlerPharmacologicalBackgroundObservation
                        }
                        handlerGynecologistBackgroundRadio={
                          this.handlerGynecologistBackgroundRadio
                        }
                        handlerGynecologistBackgroundText={
                          this.handlerGynecologistBackgroundText
                        }
                        handlerGynecologistBackgroundObservation={
                          this.handlerGynecologistBackgroundObservation
                        }
                        handlerFamilyBackgroundRadio={
                          this.handlerFamilyBackgroundRadio
                        }
                        handlerFamilyBackgroundText={
                          this.handlerFamilyBackgroundText
                        }
                        handlerFamilyBackgroundObservation={
                          this.handlerFamilyBackgroundObservation
                        }
                        handlerOthersBackgroundRadio={
                          this.handlerOthersBackgroundRadio
                        }
                        handlerOthersBackgroundText={
                          this.handlerOthersBackgroundText
                        }
                        handlerOthersBackgroundObservation={
                          this.handlerOthersBackgroundObservation
                        }
                        handlerInmunizationsBackgroundRadio={
                          this.handlerInmunizationsBackgroundRadio
                        }
                        handlerInmunizationsBackgroundText={
                          this.handlerInmunizationsBackgroundText
                        }
                        handlerInmunizationsBackgroundTableAdd={
                          this.handlerInmunizationsBackgroundTableAdd
                        }
                        handlerInmunizationsBackgroundTableDelete={
                          this.handlerInmunizationsBackgroundTableDelete
                        }
                        handlerInmunizationsBackgroundObservation={
                          this.handlerInmunizationsBackgroundObservation
                        }
                        handlerHabits={this.handlerHabits}
                        calculateSmoke={this.calculateSmoke}
                        sections={sections}
                        ailments={ailments}
                        loadBackgroud={this.loadBackgroud}
                        handlerAilment={this.handlerAilment}
                        handlerComments={this.handlerComments}
                        handlerCommentary={this.handlerCommentary}
                        handlerAlimentTable={this.handlerAlimentTable}
                        gender={this.props.data.sexo}
                        handlerObservation={this.handlerObservation}
                        id_historia={
                          this.props.data !== undefined
                            ? this.props.data.id_historia
                            : this.props.location.state.dataPatient.id_historia
                        }
                        stateClinicHistory={this.state.stateClinicistory}
                        dataPatient={
                          this.props.data !== undefined
                            ? this.props.data
                            : this.props.location.state.dataPatient
                                .num_documento
                        }
                        handlerFormulasNewFunctional={
                          this.handlerFormulasNewFunctional
                        }
                        handlerChangeColorAlergies={
                          this.handlerChangeColorAlergies
                        }
                      />
                    ) : null}
                  </TabPane>
                  <TabPane tabId="4">
                    {this.state.hiddenQuerysTabs == false ? (
                      <SystemReview
                        ailments={this.state.SystemReview.ailments}
                        loadSystemReview={this.loadSystemReview}
                        handlerCommentsSystemReview={
                          this.handlerCommentsSystemReview
                        }
                        templates={this.state.templates}
                        isCloseClinicHistory={this.state.stateClinicistory}
                      />
                    ) : null}
                  </TabPane>
                  <TabPane tabId="5">
                    {this.state.hiddenQuerysTabs == false ? (
                      <PhysicalExam
                        PhysicalExam={this.state.PhysicalExam}
                        loadPhysicalExam={this.loadPhysicalExam}
                        handlerPhysicalExam={this.handlerPhysicalExam}
                        handlerWeight={this.handlerWeight}
                        handlerSize={this.handlerSize}
                        calculateSurfaceBody={this.calculateSurfaceBody}
                        gender={this.props.data.sexo}
                        templates={this.state.templates}
                        isCloseClinicHistory={this.state.stateClinicistory}
                      />
                    ) : null}
                  </TabPane>
                  <TabPane tabId="6">
                    <Diagnostic
                      stateClinicHistory={this.state.stateClinicistory}
                      id_historia={this.props.data.id_historia}
                      id_admision={this.props.data.id_admision}
                      Diagnostic={this.state.Diagnostic}
                      loadDiagnostic={this.loadDiagnostic}
                      handlerCUPS={this.handlerCUPS}
                      handlerDiagnosticName={this.handlerDiagnosticName}
                      searchDiagnostic={this.searchCIE}
                      selectDiagnostic={this.selectDiagnostic}
                      addDiagnostic={this.addDiagnostic}
                      addObservation={this.handlerAddObservationDiagnostic}
                      removeDiagnostic={this.removeDiagnostic}
                      handlerAddTypeDiagnostic={this.handlerAddTypeDiagnostic}
                      handlerDiagnosticGeneralObervation={
                        this.handlerDiagnosticGeneralObervation
                      }
                    />
                  </TabPane>
                  <TabPane tabId="7">
                    {this.state.hiddenQuerysTabs == false ? (
                      <AnalysisAndMedicalPlan
                        AnalysisAndMedicalPlan={
                          this.state.AnalysisAndMedicalPlan
                        }
                        loadAnalysisAndMedicalPlan={
                          this.loadAnalysisAndMedicalPlan
                        }
                        handlerAnalysis={this.handlerAnalysis}
                        handlerPlan={this.handlerPlan}
                        handlerRecommendations={this.handlerRecommendations}
                        isCloseClinicHistory={this.state.stateClinicistory}
                      />
                    ) : null}
                  </TabPane>
                  <TabPane tabId="8">
                    {this.state.hiddenQuerysTabs == false ? (
                      <Fragment>
                        <MedicalOrders
                          ailments={this.state.sectionAilment.ailments[2]}
                          id_historia={this.props.data.id_historia}
                          id_admision={this.props.data.id_admision}
                          MedicalOrders={this.state.MedicalOrders}
                          loadMedicalOrders={this.loadMedicalOrders}
                          handlerCUPS={this.handlerMedicalOrdersCUPS}
                          handlerDiagnosticName={
                            this.handlerMedicalOrdersDiagnosticName
                          }
                          searchDiagnostic={this.searchDiagnostic}
                          selectDiagnostic={this.selectMedicalOrdersDiagnostic}
                          searchMedicalOrders={this.searchMedicalOrders}
                          searchMedicaments={this.searchMedicaments}
                          addDiagnostic={this.addMedicalOrderDiagnostic}
                          removeDiagnostic={this.removeMedicalOrderDiagnostic}
                          addObservation={this.handlerAddObservation}
                          handlerMedicalOrderTime={this.handlerMedicalOrderTime}
                          handlerFormulasNew={this.handlerFormulasNew}
                          removeFormula={this.removeFormula}
                          handlerObservationAndProcedureTextMedicalOrder={
                            this.handlerObservationAndProcedureTextMedicalOrder
                          }
                          handlerMedicalObservationTextMedicalOrder={
                            this.handlerMedicalObservationTextMedicalOrder
                          }
                          isCloseClinicHistory={this.state.stateClinicistory}
                          data={this.props.data}
                          profesional={this.state.professional}
                          infoAdmission={this.state.infoAdmissionPatient}
                          thirdInfo={this.state.third}
                          diagnostic={this.state.Diagnostic}
                          handlerAmountExams={this.handlerAmountExams}
                        />
                        <MedicalOrdersFunctionalCom
                          ailments={this.state.sectionAilment.ailments[2]}
                          id_historia={this.props.data.id_historia}
                          id_admision={this.props.data.id_admision}
                          MedicalOrders={this.state.MedicalOrders}
                          loadMedicalOrders={this.loadMedicalOrders}
                          handlerCUPS={this.handlerMedicalOrdersCUPS}
                          handlerDiagnosticName={
                            this.handlerMedicalOrdersDiagnosticName
                          }
                          searchDiagnostic={this.searchDiagnostic}
                          selectDiagnostic={this.selectMedicalOrdersDiagnostic}
                          searchMedicalOrders={this.searchMedicalOrders}
                          searchMedicaments={this.searchMedicaments}
                          addDiagnostic={this.addMedicalOrderDiagnostic}
                          removeDiagnostic={this.removeMedicalOrderDiagnostic}
                          addObservation={this.handlerAddObservation}
                          handlerMedicalOrderTime={this.handlerMedicalOrderTime}
                          handlerFormulasNew={this.handlerFormulasNewFunctional}
                          removeFormula={this.removeFormula}
                          handlerObservationAndProcedureTextMedicalOrder={
                            this.handlerObservationAndProcedureTextMedicalOrder
                          }
                          handlerMedicalObservationTextMedicalOrder={
                            this.handlerMedicalObservationTextMedicalOrder
                          }
                          isCloseClinicHistory={this.state.stateClinicistory}
                          formulasFromPharmacological={
                            this.state.sectionAilment.pharmacological
                              .farmacologico.table
                          }
                          removeFormulaByIndex={this.removeFormulaByIndex}
                          onEditFormulaFromMedicalOrders={
                            this.onEditFormulaFromMedicalOrders
                          }
                        />
                      </Fragment>
                    ) : null}
                  </TabPane>
                  <TabPane tabId="19">
                    <Results
                      id_historia={this.props.data.id_historia}
                      id_admision={this.props.data.id_admision}
                      medicalProcedures={this.state.MedicalProcedures}
                      shouldResultsBeUpdated={this.state.shouldResultsBeUpdated}
                      handlerSHouldResultBeUpdated={
                        this.handlerSHouldResultBeUpdated
                      }
                    />
                  </TabPane>
                  <TabPane tabId="9">
                    <MedicalProcedures
                      shouldEnabledProcedureTab={
                        this.state.shouldEnabledProcedureTab
                      }
                      examResults={this.state.examResults}
                      MedicalProcedures={this.state.MedicalProcedures}
                      loadMedicalProcedures={this.loadMedicalProcedures}
                      handlerMedicalProcedures={this.handlerMedicalProcedures}
                      handlerMedications={this.handlerMedications}
                      selectMedicament={this.selectMedicament}
                      searchMedications={this.searchMedications}
                      addMedicament={this.addMedicament}
                      removeMedicament={this.removeMedicament}
                      createHistory={this.createHistory}
                      id_historia={this.props.data.id_historia}
                      id_admision={this.props.data.id_admision}
                      num_documento={this.props.data.num_documento}
                      templates={this.state.templates}
                      enabledTabsProcedures={this.state.enabledTabsProcedures}
                      isDoctor={this.state.userPermits.includes(32)}
                      saveProceduresPatient={this.saveProceduresPatient}
                      handlerFileProcedure={this.handlerFileProcedure}
                      FileProcedure={this.state.FileProcedure}
                      isCloseClinicHistory={this.state.stateClinicistory}
                      handlerNameTemplete={
                        this.handlerDefineNameTemplMedicalProcedures
                      }
                      dropDeletedFileProcedureFromState={
                        this.dropDeletedFileProcedureFromState
                      }
                      loadFileProcedure={this.loadFileProcedure}
                      uploadFileProcedure={this.state.uploadFileProcedure}
                    />
                  </TabPane>

                  <TabPane tabId="10">
                    <Notes data={this.props.data} />
                  </TabPane>

                  <TabPane tabId="11">
                    <SourceDocuments
                      id_historia={this.props.data.id_historia}
                      id_admision={this.props.data.id_admision}
                    />
                  </TabPane>

                  <TabPane tabId="12">
                    {this.state.userPermits.includes(34) ? (
                      <SpeechTerapy
                        speechTerapyText={this.state.SpeechTerapyText}
                        data={this.props.data}
                        handlerSpeechTerapy={this.handlerSpeechTerapy}
                      />
                    ) : null}
                  </TabPane>

                  <TabPane tabId="13">
                    {this.state.anamesis.participate == true ? (
                      <CriterialExclutionAndInclution
                        id_historia={this.props.data.id_historia}
                        id_admision={this.props.data.id_admision}
                        id_paciente={this.props.data.id_paciente}
                        id_visita={this.props.data.id_visita}
                        id_estudio={this.props.data.id_estudio}
                        criterialExcIncData={
                          this.state.detailsClinicalStudio.criterialExcIncData
                        }
                        handlerCriterialExclusionAndInclusion={(
                          value,
                          type,
                          index
                        ) => {
                          this.handlerCriterialExclusionAndInclusion(
                            value,
                            type,
                            index
                          );
                        }}
                        textPatientStudioContain={
                          this.state.textPatientStudioContain
                        }
                      />
                    ) : null}
                  </TabPane>

                  <TabPane tabId="14">
                    {this.state.anamesis.participate == true ? (
                      <InformedConsent
                        id_historia={this.props.data.id_historia}
                        id_admision={this.props.data.id_admision}
                        id_estudio={this.props.data.id_estudio}
                        dataInformedConsent={
                          this.state.detailsClinicalStudio.dataInformedConsent
                        }
                        loadDataInformetConsentClinicalStudio={(
                          dataInformedConsentClinicalStudio
                        ) => {
                          this.setState({
                            detailsClinicalStudio: {
                              ...this.state.detailsClinicalStudio,
                              dataInformedConsent:
                                dataInformedConsentClinicalStudio,
                            },
                          });
                          let data =
                            this.state.detailsClinicalStudio
                              .dataInformedConsent;
                        }}
                      />
                    ) : null}
                  </TabPane>

                  <TabPane tabId="15">
                    {/*///
                      this.state.anamesis.participate == true ?
                        <>
                          <EventAdverse
                            searchDiagnostic={this.searchCIE}
                            id_historia={this.props.data.id_historia}
                            id_admision={this.props.data.id_admision} />
                        </>
                        : null
                    */}
                  </TabPane>

                  <TabPane tabId="16">
                    {/*
                      this.state.anamesis.participate == true ?
                        <>
                          <ProtocolDeviations
                            id_historia={this.props.data.id_historia}
                            id_admision={this.props.data.id_admision} />
                        </> : null
                    */}
                  </TabPane>

                  <TabPane tabId="17">
                    {/*
                      this.state.anamesis.participate == true ?
                        <>
                          <ActivityVisitsPatient data={this.props.data} />
                        </> : null
                  */}
                  </TabPane>
                  {/* <TabPane tabId="18">
                    <MedicalIncapacity data={this.props.data} profesional={this.state.professional} infoAdmission={this.state.infoAdmissionPatient} thirdInfo={this.state.third} diagnostic={this.state.Diagnostic} />
                  </TabPane> */}
                </TabContent>
              </div>

              <Modal
                open={this.state.openErrors}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                style={{ zIndex: 1000 }}
                onClose={() => {
                  this.setState({ openErrors: false, btnActive: true });
                }}
              >
                <div
                  style={{
                    position: "absolute",
                    backgroundColor: "#ffffff",
                    width: 400,
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%,-50%)",
                    display: "flex",
                    margin: 10,
                    padding: 20,
                    flexDirection: "column",
                  }}
                >
                  <div>
                    {this.state.errors.anamesis !== undefined ? (
                      <>
                        <div>
                          <h5>Anamesis</h5>
                          <div style={{ marginLeft: 20 }}>
                            {this.state.errors.anamesis.hasOwnProperty(
                              "cause"
                            ) ? (
                              <p>
                                <span role="img" aria-label="warning">
                                  ⚠
                                </span>{" "}
                                {this.state.errors.anamesis.cause}
                              </p>
                            ) : null}
                            {this.state.errors.anamesis.hasOwnProperty(
                              "reasonForConsultation"
                            ) ? (
                              <p>
                                <span role="img" aria-label="warning">
                                  ⚠
                                </span>{" "}
                                {
                                  this.state.errors.anamesis
                                    .reasonForConsultation
                                }
                              </p>
                            ) : null}
                            {this.state.errors.anamesis.hasOwnProperty(
                              "currentIllness"
                            ) ? (
                              <p>
                                <span role="img" aria-label="warning">
                                  ⚠
                                </span>{" "}
                                {this.state.errors.anamesis.currentIllness}
                              </p>
                            ) : null}
                          </div>
                        </div>
                      </>
                    ) : null}
                  </div>
                  <div>
                    {this.state.errors.habits !== undefined ? (
                      <>
                        <div>
                          <h5>Habitos</h5>
                          <div style={{ marginLeft: 20 }}>
                            {this.state.errors.habits.hasOwnProperty(
                              "differenceYearStartSmoke"
                            ) ? (
                              <p>
                                <span role="img" aria-label="warning">
                                  ⚠
                                </span>{" "}
                                {
                                  this.state.errors.habits
                                    .differenceYearStartSmoke
                                }
                              </p>
                            ) : null}
                            {this.state.errors.habits.hasOwnProperty(
                              "differenceYearEndSmoke"
                            ) ? (
                              <p>
                                <span role="img" aria-label="warning">
                                  ⚠
                                </span>{" "}
                                {
                                  this.state.errors.habits
                                    .differenceYearEndSmoke
                                }
                              </p>
                            ) : null}
                          </div>
                        </div>
                      </>
                    ) : null}
                  </div>
                  <div>
                    {this.state.errors.Diagnostic !== undefined ? (
                      <>
                        <div>
                          <h5>Diagnostico</h5>
                          <div style={{ marginLeft: 20 }}>
                            {this.state.errors.hasOwnProperty("Diagnostic") ? (
                              <p>
                                <span role="img" aria-label="warning">
                                  ⚠
                                </span>{" "}
                                {this.state.errors.Diagnostic}
                              </p>
                            ) : null}
                          </div>
                        </div>
                      </>
                    ) : null}
                  </div>
                  <div>
                    {this.state.errors.PhysicalExam !== undefined ? (
                      <>
                        <div>
                          <h5>Examen Físico</h5>
                          <div style={{ marginLeft: 20 }}>
                            {this.state.errors.hasOwnProperty(
                              "PhysicalExam"
                            ) ? (
                              <p>
                                <span role="img" aria-label="warning">
                                  ⚠
                                </span>{" "}
                                {this.state.errors.PhysicalExam}
                              </p>
                            ) : null}
                          </div>
                        </div>
                      </>
                    ) : null}
                  </div>
                  <div>
                    {this.state.errors.SpeechTerapyText !== undefined ? (
                      <>
                        <div>
                          <h5>Procedimiento Audiologico</h5>
                          <div style={{ marginLeft: 20 }}>
                            {this.state.errors.hasOwnProperty(
                              "SpeechTerapyText"
                            ) ? (
                              <p>
                                <span role="img" aria-label="warning">
                                  ⚠
                                </span>{" "}
                                {this.state.errors.SpeechTerapyText}
                              </p>
                            ) : null}
                          </div>
                        </div>
                      </>
                    ) : null}
                  </div>
                  <div>
                    {this.state.errors.clinicalStudio != undefined ? (
                      <>
                        <div>
                          <h5>Estudio Clinico</h5>
                          <div style={{ marginLeft: 20 }}>
                            {this.state.errors.clinicalStudio.hasOwnProperty(
                              "criterialInclusion"
                            ) ? (
                              <p>
                                <span role="img" aria-label="warning">
                                  ⚠
                                </span>{" "}
                                {
                                  this.state.errors.clinicalStudio
                                    .criterialInclusion
                                }
                              </p>
                            ) : null}

                            {this.state.errors.clinicalStudio.hasOwnProperty(
                              "criterialExclusion"
                            ) ? (
                              <p>
                                <span role="img" aria-label="warning">
                                  ⚠
                                </span>{" "}
                                {
                                  this.state.errors.clinicalStudio
                                    .criterialExclusion
                                }
                              </p>
                            ) : null}

                            {this.state.errors.clinicalStudio.hasOwnProperty(
                              "dataInformedConsent"
                            ) ? (
                              <p>
                                <span role="img" aria-label="warning">
                                  ⚠
                                </span>{" "}
                                {
                                  this.state.errors.clinicalStudio
                                    .dataInformedConsent
                                }
                              </p>
                            ) : null}
                          </div>
                        </div>
                      </>
                    ) : null}
                  </div>
                  <div style={{ marginTop: 10 }}>
                    {this.state.errors.analysisAndMedicalPlan !== undefined ? (
                      <>
                        <div>
                          <h5>Analisis y plan medico</h5>
                          <div style={{ marginLeft: 20 }}>
                            {this.state.errors.analysisAndMedicalPlan.hasOwnProperty(
                              "analysis"
                            ) ? (
                              <p>
                                <span role="img" aria-label="warning">
                                  ⚠
                                </span>{" "}
                                {
                                  this.state.errors.analysisAndMedicalPlan
                                    .analysis
                                }
                              </p>
                            ) : null}
                            {this.state.errors.analysisAndMedicalPlan.hasOwnProperty(
                              "plan"
                            ) ? (
                              <p>
                                <span role="img" aria-label="warning">
                                  ⚠
                                </span>{" "}
                                {this.state.errors.analysisAndMedicalPlan.plan}
                              </p>
                            ) : null}
                            {this.state.errors.analysisAndMedicalPlan.hasOwnProperty(
                              "recommendations"
                            ) ? (
                              <p>
                                <span role="img" aria-label="warning">
                                  ⚠
                                </span>
                                {
                                  this.state.errors.analysisAndMedicalPlan
                                    .recommendations
                                }
                              </p>
                            ) : null}
                          </div>
                        </div>
                      </>
                    ) : null}
                  </div>
                </div>
              </Modal>

              <ModalMessage
                color={this.state.modalAlert.color}
                title={this.state.modalAlert.title}
                message={this.state.modalAlert.message}
                modal={this.state.openAlert}
                toggle={() => {
                  //this.onToggleModal();
                  this.setState({ openAlert: false });
                }}
                onOk={() => {
                  this.onOkModal();
                }}
              />
            </CardBody>
          </Card>
        </Col>
      </Col>
    );
  }
}

//export default withTranslation('common')(DefaultTabsBorderedTop);
export default reduxForm({
  form: "clinic_history_form", // a unique identifier for this form
})(withTranslation("common")(DefaultTabsBorderedTop));
